// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-focus-brown50:focus {
  background: #d67f6b !important;
}

.bg-hover-brown50:hover {
  background: #d67f6b !important;
}

.fg-brown50 {
  color: #d67f6b;
}
.fg-brown50 .nav-tabs > li.active > a {
  color: #d67f6b;
}

.fg-tab-active-brown50 .nav-tabs > li.active > a {
  color: #d67f6b !important;
}

.fg-focus-brown50:focus {
  color: #d67f6b;
}

.fg-hover-brown50:hover {
  color: #d67f6b;
}

.border-brown50 {
  border-color: #d67f6b !important;
}
.border-brown50 .rubix-timeline-body > ul {
  border-color: #d67f6b;
}
.border-brown50.rubix-timeline-view:before {
  border-color: #d67f6b;
}

.border-hover-brown50:hover {
  border-color: #d67f6b !important;
}

.border-focus-brown50:focus {
  border-color: #d67f6b !important;
}

.tl-brown50 .rubix-timeline-body > ul > li:before {
  border-color: #d67f6b;
}

.list-bg-brown50 > .list-group-item.active {
  background: #d67f6b !important;
  color: white !important;
}

.list-fg-brown50 > .list-group-item {
  color: #d67f6b;
}

.btn-brownishgreen {
  background: #948266;
  color: white;
  border-color: #948266;
}
.btn-brownishgreen.btn-outlined {
  color: #948266;
  background: none;
}
.btn-brownishgreen.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brownishgreen.btn-outlined.btn-onlyOnHover:hover,
.btn-brownishgreen.btn-outlined.btn-onlyOnHover:focus,
.btn-brownishgreen.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brownishgreen.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brownishgreen.btn-outlined.btn-inverse:hover,
.btn-brownishgreen.btn-outlined.btn-inverse:focus,
.btn-brownishgreen.btn-outlined.btn-inverse.active {
  color: #948266;
  background: white;
}
.btn-brownishgreen.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brownishgreen.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brownishgreen.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #948266;
  color: white;
  border-color: #948266;
}
.btn-brownishgreen.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brownishgreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brownishgreen.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #5e5241;
  border-color: #393228;
}
.btn-brownishgreen:focus,
.btn-brownishgreen.focus,
.btn-brownishgreen:hover,
.btn-brownishgreen.active {
  color: white;
  background: #aa9b83;
  border-color: #aa9b83;
}
.btn-brownishgreen:active,
.btn-brownishgreen.active,
.btn-brownishgreen[aria-expanded="true"],
.btn-brownishgreen.active:hover,
.btn-brownishgreen.active:focus,
.btn-brownishgreen[aria-expanded="true"]:hover,
.btn-brownishgreen[aria-expanded="true"]:focus,
.open > .btn-brownishgreen.dropdown-toggle {
  color: white;
  background: #5e5241;
  border-color: #393228;
  background-image: none;
}
.btn-brownishgreen.dropdown-toggle + ul li.active a {
  color: white;
  background: #948266;
}
.btn-brownishgreen.disabled,
.btn-brownishgreen[disabled],
fieldset[disabled] .btn-brownishgreen {
  pointer-events: none;
}
.btn-brownishgreen .badge {
  color: #948266;
  background-color: #948266;
}

.menu-brownishgreen ul li.active a,
.menu-brownishgreen ul li.active a:hover {
  color: white;
  background: #948266 !important;
}

.nav-brownishgreen > li.active > a,
.nav-brownishgreen > rubix-menu > li.active > a,
.nav-brownishgreen > rubix-nav-item > li.active > a {
  color: white;
  background: #948266;
  border-color: #948266;
}

.tab-brownishgreen {
  border-color: #948266;
}
.tab-brownishgreen > li.active > a {
  border-color: #948266;
  border-bottom-color: transparent;
}
.tab-brownishgreen.nav-pills > li.active > a {
  background: #948266;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brownishgreen > li.active > a {
  border: 1px solid #948266;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-brownishgreen > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brownishgreen {
  background: #948266 !important;
}
.bg-brownishgreen table td,
.bg-brownishgreen th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brownishgreen:focus {
  background: #948266 !important;
}

.bg-hover-brownishgreen:hover {
  background: #948266 !important;
}

.fg-brownishgreen {
  color: #948266;
}
.fg-brownishgreen .nav-tabs > li.active > a {
  color: #948266;
}

.fg-tab-active-brownishgreen .nav-tabs > li.active > a {
  color: #948266 !important;
}

.fg-focus-brownishgreen:focus {
  color: #948266;
}

.fg-hover-brownishgreen:hover {
  color: #948266;
}

.border-brownishgreen {
  border-color: #948266 !important;
}
.border-brownishgreen .rubix-timeline-body > ul {
  border-color: #948266;
}
.border-brownishgreen.rubix-timeline-view:before {
  border-color: #948266;
}

.border-hover-brownishgreen:hover {
  border-color: #948266 !important;
}

.border-focus-brownishgreen:focus {
  border-color: #948266 !important;
}

.tl-brownishgreen .rubix-timeline-body > ul > li:before {
  border-color: #948266;
}

.list-bg-brownishgreen > .list-group-item.active {
  background: #948266 !important;
  color: white !important;
}

.list-fg-brownishgreen > .list-group-item {
  color: #948266;
}

.btn-orange {
  background: #ffc497;
  color: white;
  border-color: #ffc497;
}
.btn-orange.btn-outlined {
  color: #ffc497;
  background: none;
}
.btn-orange.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-orange.btn-outlined.btn-onlyOnHover:hover,
.btn-orange.btn-outlined.btn-onlyOnHover:focus,
.btn-orange.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-orange.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-orange.btn-outlined.btn-inverse:hover,
.btn-orange.btn-outlined.btn-inverse:focus,
.btn-orange.btn-outlined.btn-inverse.active {
  color: #ffc497;
  background: white;
}
.btn-orange.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-orange.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-orange.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ffc497;
  color: white;
  border-color: #ffc497;
}
.btn-orange.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-orange.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-orange.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #ff903b;
  border-color: #fd6d00;
}
.btn-orange:focus,
.btn-orange.focus,
.btn-orange:hover,
.btn-orange.active {
  color: white;
  background: #ffe1ca;
  border-color: #ffe1ca;
}
.btn-orange:active,
.btn-orange.active,
.btn-orange[aria-expanded="true"],
.btn-orange.active:hover,
.btn-orange.active:focus,
.btn-orange[aria-expanded="true"]:hover,
.btn-orange[aria-expanded="true"]:focus,
.open > .btn-orange.dropdown-toggle {
  color: white;
  background: #ff903b;
  border-color: #fd6d00;
  background-image: none;
}
.btn-orange.dropdown-toggle + ul li.active a {
  color: white;
  background: #ffc497;
}
.btn-orange.disabled,
.btn-orange[disabled],
fieldset[disabled] .btn-orange {
  pointer-events: none;
}
.btn-orange .badge {
  color: #ffc497;
  background-color: #ffc497;
}

.menu-orange ul li.active a,
.menu-orange ul li.active a:hover {
  color: white;
  background: #ffc497 !important;
}

.nav-orange > li.active > a,
.nav-orange > rubix-menu > li.active > a,
.nav-orange > rubix-nav-item > li.active > a {
  color: white;
  background: #ffc497;
  border-color: #ffc497;
}

.tab-orange {
  border-color: #ffc497;
}
.tab-orange > li.active > a {
  border-color: #ffc497;
  border-bottom-color: transparent;
}
.tab-orange.nav-pills > li.active > a {
  background: #ffc497;
  color: white;
}

.rubix-panel-header.nav-inline .nav-orange > li.active > a {
  border: 1px solid #ffc497;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-orange > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-orange {
  background: #ffc497 !important;
}
.bg-orange table td,
.bg-orange th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-orange:focus {
  background: #ffc497 !important;
}

.bg-hover-orange:hover {
  background: #ffc497 !important;
}

.fg-orange {
  color: #ffc497;
}
.fg-orange .nav-tabs > li.active > a {
  color: #ffc497;
}

.fg-tab-active-orange .nav-tabs > li.active > a {
  color: #ffc497 !important;
}

.fg-focus-orange:focus {
  color: #ffc497;
}

.fg-hover-orange:hover {
  color: #ffc497;
}

.border-orange {
  border-color: #ffc497 !important;
}
.border-orange .rubix-timeline-body > ul {
  border-color: #ffc497;
}
.border-orange.rubix-timeline-view:before {
  border-color: #ffc497;
}

.border-hover-orange:hover {
  border-color: #ffc497 !important;
}

.border-focus-orange:focus {
  border-color: #ffc497 !important;
}

.tl-orange .rubix-timeline-body > ul > li:before {
  border-color: #ffc497;
}

.list-bg-orange > .list-group-item.active {
  background: #ffc497 !important;
  color: white !important;
}

.list-fg-orange > .list-group-item {
  color: #ffc497;
}

.btn-paleorange {
  background: #ea8564;
  color: white;
  border-color: #ea8564;
}
.btn-paleorange.btn-outlined {
  color: #ea8564;
  background: none;
}
.btn-paleorange.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-paleorange.btn-outlined.btn-onlyOnHover:hover,
.btn-paleorange.btn-outlined.btn-onlyOnHover:focus,
.btn-paleorange.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-paleorange.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-paleorange.btn-outlined.btn-inverse:hover,
.btn-paleorange.btn-outlined.btn-inverse:focus,
.btn-paleorange.btn-outlined.btn-inverse.active {
  color: #ea8564;
  background: white;
}
.btn-paleorange.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-paleorange.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-paleorange.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ea8564;
  color: white;
  border-color: #ea8564;
}
.btn-paleorange.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-paleorange.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-paleorange.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #d54a1d;
  border-color: #9f3816;
}
.btn-paleorange:focus,
.btn-paleorange.focus,
.btn-paleorange:hover,
.btn-paleorange.active {
  color: white;
  background: #f0a891;
  border-color: #f0a891;
}
.btn-paleorange:active,
.btn-paleorange.active,
.btn-paleorange[aria-expanded="true"],
.btn-paleorange.active:hover,
.btn-paleorange.active:focus,
.btn-paleorange[aria-expanded="true"]:hover,
.btn-paleorange[aria-expanded="true"]:focus,
.open > .btn-paleorange.dropdown-toggle {
  color: white;
  background: #d54a1d;
  border-color: #9f3816;
  background-image: none;
}
.btn-paleorange.dropdown-toggle + ul li.active a {
  color: white;
  background: #ea8564;
}
.btn-paleorange.disabled,
.btn-paleorange[disabled],
fieldset[disabled] .btn-paleorange {
  pointer-events: none;
}
.btn-paleorange .badge {
  color: #ea8564;
  background-color: #ea8564;
}

.menu-paleorange ul li.active a,
.menu-paleorange ul li.active a:hover {
  color: white;
  background: #ea8564 !important;
}

.nav-paleorange > li.active > a,
.nav-paleorange > rubix-menu > li.active > a,
.nav-paleorange > rubix-nav-item > li.active > a {
  color: white;
  background: #ea8564;
  border-color: #ea8564;
}

.tab-paleorange {
  border-color: #ea8564;
}
.tab-paleorange > li.active > a {
  border-color: #ea8564;
  border-bottom-color: transparent;
}
.tab-paleorange.nav-pills > li.active > a {
  background: #ea8564;
  color: white;
}

.rubix-panel-header.nav-inline .nav-paleorange > li.active > a {
  border: 1px solid #ea8564;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-paleorange > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-paleorange {
  background: #ea8564 !important;
}
.bg-paleorange table td,
.bg-paleorange th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-paleorange:focus {
  background: #ea8564 !important;
}

.bg-hover-paleorange:hover {
  background: #ea8564 !important;
}

.fg-paleorange {
  color: #ea8564;
}
.fg-paleorange .nav-tabs > li.active > a {
  color: #ea8564;
}

.fg-tab-active-paleorange .nav-tabs > li.active > a {
  color: #ea8564 !important;
}

.fg-focus-paleorange:focus {
  color: #ea8564;
}

.fg-hover-paleorange:hover {
  color: #ea8564;
}

.border-paleorange {
  border-color: #ea8564 !important;
}
.border-paleorange .rubix-timeline-body > ul {
  border-color: #ea8564;
}
.border-paleorange.rubix-timeline-view:before {
  border-color: #ea8564;
}

.border-hover-paleorange:hover {
  border-color: #ea8564 !important;
}

.border-focus-paleorange:focus {
  border-color: #ea8564 !important;
}

.tl-paleorange .rubix-timeline-body > ul > li:before {
  border-color: #ea8564;
}

.list-bg-paleorange > .list-group-item.active {
  background: #ea8564 !important;
  color: white !important;
}

.list-fg-paleorange > .list-group-item {
  color: #ea8564;
}

.btn-pinkishred {
  background: #ef6b5d;
  color: white;
  border-color: #ef6b5d;
}
.btn-pinkishred.btn-outlined {
  color: #ef6b5d;
  background: none;
}
.btn-pinkishred.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-pinkishred.btn-outlined.btn-onlyOnHover:hover,
.btn-pinkishred.btn-outlined.btn-onlyOnHover:focus,
.btn-pinkishred.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-pinkishred.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-pinkishred.btn-outlined.btn-inverse:hover,
.btn-pinkishred.btn-outlined.btn-inverse:focus,
.btn-pinkishred.btn-outlined.btn-inverse.active {
  color: #ef6b5d;
  background: white;
}
.btn-pinkishred.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-pinkishred.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-pinkishred.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ef6b5d;
  color: white;
  border-color: #ef6b5d;
}
.btn-pinkishred.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-pinkishred.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-pinkishred.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #db2816;
  border-color: #a31e10;
}
.btn-pinkishred:focus,
.btn-pinkishred.focus,
.btn-pinkishred:hover,
.btn-pinkishred.active {
  color: white;
  background: #f4958b;
  border-color: #f4958b;
}
.btn-pinkishred:active,
.btn-pinkishred.active,
.btn-pinkishred[aria-expanded="true"],
.btn-pinkishred.active:hover,
.btn-pinkishred.active:focus,
.btn-pinkishred[aria-expanded="true"]:hover,
.btn-pinkishred[aria-expanded="true"]:focus,
.open > .btn-pinkishred.dropdown-toggle {
  color: white;
  background: #db2816;
  border-color: #a31e10;
  background-image: none;
}
.btn-pinkishred.dropdown-toggle + ul li.active a {
  color: white;
  background: #ef6b5d;
}
.btn-pinkishred.disabled,
.btn-pinkishred[disabled],
fieldset[disabled] .btn-pinkishred {
  pointer-events: none;
}
.btn-pinkishred .badge {
  color: #ef6b5d;
  background-color: #ef6b5d;
}

.menu-pinkishred ul li.active a,
.menu-pinkishred ul li.active a:hover {
  color: white;
  background: #ef6b5d !important;
}

.nav-pinkishred > li.active > a,
.nav-pinkishred > rubix-menu > li.active > a,
.nav-pinkishred > rubix-nav-item > li.active > a {
  color: white;
  background: #ef6b5d;
  border-color: #ef6b5d;
}

.tab-pinkishred {
  border-color: #ef6b5d;
}
.tab-pinkishred > li.active > a {
  border-color: #ef6b5d;
  border-bottom-color: transparent;
}
.tab-pinkishred.nav-pills > li.active > a {
  background: #ef6b5d;
  color: white;
}

.rubix-panel-header.nav-inline .nav-pinkishred > li.active > a {
  border: 1px solid #ef6b5d;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-pinkishred > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-custome-red {
  background: #f12f39 !important;
}
.vbg-panel-header {
  height: 15px !important;
}

.bg-pinkishred {
  background: #ef6b5d !important;
}
.bg-pinkishred table td,
.bg-pinkishred th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-pinkishred:focus {
  background: #ef6b5d !important;
}

.bg-hover-pinkishred:hover {
  background: #ef6b5d !important;
}

.fg-pinkishred {
  color: #ef6b5d;
}
.fg-pinkishred .nav-tabs > li.active > a {
  color: #ef6b5d;
}

.fg-tab-active-pinkishred .nav-tabs > li.active > a {
  color: #ef6b5d !important;
}

.fg-focus-pinkishred:focus {
  color: #ef6b5d;
}

.fg-hover-pinkishred:hover {
  color: #ef6b5d;
}

.border-pinkishred {
  border-color: #ef6b5d !important;
}
.border-pinkishred .rubix-timeline-body > ul {
  border-color: #ef6b5d;
}
.border-pinkishred.rubix-timeline-view:before {
  border-color: #ef6b5d;
}

.border-hover-pinkishred:hover {
  border-color: #ef6b5d !important;
}

.border-focus-pinkishred:focus {
  border-color: #ef6b5d !important;
}

.tl-pinkishred .rubix-timeline-body > ul > li:before {
  border-color: #ef6b5d;
}

.list-bg-pinkishred > .list-group-item.active {
  background: #ef6b5d !important;
  color: white !important;
}

.list-fg-pinkishred > .list-group-item {
  color: #ef6b5d;
}

.btn-orange75 {
  background: #ee682f;
  color: white;
  border-color: #ee682f;
}
.btn-orange75.btn-outlined {
  color: #ee682f;
  background: none;
}
.btn-orange75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-orange75.btn-outlined.btn-onlyOnHover:hover,
.btn-orange75.btn-outlined.btn-onlyOnHover:focus,
.btn-orange75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-orange75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-orange75.btn-outlined.btn-inverse:hover,
.btn-orange75.btn-outlined.btn-inverse:focus,
.btn-orange75.btn-outlined.btn-inverse.active {
  color: #ee682f;
  background: white;
}
.btn-orange75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-orange75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-orange75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ee682f;
  color: white;
  border-color: #ee682f;
}
.btn-orange75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-orange75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-orange75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #b3400f;
  border-color: #7a2b0a;
}
.btn-orange75:focus,
.btn-orange75.focus,
.btn-orange75:hover,
.btn-orange75.active {
  color: white;
  background: #f28a5e;
  border-color: #f28a5e;
}
.btn-orange75:active,
.btn-orange75.active,
.btn-orange75[aria-expanded="true"],
.btn-orange75.active:hover,
.btn-orange75.active:focus,
.btn-orange75[aria-expanded="true"]:hover,
.btn-orange75[aria-expanded="true"]:focus,
.open > .btn-orange75.dropdown-toggle {
  color: white;
  background: #b3400f;
  border-color: #7a2b0a;
  background-image: none;
}
.btn-orange75.dropdown-toggle + ul li.active a {
  color: white;
  background: #ee682f;
}
.btn-orange75.disabled,
.btn-orange75[disabled],
fieldset[disabled] .btn-orange75 {
  pointer-events: none;
}
.btn-orange75 .badge {
  color: #ee682f;
  background-color: #ee682f;
}

.menu-orange75 ul li.active a,
.menu-orange75 ul li.active a:hover {
  color: white;
  background: #ee682f !important;
}

.nav-orange75 > li.active > a,
.nav-orange75 > rubix-menu > li.active > a,
.nav-orange75 > rubix-nav-item > li.active > a {
  color: white;
  background: #ee682f;
  border-color: #ee682f;
}

.tab-orange75 {
  border-color: #ee682f;
}
.tab-orange75 > li.active > a {
  border-color: #ee682f;
  border-bottom-color: transparent;
}
.tab-orange75.nav-pills > li.active > a {
  background: #ee682f;
  color: white;
}

.rubix-panel-header.nav-inline .nav-orange75 > li.active > a {
  border: 1px solid #ee682f;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-orange75 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-orange75 {
  background: #ee682f !important;
}
.bg-orange75 table td,
.bg-orange75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-orange75:focus {
  background: #ee682f !important;
}

.bg-hover-orange75:hover {
  background: #ee682f !important;
}

.fg-orange75 {
  color: #ee682f;
}
.fg-orange75 .nav-tabs > li.active > a {
  color: #ee682f;
}

.fg-tab-active-orange75 .nav-tabs > li.active > a {
  color: #ee682f !important;
}

.fg-focus-orange75:focus {
  color: #ee682f;
}

.fg-hover-orange75:hover {
  color: #ee682f;
}

.border-orange75 {
  border-color: #ee682f !important;
}
.border-orange75 .rubix-timeline-body > ul {
  border-color: #ee682f;
}
.border-orange75.rubix-timeline-view:before {
  border-color: #ee682f;
}

.border-hover-orange75:hover {
  border-color: #ee682f !important;
}

.border-focus-orange75:focus {
  border-color: #ee682f !important;
}

.tl-orange75 .rubix-timeline-body > ul > li:before {
  border-color: #ee682f;
}

.list-bg-orange75 > .list-group-item.active {
  background: #ee682f !important;
  color: white !important;
}

.list-fg-orange75 > .list-group-item {
  color: #ee682f;
}

.btn-orange65 {
  background: #fa824f;
  color: white;
  border-color: #fa824f;
}
.btn-orange65.btn-outlined {
  color: #fa824f;
  background: none;
}
.btn-orange65.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-orange65.btn-outlined.btn-onlyOnHover:hover,
.btn-orange65.btn-outlined.btn-onlyOnHover:focus,
.btn-orange65.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-orange65.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-orange65.btn-outlined.btn-inverse:hover,
.btn-orange65.btn-outlined.btn-inverse:focus,
.btn-orange65.btn-outlined.btn-inverse.active {
  color: #fa824f;
  background: white;
}
.btn-orange65.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-orange65.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-orange65.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #fa824f;
  color: white;
  border-color: #fa824f;
}
.btn-orange65.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-orange65.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-orange65.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #e74907;
  border-color: #ab3605;
}
.btn-orange65:focus,
.btn-orange65.focus,
.btn-orange65:hover,
.btn-orange65.active {
  color: white;
  background: #fba581;
  border-color: #fba581;
}
.btn-orange65:active,
.btn-orange65.active,
.btn-orange65[aria-expanded="true"],
.btn-orange65.active:hover,
.btn-orange65.active:focus,
.btn-orange65[aria-expanded="true"]:hover,
.btn-orange65[aria-expanded="true"]:focus,
.open > .btn-orange65.dropdown-toggle {
  color: white;
  background: #e74907;
  border-color: #ab3605;
  background-image: none;
}
.btn-orange65.dropdown-toggle + ul li.active a {
  color: white;
  background: #fa824f;
}
.btn-orange65.disabled,
.btn-orange65[disabled],
fieldset[disabled] .btn-orange65 {
  pointer-events: none;
}
.btn-orange65 .badge {
  color: #fa824f;
  background-color: #fa824f;
}

.menu-orange65 ul li.active a,
.menu-orange65 ul li.active a:hover {
  color: white;
  background: #fa824f !important;
}

.nav-orange65 > li.active > a,
.nav-orange65 > rubix-menu > li.active > a,
.nav-orange65 > rubix-nav-item > li.active > a {
  color: white;
  background: #fa824f;
  border-color: #fa824f;
}

.tab-orange65 {
  border-color: #fa824f;
}
.tab-orange65 > li.active > a {
  border-color: #fa824f;
  border-bottom-color: transparent;
}
.tab-orange65.nav-pills > li.active > a {
  background: #fa824f;
  color: white;
}

.rubix-panel-header.nav-inline .nav-orange65 > li.active > a {
  border: 1px solid #fa824f;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-orange65 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-orange65 {
  background: #fa824f !important;
}
.bg-orange65 table td,
.bg-orange65 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-orange65:focus {
  background: #fa824f !important;
}

.bg-hover-orange65:hover {
  background: #fa824f !important;
}

.fg-orange65 {
  color: #fa824f;
}
.fg-orange65 .nav-tabs > li.active > a {
  color: #fa824f;
}

.fg-tab-active-orange65 .nav-tabs > li.active > a {
  color: #fa824f !important;
}

.fg-focus-orange65:focus {
  color: #fa824f;
}

.fg-hover-orange65:hover {
  color: #fa824f;
}

.border-orange65 {
  border-color: #fa824f !important;
}
.border-orange65 .rubix-timeline-body > ul {
  border-color: #fa824f;
}
.border-orange65.rubix-timeline-view:before {
  border-color: #fa824f;
}

.border-hover-orange65:hover {
  border-color: #fa824f !important;
}

.border-focus-orange65:focus {
  border-color: #fa824f !important;
}

.tl-orange65 .rubix-timeline-body > ul > li:before {
  border-color: #fa824f;
}

.list-bg-orange65 > .list-group-item.active {
  background: #fa824f !important;
  color: white !important;
}

.list-fg-orange65 > .list-group-item {
  color: #fa824f;
}

.btn-orange45 {
  background: #ffc9a0;
  color: white;
  border-color: #ffc9a0;
}
.btn-orange45.btn-outlined {
  color: #ffc9a0;
  background: none;
}
.btn-orange45.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-orange45.btn-outlined.btn-onlyOnHover:hover,
.btn-orange45.btn-outlined.btn-onlyOnHover:focus,
.btn-orange45.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-orange45.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-orange45.btn-outlined.btn-inverse:hover,
.btn-orange45.btn-outlined.btn-inverse:focus,
.btn-orange45.btn-outlined.btn-inverse.active {
  color: #ffc9a0;
  background: white;
}
.btn-orange45.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-orange45.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-orange45.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ffc9a0;
  color: white;
  border-color: #ffc9a0;
}
.btn-orange45.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-orange45.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-orange45.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #ff9544;
  border-color: #ff7207;
}
.btn-orange45:focus,
.btn-orange45.focus,
.btn-orange45:hover,
.btn-orange45.active {
  color: white;
  background: #ffe6d3;
  border-color: #ffe6d3;
}
.btn-orange45:active,
.btn-orange45.active,
.btn-orange45[aria-expanded="true"],
.btn-orange45.active:hover,
.btn-orange45.active:focus,
.btn-orange45[aria-expanded="true"]:hover,
.btn-orange45[aria-expanded="true"]:focus,
.open > .btn-orange45.dropdown-toggle {
  color: white;
  background: #ff9544;
  border-color: #ff7207;
  background-image: none;
}
.btn-orange45.dropdown-toggle + ul li.active a {
  color: white;
  background: #ffc9a0;
}
.btn-orange45.disabled,
.btn-orange45[disabled],
fieldset[disabled] .btn-orange45 {
  pointer-events: none;
}
.btn-orange45 .badge {
  color: #ffc9a0;
  background-color: #ffc9a0;
}

.menu-orange45 ul li.active a,
.menu-orange45 ul li.active a:hover {
  color: white;
  background: #ffc9a0 !important;
}

.nav-orange45 > li.active > a,
.nav-orange45 > rubix-menu > li.active > a,
.nav-orange45 > rubix-nav-item > li.active > a {
  color: white;
  background: #ffc9a0;
  border-color: #ffc9a0;
}

.tab-orange45 {
  border-color: #ffc9a0;
}
.tab-orange45 > li.active > a {
  border-color: #ffc9a0;
  border-bottom-color: transparent;
}
.tab-orange45.nav-pills > li.active > a {
  background: #ffc9a0;
  color: white;
}

.rubix-panel-header.nav-inline .nav-orange45 > li.active > a {
  border: 1px solid #ffc9a0;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-orange45 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-orange45 {
  background: #ffc9a0 !important;
}
.bg-orange45 table td,
.bg-orange45 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-orange45:focus {
  background: #ffc9a0 !important;
}

.bg-hover-orange45:hover {
  background: #ffc9a0 !important;
}

.fg-orange45 {
  color: #ffc9a0;
}
.fg-orange45 .nav-tabs > li.active > a {
  color: #ffc9a0;
}

.fg-tab-active-orange45 .nav-tabs > li.active > a {
  color: #ffc9a0 !important;
}

.fg-focus-orange45:focus {
  color: #ffc9a0;
}

.fg-hover-orange45:hover {
  color: #ffc9a0;
}

.border-orange45 {
  border-color: #ffc9a0 !important;
}
.border-orange45 .rubix-timeline-body > ul {
  border-color: #ffc9a0;
}
.border-orange45.rubix-timeline-view:before {
  border-color: #ffc9a0;
}

.border-hover-orange45:hover {
  border-color: #ffc9a0 !important;
}

.border-focus-orange45:focus {
  border-color: #ffc9a0 !important;
}

.tl-orange45 .rubix-timeline-body > ul > li:before {
  border-color: #ffc9a0;
}

.list-bg-orange45 > .list-group-item.active {
  background: #ffc9a0 !important;
  color: white !important;
}

.list-fg-orange45 > .list-group-item {
  color: #ffc9a0;
}

.btn-darkorange {
  background: #eba068;
  color: white;
  border-color: #eba068;
}
.btn-darkorange.btn-outlined {
  color: #eba068;
  background: none;
}
.btn-darkorange.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkorange.btn-outlined.btn-onlyOnHover:hover,
.btn-darkorange.btn-outlined.btn-onlyOnHover:focus,
.btn-darkorange.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkorange.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkorange.btn-outlined.btn-inverse:hover,
.btn-darkorange.btn-outlined.btn-inverse:focus,
.btn-darkorange.btn-outlined.btn-inverse.active {
  color: #eba068;
  background: white;
}
.btn-darkorange.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkorange.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkorange.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #eba068;
  color: white;
  border-color: #eba068;
}
.btn-darkorange.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkorange.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkorange.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #da6e1d;
  border-color: #a45316;
}
.btn-darkorange:focus,
.btn-darkorange.focus,
.btn-darkorange:hover,
.btn-darkorange.active {
  color: white;
  background: #f1bc95;
  border-color: #f1bc95;
}
.btn-darkorange:active,
.btn-darkorange.active,
.btn-darkorange[aria-expanded="true"],
.btn-darkorange.active:hover,
.btn-darkorange.active:focus,
.btn-darkorange[aria-expanded="true"]:hover,
.btn-darkorange[aria-expanded="true"]:focus,
.open > .btn-darkorange.dropdown-toggle {
  color: white;
  background: #da6e1d;
  border-color: #a45316;
  background-image: none;
}
.btn-darkorange.dropdown-toggle + ul li.active a {
  color: white;
  background: #eba068;
}
.btn-darkorange.disabled,
.btn-darkorange[disabled],
fieldset[disabled] .btn-darkorange {
  pointer-events: none;
}
.btn-darkorange .badge {
  color: #eba068;
  background-color: #eba068;
}

.menu-darkorange ul li.active a,
.menu-darkorange ul li.active a:hover {
  color: white;
  background: #eba068 !important;
}

.nav-darkorange > li.active > a,
.nav-darkorange > rubix-menu > li.active > a,
.nav-darkorange > rubix-nav-item > li.active > a {
  color: white;
  background: #eba068;
  border-color: #eba068;
}

.tab-darkorange {
  border-color: #eba068;
}
.tab-darkorange > li.active > a {
  border-color: #eba068;
  border-bottom-color: transparent;
}
.tab-darkorange.nav-pills > li.active > a {
  background: #eba068;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkorange > li.active > a {
  border: 1px solid #eba068;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkorange > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkorange {
  background: #eba068 !important;
}
.bg-darkorange table td,
.bg-darkorange th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkorange:focus {
  background: #eba068 !important;
}

.bg-hover-darkorange:hover {
  background: #eba068 !important;
}

.fg-darkorange {
  color: #eba068;
}
.fg-darkorange .nav-tabs > li.active > a {
  color: #eba068;
}

.fg-tab-active-darkorange .nav-tabs > li.active > a {
  color: #eba068 !important;
}

.fg-focus-darkorange:focus {
  color: #eba068;
}

.fg-hover-darkorange:hover {
  color: #eba068;
}

.border-darkorange {
  border-color: #eba068 !important;
}
.border-darkorange .rubix-timeline-body > ul {
  border-color: #eba068;
}
.border-darkorange.rubix-timeline-view:before {
  border-color: #eba068;
}

.border-hover-darkorange:hover {
  border-color: #eba068 !important;
}

.border-focus-darkorange:focus {
  border-color: #eba068 !important;
}

.tl-darkorange .rubix-timeline-body > ul > li:before {
  border-color: #eba068;
}

.list-bg-darkorange > .list-group-item.active {
  background: #eba068 !important;
  color: white !important;
}

.list-fg-darkorange > .list-group-item {
  color: #eba068;
}

.btn-lightorange {
  background: #ffd3b1;
  color: white;
  border-color: #ffd3b1;
}
.btn-lightorange.btn-outlined {
  color: #ffd3b1;
  background: none;
}
.btn-lightorange.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightorange.btn-outlined.btn-onlyOnHover:hover,
.btn-lightorange.btn-outlined.btn-onlyOnHover:focus,
.btn-lightorange.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightorange.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightorange.btn-outlined.btn-inverse:hover,
.btn-lightorange.btn-outlined.btn-inverse:focus,
.btn-lightorange.btn-outlined.btn-inverse.active {
  color: #ffd3b1;
  background: white;
}
.btn-lightorange.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightorange.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightorange.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ffd3b1;
  color: white;
  border-color: #ffd3b1;
}
.btn-lightorange.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightorange.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightorange.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #ff9f55;
  border-color: #ff7d18;
}
.btn-lightorange:focus,
.btn-lightorange.focus,
.btn-lightorange:hover,
.btn-lightorange.active {
  color: white;
  background: #fff0e4;
  border-color: #fff0e4;
}
.btn-lightorange:active,
.btn-lightorange.active,
.btn-lightorange[aria-expanded="true"],
.btn-lightorange.active:hover,
.btn-lightorange.active:focus,
.btn-lightorange[aria-expanded="true"]:hover,
.btn-lightorange[aria-expanded="true"]:focus,
.open > .btn-lightorange.dropdown-toggle {
  color: white;
  background: #ff9f55;
  border-color: #ff7d18;
  background-image: none;
}
.btn-lightorange.dropdown-toggle + ul li.active a {
  color: white;
  background: #ffd3b1;
}
.btn-lightorange.disabled,
.btn-lightorange[disabled],
fieldset[disabled] .btn-lightorange {
  pointer-events: none;
}
.btn-lightorange .badge {
  color: #ffd3b1;
  background-color: #ffd3b1;
}

.menu-lightorange ul li.active a,
.menu-lightorange ul li.active a:hover {
  color: white;
  background: #ffd3b1 !important;
}

.nav-lightorange > li.active > a,
.nav-lightorange > rubix-menu > li.active > a,
.nav-lightorange > rubix-nav-item > li.active > a {
  color: white;
  background: #ffd3b1;
  border-color: #ffd3b1;
}

.tab-lightorange {
  border-color: #ffd3b1;
}
.tab-lightorange > li.active > a {
  border-color: #ffd3b1;
  border-bottom-color: transparent;
}
.tab-lightorange.nav-pills > li.active > a {
  background: #ffd3b1;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightorange > li.active > a {
  border: 1px solid #ffd3b1;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightorange > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightorange {
  background: #ffd3b1 !important;
}
.bg-lightorange table td,
.bg-lightorange th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightorange:focus {
  background: #ffd3b1 !important;
}

.bg-hover-lightorange:hover {
  background: #ffd3b1 !important;
}

.fg-lightorange {
  color: #ffd3b1;
}
.fg-lightorange .nav-tabs > li.active > a {
  color: #ffd3b1;
}

.fg-tab-active-lightorange .nav-tabs > li.active > a {
  color: #ffd3b1 !important;
}

.fg-focus-lightorange:focus {
  color: #ffd3b1;
}

.fg-hover-lightorange:hover {
  color: #ffd3b1;
}

.border-lightorange {
  border-color: #ffd3b1 !important;
}
.border-lightorange .rubix-timeline-body > ul {
  border-color: #ffd3b1;
}
.border-lightorange.rubix-timeline-view:before {
  border-color: #ffd3b1;
}

.border-hover-lightorange:hover {
  border-color: #ffd3b1 !important;
}

.border-focus-lightorange:focus {
  border-color: #ffd3b1 !important;
}

.tl-lightorange .rubix-timeline-body > ul > li:before {
  border-color: #ffd3b1;
}

.list-bg-lightorange > .list-group-item.active {
  background: #ffd3b1 !important;
  color: white !important;
}

.list-fg-lightorange > .list-group-item {
  color: #ffd3b1;
}

.btn-darkgreen {
  background: #306c67;
  color: white;
  border-color: #306c67;
}
.btn-darkgreen.btn-outlined {
  color: #306c67;
  background: none;
}
.btn-darkgreen.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgreen.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgreen.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgreen.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgreen.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgreen.btn-outlined.btn-inverse:hover,
.btn-darkgreen.btn-outlined.btn-inverse:focus,
.btn-darkgreen.btn-outlined.btn-inverse.active {
  color: #306c67;
  background: white;
}
.btn-darkgreen.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgreen.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgreen.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #306c67;
  color: white;
  border-color: #306c67;
}
.btn-darkgreen.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgreen.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #142c2a;
  border-color: #010202;
}
.btn-darkgreen:focus,
.btn-darkgreen.focus,
.btn-darkgreen:hover,
.btn-darkgreen.active {
  color: white;
  background: #408f89;
  border-color: #408f89;
}
.btn-darkgreen:active,
.btn-darkgreen.active,
.btn-darkgreen[aria-expanded="true"],
.btn-darkgreen.active:hover,
.btn-darkgreen.active:focus,
.btn-darkgreen[aria-expanded="true"]:hover,
.btn-darkgreen[aria-expanded="true"]:focus,
.open > .btn-darkgreen.dropdown-toggle {
  color: white;
  background: #142c2a;
  border-color: #010202;
  background-image: none;
}
.btn-darkgreen.dropdown-toggle + ul li.active a {
  color: white;
  background: #306c67;
}
.btn-darkgreen.disabled,
.btn-darkgreen[disabled],
fieldset[disabled] .btn-darkgreen {
  pointer-events: none;
}
.btn-darkgreen .badge {
  color: #306c67;
  background-color: #306c67;
}

.menu-darkgreen ul li.active a,
.menu-darkgreen ul li.active a:hover {
  color: white;
  background: #306c67 !important;
}

.nav-darkgreen > li.active > a,
.nav-darkgreen > rubix-menu > li.active > a,
.nav-darkgreen > rubix-nav-item > li.active > a {
  color: white;
  background: #306c67;
  border-color: #306c67;
}

.tab-darkgreen {
  border-color: #306c67;
}
.tab-darkgreen > li.active > a {
  border-color: #306c67;
  border-bottom-color: transparent;
}
.tab-darkgreen.nav-pills > li.active > a {
  background: #306c67;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgreen > li.active > a {
  border: 1px solid #306c67;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgreen > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgreen {
  background: #306c67 !important;
}
.bg-darkgreen table td,
.bg-darkgreen th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgreen:focus {
  background: #306c67 !important;
}

.bg-hover-darkgreen:hover {
  background: #306c67 !important;
}

.fg-darkgreen {
  color: #306c67;
}
.fg-darkgreen .nav-tabs > li.active > a {
  color: #306c67;
}

.fg-tab-active-darkgreen .nav-tabs > li.active > a {
  color: #306c67 !important;
}

.fg-focus-darkgreen:focus {
  color: #306c67;
}

.fg-hover-darkgreen:hover {
  color: #306c67;
}

.border-darkgreen {
  border-color: #306c67 !important;
}
.border-darkgreen .rubix-timeline-body > ul {
  border-color: #306c67;
}
.border-darkgreen.rubix-timeline-view:before {
  border-color: #306c67;
}

.border-hover-darkgreen:hover {
  border-color: #306c67 !important;
}

.border-focus-darkgreen:focus {
  border-color: #306c67 !important;
}

.tl-darkgreen .rubix-timeline-body > ul > li:before {
  border-color: #306c67;
}

.list-bg-darkgreen > .list-group-item.active {
  background: #306c67 !important;
  color: white !important;
}

.list-fg-darkgreen > .list-group-item {
  color: #306c67;
}

.btn-darkgreen85 {
  background: #36845e;
  color: white;
  border-color: #36845e;
}
.btn-darkgreen85.btn-outlined {
  color: #36845e;
  background: none;
}
.btn-darkgreen85.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgreen85.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgreen85.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgreen85.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgreen85.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgreen85.btn-outlined.btn-inverse:hover,
.btn-darkgreen85.btn-outlined.btn-inverse:focus,
.btn-darkgreen85.btn-outlined.btn-inverse.active {
  color: #36845e;
  background: white;
}
.btn-darkgreen85.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgreen85.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgreen85.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #36845e;
  color: white;
  border-color: #36845e;
}
.btn-darkgreen85.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgreen85.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgreen85.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #1b4330;
  border-color: #0a1711;
}
.btn-darkgreen85:focus,
.btn-darkgreen85.focus,
.btn-darkgreen85:hover,
.btn-darkgreen85.active {
  color: white;
  background: #45a878;
  border-color: #45a878;
}
.btn-darkgreen85:active,
.btn-darkgreen85.active,
.btn-darkgreen85[aria-expanded="true"],
.btn-darkgreen85.active:hover,
.btn-darkgreen85.active:focus,
.btn-darkgreen85[aria-expanded="true"]:hover,
.btn-darkgreen85[aria-expanded="true"]:focus,
.open > .btn-darkgreen85.dropdown-toggle {
  color: white;
  background: #1b4330;
  border-color: #0a1711;
  background-image: none;
}
.btn-darkgreen85.dropdown-toggle + ul li.active a {
  color: white;
  background: #36845e;
}
.btn-darkgreen85.disabled,
.btn-darkgreen85[disabled],
fieldset[disabled] .btn-darkgreen85 {
  pointer-events: none;
}
.btn-darkgreen85 .badge {
  color: #36845e;
  background-color: #36845e;
}

.menu-darkgreen85 ul li.active a,
.menu-darkgreen85 ul li.active a:hover {
  color: white;
  background: #36845e !important;
}

.nav-darkgreen85 > li.active > a,
.nav-darkgreen85 > rubix-menu > li.active > a,
.nav-darkgreen85 > rubix-nav-item > li.active > a {
  color: white;
  background: #36845e;
  border-color: #36845e;
}

.tab-darkgreen85 {
  border-color: #36845e;
}
.tab-darkgreen85 > li.active > a {
  border-color: #36845e;
  border-bottom-color: transparent;
}
.tab-darkgreen85.nav-pills > li.active > a {
  background: #36845e;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgreen85 > li.active > a {
  border: 1px solid #36845e;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgreen85 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgreen85 {
  background: #36845e !important;
}
.bg-darkgreen85 table td,
.bg-darkgreen85 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgreen85:focus {
  background: #36845e !important;
}

.bg-hover-darkgreen85:hover {
  background: #36845e !important;
}

.fg-darkgreen85 {
  color: #36845e;
}
.fg-darkgreen85 .nav-tabs > li.active > a {
  color: #36845e;
}

.fg-tab-active-darkgreen85 .nav-tabs > li.active > a {
  color: #36845e !important;
}

.fg-focus-darkgreen85:focus {
  color: #36845e;
}

.fg-hover-darkgreen85:hover {
  color: #36845e;
}

.border-darkgreen85 {
  border-color: #36845e !important;
}
.border-darkgreen85 .rubix-timeline-body > ul {
  border-color: #36845e;
}
.border-darkgreen85.rubix-timeline-view:before {
  border-color: #36845e;
}

.border-hover-darkgreen85:hover {
  border-color: #36845e !important;
}

.border-focus-darkgreen85:focus {
  border-color: #36845e !important;
}

.tl-darkgreen85 .rubix-timeline-body > ul > li:before {
  border-color: #36845e;
}

.list-bg-darkgreen85 > .list-group-item.active {
  background: #36845e !important;
  color: white !important;
}

.list-fg-darkgreen85 > .list-group-item {
  color: #36845e;
}

.btn-darkgreen75 {
  background: #518f41;
  color: white;
  border-color: #518f41;
}
.btn-darkgreen75.btn-outlined {
  color: #518f41;
  background: none;
}
.btn-darkgreen75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgreen75.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgreen75.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgreen75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgreen75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgreen75.btn-outlined.btn-inverse:hover,
.btn-darkgreen75.btn-outlined.btn-inverse:focus,
.btn-darkgreen75.btn-outlined.btn-inverse.active {
  color: #518f41;
  background: white;
}
.btn-darkgreen75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgreen75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgreen75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #518f41;
  color: white;
  border-color: #518f41;
}
.btn-darkgreen75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgreen75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgreen75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #2d5024;
  border-color: #152611;
}
.btn-darkgreen75:focus,
.btn-darkgreen75.focus,
.btn-darkgreen75:hover,
.btn-darkgreen75.active {
  color: white;
  background: #66b152;
  border-color: #66b152;
}
.btn-darkgreen75:active,
.btn-darkgreen75.active,
.btn-darkgreen75[aria-expanded="true"],
.btn-darkgreen75.active:hover,
.btn-darkgreen75.active:focus,
.btn-darkgreen75[aria-expanded="true"]:hover,
.btn-darkgreen75[aria-expanded="true"]:focus,
.open > .btn-darkgreen75.dropdown-toggle {
  color: white;
  background: #2d5024;
  border-color: #152611;
  background-image: none;
}
.btn-darkgreen75.dropdown-toggle + ul li.active a {
  color: white;
  background: #518f41;
}
.btn-darkgreen75.disabled,
.btn-darkgreen75[disabled],
fieldset[disabled] .btn-darkgreen75 {
  pointer-events: none;
}
.btn-darkgreen75 .badge {
  color: #518f41;
  background-color: #518f41;
}

.menu-darkgreen75 ul li.active a,
.menu-darkgreen75 ul li.active a:hover {
  color: white;
  background: #518f41 !important;
}

.nav-darkgreen75 > li.active > a,
.nav-darkgreen75 > rubix-menu > li.active > a,
.nav-darkgreen75 > rubix-nav-item > li.active > a {
  color: white;
  background: #518f41;
  border-color: #518f41;
}

.tab-darkgreen75 {
  border-color: #518f41;
}
.tab-darkgreen75 > li.active > a {
  border-color: #518f41;
  border-bottom-color: transparent;
}
.tab-darkgreen75.nav-pills > li.active > a {
  background: #518f41;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgreen75 > li.active > a {
  border: 1px solid #518f41;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgreen75 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgreen75 {
  background: #518f41 !important;
}
.bg-darkgreen75 table td,
.bg-darkgreen75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgreen75:focus {
  background: #518f41 !important;
}

.bg-hover-darkgreen75:hover {
  background: #518f41 !important;
}

.fg-darkgreen75 {
  color: #518f41;
}
.fg-darkgreen75 .nav-tabs > li.active > a {
  color: #518f41;
}

.fg-tab-active-darkgreen75 .nav-tabs > li.active > a {
  color: #518f41 !important;
}

.fg-focus-darkgreen75:focus {
  color: #518f41;
}

.fg-hover-darkgreen75:hover {
  color: #518f41;
}

.border-darkgreen75 {
  border-color: #518f41 !important;
}
.border-darkgreen75 .rubix-timeline-body > ul {
  border-color: #518f41;
}
.border-darkgreen75.rubix-timeline-view:before {
  border-color: #518f41;
}

.border-hover-darkgreen75:hover {
  border-color: #518f41 !important;
}

.border-focus-darkgreen75:focus {
  border-color: #518f41 !important;
}

.tl-darkgreen75 .rubix-timeline-body > ul > li:before {
  border-color: #518f41;
}

.list-bg-darkgreen75 > .list-group-item.active {
  background: #518f41 !important;
  color: white !important;
}

.list-fg-darkgreen75 > .list-group-item {
  color: #518f41;
}

.btn-darkgreen65 {
  background: #66a655;
  color: white;
  border-color: #66a655;
}
.btn-darkgreen65.btn-outlined {
  color: #66a655;
  background: none;
}
.btn-darkgreen65.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgreen65.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgreen65.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgreen65.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgreen65.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgreen65.btn-outlined.btn-inverse:hover,
.btn-darkgreen65.btn-outlined.btn-inverse:focus,
.btn-darkgreen65.btn-outlined.btn-inverse.active {
  color: #66a655;
  background: white;
}
.btn-darkgreen65.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgreen65.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgreen65.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #66a655;
  color: white;
  border-color: #66a655;
}
.btn-darkgreen65.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgreen65.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgreen65.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #416936;
  border-color: #284121;
}
.btn-darkgreen65:focus,
.btn-darkgreen65.focus,
.btn-darkgreen65:hover,
.btn-darkgreen65.active {
  color: white;
  background: #84b975;
  border-color: #84b975;
}
.btn-darkgreen65:active,
.btn-darkgreen65.active,
.btn-darkgreen65[aria-expanded="true"],
.btn-darkgreen65.active:hover,
.btn-darkgreen65.active:focus,
.btn-darkgreen65[aria-expanded="true"]:hover,
.btn-darkgreen65[aria-expanded="true"]:focus,
.open > .btn-darkgreen65.dropdown-toggle {
  color: white;
  background: #416936;
  border-color: #284121;
  background-image: none;
}
.btn-darkgreen65.dropdown-toggle + ul li.active a {
  color: white;
  background: #66a655;
}
.btn-darkgreen65.disabled,
.btn-darkgreen65[disabled],
fieldset[disabled] .btn-darkgreen65 {
  pointer-events: none;
}
.btn-darkgreen65 .badge {
  color: #66a655;
  background-color: #66a655;
}

.menu-darkgreen65 ul li.active a,
.menu-darkgreen65 ul li.active a:hover {
  color: white;
  background: #66a655 !important;
}

.nav-darkgreen65 > li.active > a,
.nav-darkgreen65 > rubix-menu > li.active > a,
.nav-darkgreen65 > rubix-nav-item > li.active > a {
  color: white;
  background: #66a655;
  border-color: #66a655;
}

.tab-darkgreen65 {
  border-color: #66a655;
}
.tab-darkgreen65 > li.active > a {
  border-color: #66a655;
  border-bottom-color: transparent;
}
.tab-darkgreen65.nav-pills > li.active > a {
  background: #66a655;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgreen65 > li.active > a {
  border: 1px solid #66a655;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgreen65 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgreen65 {
  background: #66a655 !important;
}
.bg-darkgreen65 table td,
.bg-darkgreen65 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgreen65:focus {
  background: #66a655 !important;
}

.bg-hover-darkgreen65:hover {
  background: #66a655 !important;
}

.fg-darkgreen65 {
  color: #66a655;
}
.fg-darkgreen65 .nav-tabs > li.active > a {
  color: #66a655;
}

.fg-tab-active-darkgreen65 .nav-tabs > li.active > a {
  color: #66a655 !important;
}

.fg-focus-darkgreen65:focus {
  color: #66a655;
}

.fg-hover-darkgreen65:hover {
  color: #66a655;
}

.border-darkgreen65 {
  border-color: #66a655 !important;
}
.border-darkgreen65 .rubix-timeline-body > ul {
  border-color: #66a655;
}
.border-darkgreen65.rubix-timeline-view:before {
  border-color: #66a655;
}

.border-hover-darkgreen65:hover {
  border-color: #66a655 !important;
}

.border-focus-darkgreen65:focus {
  border-color: #66a655 !important;
}

.tl-darkgreen65 .rubix-timeline-body > ul > li:before {
  border-color: #66a655;
}

.list-bg-darkgreen65 > .list-group-item.active {
  background: #66a655 !important;
  color: white !important;
}

.list-fg-darkgreen65 > .list-group-item {
  color: #66a655;
}

.btn-darkgreen55 {
  background: #68bd80;
  color: white;
  border-color: #68bd80;
}
.btn-darkgreen55.btn-outlined {
  color: #68bd80;
  background: none;
}
.btn-darkgreen55.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgreen55.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgreen55.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgreen55.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgreen55.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgreen55.btn-outlined.btn-inverse:hover,
.btn-darkgreen55.btn-outlined.btn-inverse:focus,
.btn-darkgreen55.btn-outlined.btn-inverse.active {
  color: #68bd80;
  background: white;
}
.btn-darkgreen55.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgreen55.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgreen55.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #68bd80;
  color: white;
  border-color: #68bd80;
}
.btn-darkgreen55.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgreen55.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgreen55.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #3d8c53;
  border-color: #2b613a;
}
.btn-darkgreen55:focus,
.btn-darkgreen55.focus,
.btn-darkgreen55:hover,
.btn-darkgreen55.active {
  color: white;
  background: #8bcd9e;
  border-color: #8bcd9e;
}
.btn-darkgreen55:active,
.btn-darkgreen55.active,
.btn-darkgreen55[aria-expanded="true"],
.btn-darkgreen55.active:hover,
.btn-darkgreen55.active:focus,
.btn-darkgreen55[aria-expanded="true"]:hover,
.btn-darkgreen55[aria-expanded="true"]:focus,
.open > .btn-darkgreen55.dropdown-toggle {
  color: white;
  background: #3d8c53;
  border-color: #2b613a;
  background-image: none;
}
.btn-darkgreen55.dropdown-toggle + ul li.active a {
  color: white;
  background: #68bd80;
}
.btn-darkgreen55.disabled,
.btn-darkgreen55[disabled],
fieldset[disabled] .btn-darkgreen55 {
  pointer-events: none;
}
.btn-darkgreen55 .badge {
  color: #68bd80;
  background-color: #68bd80;
}

.menu-darkgreen55 ul li.active a,
.menu-darkgreen55 ul li.active a:hover {
  color: white;
  background: #68bd80 !important;
}

.nav-darkgreen55 > li.active > a,
.nav-darkgreen55 > rubix-menu > li.active > a,
.nav-darkgreen55 > rubix-nav-item > li.active > a {
  color: white;
  background: #68bd80;
  border-color: #68bd80;
}

.tab-darkgreen55 {
  border-color: #68bd80;
}
.tab-darkgreen55 > li.active > a {
  border-color: #68bd80;
  border-bottom-color: transparent;
}
.tab-darkgreen55.nav-pills > li.active > a {
  background: #68bd80;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgreen55 > li.active > a {
  border: 1px solid #68bd80;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgreen55 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgreen55 {
  background: #68bd80 !important;
}
.bg-darkgreen55 table td,
.bg-darkgreen55 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgreen55:focus {
  background: #68bd80 !important;
}

.bg-hover-darkgreen55:hover {
  background: #68bd80 !important;
}

.fg-darkgreen55 {
  color: #68bd80;
}
.fg-darkgreen55 .nav-tabs > li.active > a {
  color: #68bd80;
}

.fg-tab-active-darkgreen55 .nav-tabs > li.active > a {
  color: #68bd80 !important;
}

.fg-focus-darkgreen55:focus {
  color: #68bd80;
}

.fg-hover-darkgreen55:hover {
  color: #68bd80;
}

.border-darkgreen55 {
  border-color: #68bd80 !important;
}
.border-darkgreen55 .rubix-timeline-body > ul {
  border-color: #68bd80;
}
.border-darkgreen55.rubix-timeline-view:before {
  border-color: #68bd80;
}

.border-hover-darkgreen55:hover {
  border-color: #68bd80 !important;
}

.border-focus-darkgreen55:focus {
  border-color: #68bd80 !important;
}

.tl-darkgreen55 .rubix-timeline-body > ul > li:before {
  border-color: #68bd80;
}

.list-bg-darkgreen55 > .list-group-item.active {
  background: #68bd80 !important;
  color: white !important;
}

.list-fg-darkgreen55 > .list-group-item {
  color: #68bd80;
}

.btn-darkgreen50 {
  background: #55a69f;
  color: white;
  border-color: #55a69f;
}
.btn-darkgreen50.btn-outlined {
  color: #55a69f;
  background: none;
}
.btn-darkgreen50.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgreen50.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgreen50.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgreen50.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgreen50.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgreen50.btn-outlined.btn-inverse:hover,
.btn-darkgreen50.btn-outlined.btn-inverse:focus,
.btn-darkgreen50.btn-outlined.btn-inverse.active {
  color: #55a69f;
  background: white;
}
.btn-darkgreen50.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgreen50.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgreen50.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #55a69f;
  color: white;
  border-color: #55a69f;
}
.btn-darkgreen50.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgreen50.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgreen50.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #366965;
  border-color: #21413e;
}
.btn-darkgreen50:focus,
.btn-darkgreen50.focus,
.btn-darkgreen50:hover,
.btn-darkgreen50.active {
  color: white;
  background: #75b9b3;
  border-color: #75b9b3;
}
.btn-darkgreen50:active,
.btn-darkgreen50.active,
.btn-darkgreen50[aria-expanded="true"],
.btn-darkgreen50.active:hover,
.btn-darkgreen50.active:focus,
.btn-darkgreen50[aria-expanded="true"]:hover,
.btn-darkgreen50[aria-expanded="true"]:focus,
.open > .btn-darkgreen50.dropdown-toggle {
  color: white;
  background: #366965;
  border-color: #21413e;
  background-image: none;
}
.btn-darkgreen50.dropdown-toggle + ul li.active a {
  color: white;
  background: #55a69f;
}
.btn-darkgreen50.disabled,
.btn-darkgreen50[disabled],
fieldset[disabled] .btn-darkgreen50 {
  pointer-events: none;
}
.btn-darkgreen50 .badge {
  color: #55a69f;
  background-color: #55a69f;
}

.menu-darkgreen50 ul li.active a,
.menu-darkgreen50 ul li.active a:hover {
  color: white;
  background: #55a69f !important;
}

.nav-darkgreen50 > li.active > a,
.nav-darkgreen50 > rubix-menu > li.active > a,
.nav-darkgreen50 > rubix-nav-item > li.active > a {
  color: white;
  background: #55a69f;
  border-color: #55a69f;
}

.tab-darkgreen50 {
  border-color: #55a69f;
}
.tab-darkgreen50 > li.active > a {
  border-color: #55a69f;
  border-bottom-color: transparent;
}
.tab-darkgreen50.nav-pills > li.active > a {
  background: #55a69f;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgreen50 > li.active > a {
  border: 1px solid #55a69f;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgreen50 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgreen50 {
  background: #55a69f !important;
}
.bg-darkgreen50 table td,
.bg-darkgreen50 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgreen50:focus {
  background: #55a69f !important;
}

.bg-hover-darkgreen50:hover {
  background: #55a69f !important;
}

.fg-darkgreen50 {
  color: #55a69f;
}
.fg-darkgreen50 .nav-tabs > li.active > a {
  color: #55a69f;
}

.fg-tab-active-darkgreen50 .nav-tabs > li.active > a {
  color: #55a69f !important;
}

.fg-focus-darkgreen50:focus {
  color: #55a69f;
}

.fg-hover-darkgreen50:hover {
  color: #55a69f;
}

.border-darkgreen50 {
  border-color: #55a69f !important;
}
.border-darkgreen50 .rubix-timeline-body > ul {
  border-color: #55a69f;
}
.border-darkgreen50.rubix-timeline-view:before {
  border-color: #55a69f;
}

.border-hover-darkgreen50:hover {
  border-color: #55a69f !important;
}

.border-focus-darkgreen50:focus {
  border-color: #55a69f !important;
}

.tl-darkgreen50 .rubix-timeline-body > ul > li:before {
  border-color: #55a69f;
}

.list-bg-darkgreen50 > .list-group-item.active {
  background: #55a69f !important;
  color: white !important;
}

.list-fg-darkgreen50 > .list-group-item {
  color: #55a69f;
}

.btn-darkgreen45 {
  background: #2eb398;
  color: white;
  border-color: #2eb398;
}
.btn-darkgreen45.btn-outlined {
  color: #2eb398;
  background: none;
}
.btn-darkgreen45.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgreen45.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgreen45.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgreen45.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgreen45.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgreen45.btn-outlined.btn-inverse:hover,
.btn-darkgreen45.btn-outlined.btn-inverse:focus,
.btn-darkgreen45.btn-outlined.btn-inverse.active {
  color: #2eb398;
  background: white;
}
.btn-darkgreen45.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgreen45.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgreen45.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #2eb398;
  color: white;
  border-color: #2eb398;
}
.btn-darkgreen45.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgreen45.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgreen45.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #1b6a5a;
  border-color: #0f3931;
}
.btn-darkgreen45:focus,
.btn-darkgreen45.focus,
.btn-darkgreen45:hover,
.btn-darkgreen45.active {
  color: white;
  background: #45cfb3;
  border-color: #45cfb3;
}
.btn-darkgreen45:active,
.btn-darkgreen45.active,
.btn-darkgreen45[aria-expanded="true"],
.btn-darkgreen45.active:hover,
.btn-darkgreen45.active:focus,
.btn-darkgreen45[aria-expanded="true"]:hover,
.btn-darkgreen45[aria-expanded="true"]:focus,
.open > .btn-darkgreen45.dropdown-toggle {
  color: white;
  background: #1b6a5a;
  border-color: #0f3931;
  background-image: none;
}
.btn-darkgreen45.dropdown-toggle + ul li.active a {
  color: white;
  background: #2eb398;
}
.btn-darkgreen45.disabled,
.btn-darkgreen45[disabled],
fieldset[disabled] .btn-darkgreen45 {
  pointer-events: none;
}
.btn-darkgreen45 .badge {
  color: #2eb398;
  background-color: #2eb398;
}

.menu-darkgreen45 ul li.active a,
.menu-darkgreen45 ul li.active a:hover {
  color: white;
  background: #2eb398 !important;
}

.nav-darkgreen45 > li.active > a,
.nav-darkgreen45 > rubix-menu > li.active > a,
.nav-darkgreen45 > rubix-nav-item > li.active > a {
  color: white;
  background: #2eb398;
  border-color: #2eb398;
}

.tab-darkgreen45 {
  border-color: #2eb398;
}
.tab-darkgreen45 > li.active > a {
  border-color: #2eb398;
  border-bottom-color: transparent;
}
.tab-darkgreen45.nav-pills > li.active > a {
  background: #2eb398;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgreen45 > li.active > a {
  border: 1px solid #2eb398;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgreen45 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgreen45 {
  background: #2eb398 !important;
}
.bg-darkgreen45 table td,
.bg-darkgreen45 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgreen45:focus {
  background: #2eb398 !important;
}

.bg-hover-darkgreen45:hover {
  background: #2eb398 !important;
}

.fg-darkgreen45 {
  color: #2eb398;
}
.fg-darkgreen45 .nav-tabs > li.active > a {
  color: #2eb398;
}

.fg-tab-active-darkgreen45 .nav-tabs > li.active > a {
  color: #2eb398 !important;
}

.fg-focus-darkgreen45:focus {
  color: #2eb398;
}

.fg-hover-darkgreen45:hover {
  color: #2eb398;
}

.border-darkgreen45 {
  border-color: #2eb398 !important;
}
.border-darkgreen45 .rubix-timeline-body > ul {
  border-color: #2eb398;
}
.border-darkgreen45.rubix-timeline-view:before {
  border-color: #2eb398;
}

.border-hover-darkgreen45:hover {
  border-color: #2eb398 !important;
}

.border-focus-darkgreen45:focus {
  border-color: #2eb398 !important;
}

.tl-darkgreen45 .rubix-timeline-body > ul > li:before {
  border-color: #2eb398;
}

.list-bg-darkgreen45 > .list-group-item.active {
  background: #2eb398 !important;
  color: white !important;
}

.list-fg-darkgreen45 > .list-group-item {
  color: #2eb398;
}

.btn-darkgreen40 {
  background: #44c1ac;
  color: white;
  border-color: #44c1ac;
}
.btn-darkgreen40.btn-outlined {
  color: #44c1ac;
  background: none;
}
.btn-darkgreen40.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgreen40.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgreen40.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgreen40.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgreen40.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgreen40.btn-outlined.btn-inverse:hover,
.btn-darkgreen40.btn-outlined.btn-inverse:focus,
.btn-darkgreen40.btn-outlined.btn-inverse.active {
  color: #44c1ac;
  background: white;
}
.btn-darkgreen40.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgreen40.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgreen40.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #44c1ac;
  color: white;
  border-color: #44c1ac;
}
.btn-darkgreen40.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgreen40.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgreen40.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #2a7f71;
  border-color: #1b5148;
}
.btn-darkgreen40:focus,
.btn-darkgreen40.focus,
.btn-darkgreen40:hover,
.btn-darkgreen40.active {
  color: white;
  background: #6acebd;
  border-color: #6acebd;
}
.btn-darkgreen40:active,
.btn-darkgreen40.active,
.btn-darkgreen40[aria-expanded="true"],
.btn-darkgreen40.active:hover,
.btn-darkgreen40.active:focus,
.btn-darkgreen40[aria-expanded="true"]:hover,
.btn-darkgreen40[aria-expanded="true"]:focus,
.open > .btn-darkgreen40.dropdown-toggle {
  color: white;
  background: #2a7f71;
  border-color: #1b5148;
  background-image: none;
}
.btn-darkgreen40.dropdown-toggle + ul li.active a {
  color: white;
  background: #44c1ac;
}
.btn-darkgreen40.disabled,
.btn-darkgreen40[disabled],
fieldset[disabled] .btn-darkgreen40 {
  pointer-events: none;
}
.btn-darkgreen40 .badge {
  color: #44c1ac;
  background-color: #44c1ac;
}

.menu-darkgreen40 ul li.active a,
.menu-darkgreen40 ul li.active a:hover {
  color: white;
  background: #44c1ac !important;
}

.nav-darkgreen40 > li.active > a,
.nav-darkgreen40 > rubix-menu > li.active > a,
.nav-darkgreen40 > rubix-nav-item > li.active > a {
  color: white;
  background: #44c1ac;
  border-color: #44c1ac;
}

.tab-darkgreen40 {
  border-color: #44c1ac;
}
.tab-darkgreen40 > li.active > a {
  border-color: #44c1ac;
  border-bottom-color: transparent;
}
.tab-darkgreen40.nav-pills > li.active > a {
  background: #44c1ac;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgreen40 > li.active > a {
  border: 1px solid #44c1ac;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgreen40 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgreen40 {
  background: #44c1ac !important;
}
.bg-darkgreen40 table td,
.bg-darkgreen40 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgreen40:focus {
  background: #44c1ac !important;
}

.bg-hover-darkgreen40:hover {
  background: #44c1ac !important;
}

.fg-darkgreen40 {
  color: #44c1ac;
}
.fg-darkgreen40 .nav-tabs > li.active > a {
  color: #44c1ac;
}

.fg-tab-active-darkgreen40 .nav-tabs > li.active > a {
  color: #44c1ac !important;
}

.fg-focus-darkgreen40:focus {
  color: #44c1ac;
}

.fg-hover-darkgreen40:hover {
  color: #44c1ac;
}

.border-darkgreen40 {
  border-color: #44c1ac !important;
}
.border-darkgreen40 .rubix-timeline-body > ul {
  border-color: #44c1ac;
}
.border-darkgreen40.rubix-timeline-view:before {
  border-color: #44c1ac;
}

.border-hover-darkgreen40:hover {
  border-color: #44c1ac !important;
}

.border-focus-darkgreen40:focus {
  border-color: #44c1ac !important;
}

.tl-darkgreen40 .rubix-timeline-body > ul > li:before {
  border-color: #44c1ac;
}

.list-bg-darkgreen40 > .list-group-item.active {
  background: #44c1ac !important;
  color: white !important;
}

.list-fg-darkgreen40 > .list-group-item {
  color: #44c1ac;
}

.btn-green {
  background: #55c9a6;
  color: white;
  border-color: #55c9a6;
}
.btn-green.btn-outlined {
  color: #55c9a6;
  background: none;
}
.btn-green.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-green.btn-outlined.btn-onlyOnHover:hover,
.btn-green.btn-outlined.btn-onlyOnHover:focus,
.btn-green.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-green.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-green.btn-outlined.btn-inverse:hover,
.btn-green.btn-outlined.btn-inverse:focus,
.btn-green.btn-outlined.btn-inverse.active {
  color: #55c9a6;
  background: white;
}
.btn-green.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-green.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-green.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #55c9a6;
  color: white;
  border-color: #55c9a6;
}
.btn-green.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-green.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-green.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #2f9375;
  border-color: #206550;
}
.btn-green:focus,
.btn-green.focus,
.btn-green:hover,
.btn-green.active {
  color: white;
  background: #7cd5ba;
  border-color: #7cd5ba;
}
.btn-green:active,
.btn-green.active,
.btn-green[aria-expanded="true"],
.btn-green.active:hover,
.btn-green.active:focus,
.btn-green[aria-expanded="true"]:hover,
.btn-green[aria-expanded="true"]:focus,
.open > .btn-green.dropdown-toggle {
  color: white;
  background: #2f9375;
  border-color: #206550;
  background-image: none;
}
.btn-green.dropdown-toggle + ul li.active a {
  color: white;
  background: #55c9a6;
}
.btn-green.disabled,
.btn-green[disabled],
fieldset[disabled] .btn-green {
  pointer-events: none;
}
.btn-green .badge {
  color: #55c9a6;
  background-color: #55c9a6;
}

.menu-green ul li.active a,
.menu-green ul li.active a:hover {
  color: white;
  background: #55c9a6 !important;
}

.nav-green > li.active > a,
.nav-green > rubix-menu > li.active > a,
.nav-green > rubix-nav-item > li.active > a {
  color: white;
  background: #55c9a6;
  border-color: #55c9a6;
}

.tab-green {
  border-color: #55c9a6;
}
.tab-green > li.active > a {
  border-color: #55c9a6;
  border-bottom-color: transparent;
}
.tab-green.nav-pills > li.active > a {
  background: #55c9a6;
  color: white;
}

.rubix-panel-header.nav-inline .nav-green > li.active > a {
  border: 1px solid #55c9a6;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-green > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-green {
  background: #55c9a6 !important;
}
.bg-green table td,
.bg-green th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-green:focus {
  background: #55c9a6 !important;
}

.bg-hover-green:hover {
  background: #55c9a6 !important;
}

.fg-green {
  color: #55c9a6;
}
.fg-green .nav-tabs > li.active > a {
  color: #55c9a6;
}

.fg-tab-active-green .nav-tabs > li.active > a {
  color: #55c9a6 !important;
}

.fg-focus-green:focus {
  color: #55c9a6;
}

.fg-hover-green:hover {
  color: #55c9a6;
}

.border-green {
  border-color: #55c9a6 !important;
}
.border-green .rubix-timeline-body > ul {
  border-color: #55c9a6;
}
.border-green.rubix-timeline-view:before {
  border-color: #55c9a6;
}

.border-hover-green:hover {
  border-color: #55c9a6 !important;
}

.border-focus-green:focus {
  border-color: #55c9a6 !important;
}

.tl-green .rubix-timeline-body > ul > li:before {
  border-color: #55c9a6;
}

.list-bg-green > .list-group-item.active {
  background: #55c9a6 !important;
  color: white !important;
}

.list-fg-green > .list-group-item {
  color: #55c9a6;
}

.btn-lightgreen {
  background: #7cd5ba;
  color: white;
  border-color: #7cd5ba;
}
.btn-lightgreen.btn-outlined {
  color: #7cd5ba;
  background: none;
}
.btn-lightgreen.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightgreen.btn-outlined.btn-onlyOnHover:hover,
.btn-lightgreen.btn-outlined.btn-onlyOnHover:focus,
.btn-lightgreen.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightgreen.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightgreen.btn-outlined.btn-inverse:hover,
.btn-lightgreen.btn-outlined.btn-inverse:focus,
.btn-lightgreen.btn-outlined.btn-inverse.active {
  color: #7cd5ba;
  background: white;
}
.btn-lightgreen.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightgreen.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightgreen.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #7cd5ba;
  color: white;
  border-color: #7cd5ba;
}
.btn-lightgreen.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightgreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightgreen.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #3cba93;
  border-color: #2d8b6f;
}
.btn-lightgreen:focus,
.btn-lightgreen.focus,
.btn-lightgreen:hover,
.btn-lightgreen.active {
  color: white;
  background: #a3e1ce;
  border-color: #a3e1ce;
}
.btn-lightgreen:active,
.btn-lightgreen.active,
.btn-lightgreen[aria-expanded="true"],
.btn-lightgreen.active:hover,
.btn-lightgreen.active:focus,
.btn-lightgreen[aria-expanded="true"]:hover,
.btn-lightgreen[aria-expanded="true"]:focus,
.open > .btn-lightgreen.dropdown-toggle {
  color: white;
  background: #3cba93;
  border-color: #2d8b6f;
  background-image: none;
}
.btn-lightgreen.dropdown-toggle + ul li.active a {
  color: white;
  background: #7cd5ba;
}
.btn-lightgreen.disabled,
.btn-lightgreen[disabled],
fieldset[disabled] .btn-lightgreen {
  pointer-events: none;
}
.btn-lightgreen .badge {
  color: #7cd5ba;
  background-color: #7cd5ba;
}

.menu-lightgreen ul li.active a,
.menu-lightgreen ul li.active a:hover {
  color: white;
  background: #7cd5ba !important;
}

.nav-lightgreen > li.active > a,
.nav-lightgreen > rubix-menu > li.active > a,
.nav-lightgreen > rubix-nav-item > li.active > a {
  color: white;
  background: #7cd5ba;
  border-color: #7cd5ba;
}

.tab-lightgreen {
  border-color: #7cd5ba;
}
.tab-lightgreen > li.active > a {
  border-color: #7cd5ba;
  border-bottom-color: transparent;
}
.tab-lightgreen.nav-pills > li.active > a {
  background: #7cd5ba;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightgreen > li.active > a {
  border: 1px solid #7cd5ba;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightgreen > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightgreen {
  background: #7cd5ba !important;
}
.bg-lightgreen table td,
.bg-lightgreen th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightgreen:focus {
  background: #7cd5ba !important;
}

.bg-hover-lightgreen:hover {
  background: #7cd5ba !important;
}

.fg-lightgreen {
  color: #7cd5ba;
}
.fg-lightgreen .nav-tabs > li.active > a {
  color: #7cd5ba;
}

.fg-tab-active-lightgreen .nav-tabs > li.active > a {
  color: #7cd5ba !important;
}

.fg-focus-lightgreen:focus {
  color: #7cd5ba;
}

.fg-hover-lightgreen:hover {
  color: #7cd5ba;
}

.border-lightgreen {
  border-color: #7cd5ba !important;
}
.border-lightgreen .rubix-timeline-body > ul {
  border-color: #7cd5ba;
}
.border-lightgreen.rubix-timeline-view:before {
  border-color: #7cd5ba;
}

.border-hover-lightgreen:hover {
  border-color: #7cd5ba !important;
}

.border-focus-lightgreen:focus {
  border-color: #7cd5ba !important;
}

.tl-lightgreen .rubix-timeline-body > ul > li:before {
  border-color: #7cd5ba;
}

.list-bg-lightgreen > .list-group-item.active {
  background: #7cd5ba !important;
  color: white !important;
}

.list-fg-lightgreen > .list-group-item {
  color: #7cd5ba;
}

.btn-hovergreen {
  background: #e5f7f1;
  color: white;
  border-color: #e5f7f1;
}
.btn-hovergreen.btn-outlined {
  color: #e5f7f1;
  background: none;
}
.btn-hovergreen.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-hovergreen.btn-outlined.btn-onlyOnHover:hover,
.btn-hovergreen.btn-outlined.btn-onlyOnHover:focus,
.btn-hovergreen.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-hovergreen.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-hovergreen.btn-outlined.btn-inverse:hover,
.btn-hovergreen.btn-outlined.btn-inverse:focus,
.btn-hovergreen.btn-outlined.btn-inverse.active {
  color: #e5f7f1;
  background: white;
}
.btn-hovergreen.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-hovergreen.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-hovergreen.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #e5f7f1;
  color: white;
  border-color: #e5f7f1;
}
.btn-hovergreen.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-hovergreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-hovergreen.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #9fe1cb;
  border-color: #70d3b2;
}
.btn-hovergreen:focus,
.btn-hovergreen.focus,
.btn-hovergreen:hover,
.btn-hovergreen.active {
  color: white;
  background: white;
  border-color: white;
}
.btn-hovergreen:active,
.btn-hovergreen.active,
.btn-hovergreen[aria-expanded="true"],
.btn-hovergreen.active:hover,
.btn-hovergreen.active:focus,
.btn-hovergreen[aria-expanded="true"]:hover,
.btn-hovergreen[aria-expanded="true"]:focus,
.open > .btn-hovergreen.dropdown-toggle {
  color: white;
  background: #9fe1cb;
  border-color: #70d3b2;
  background-image: none;
}
.btn-hovergreen.dropdown-toggle + ul li.active a {
  color: white;
  background: #e5f7f1;
}
.btn-hovergreen.disabled,
.btn-hovergreen[disabled],
fieldset[disabled] .btn-hovergreen {
  pointer-events: none;
}
.btn-hovergreen .badge {
  color: #e5f7f1;
  background-color: #e5f7f1;
}

.menu-hovergreen ul li.active a,
.menu-hovergreen ul li.active a:hover {
  color: white;
  background: #e5f7f1 !important;
}

.nav-hovergreen > li.active > a,
.nav-hovergreen > rubix-menu > li.active > a,
.nav-hovergreen > rubix-nav-item > li.active > a {
  color: white;
  background: #e5f7f1;
  border-color: #e5f7f1;
}

.tab-hovergreen {
  border-color: #e5f7f1;
}
.tab-hovergreen > li.active > a {
  border-color: #e5f7f1;
  border-bottom-color: transparent;
}
.tab-hovergreen.nav-pills > li.active > a {
  background: #e5f7f1;
  color: white;
}

.rubix-panel-header.nav-inline .nav-hovergreen > li.active > a {
  border: 1px solid #e5f7f1;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-hovergreen > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-hovergreen {
  background: #e5f7f1 !important;
}
.bg-hovergreen table td,
.bg-hovergreen th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-hovergreen:focus {
  background: #e5f7f1 !important;
}

.bg-hover-hovergreen:hover {
  background: #e5f7f1 !important;
}

.fg-hovergreen {
  color: #e5f7f1;
}
.fg-hovergreen .nav-tabs > li.active > a {
  color: #e5f7f1;
}

.fg-tab-active-hovergreen .nav-tabs > li.active > a {
  color: #e5f7f1 !important;
}

.fg-focus-hovergreen:focus {
  color: #e5f7f1;
}

.fg-hover-hovergreen:hover {
  color: #e5f7f1;
}

.border-hovergreen {
  border-color: #e5f7f1 !important;
}
.border-hovergreen .rubix-timeline-body > ul {
  border-color: #e5f7f1;
}
.border-hovergreen.rubix-timeline-view:before {
  border-color: #e5f7f1;
}

.border-hover-hovergreen:hover {
  border-color: #e5f7f1 !important;
}

.border-focus-hovergreen:focus {
  border-color: #e5f7f1 !important;
}

.tl-hovergreen .rubix-timeline-body > ul > li:before {
  border-color: #e5f7f1;
}

.list-bg-hovergreen > .list-group-item.active {
  background: #e5f7f1 !important;
  color: white !important;
}

.list-fg-hovergreen > .list-group-item {
  color: #e5f7f1;
}

.btn-brightyellow {
  background: #fcb621;
  color: white;
  border-color: #fcb621;
}
.btn-brightyellow.btn-outlined {
  color: #fcb621;
  background: none;
}
.btn-brightyellow.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brightyellow.btn-outlined.btn-onlyOnHover:hover,
.btn-brightyellow.btn-outlined.btn-onlyOnHover:focus,
.btn-brightyellow.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brightyellow.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brightyellow.btn-outlined.btn-inverse:hover,
.btn-brightyellow.btn-outlined.btn-inverse:focus,
.btn-brightyellow.btn-outlined.btn-inverse.active {
  color: #fcb621;
  background: white;
}
.btn-brightyellow.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brightyellow.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brightyellow.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #fcb621;
  color: white;
  border-color: #fcb621;
}
.btn-brightyellow.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brightyellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brightyellow.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #bf8303;
  border-color: #825902;
}
.btn-brightyellow:focus,
.btn-brightyellow.focus,
.btn-brightyellow:hover,
.btn-brightyellow.active {
  color: white;
  background: #fdc753;
  border-color: #fdc753;
}
.btn-brightyellow:active,
.btn-brightyellow.active,
.btn-brightyellow[aria-expanded="true"],
.btn-brightyellow.active:hover,
.btn-brightyellow.active:focus,
.btn-brightyellow[aria-expanded="true"]:hover,
.btn-brightyellow[aria-expanded="true"]:focus,
.open > .btn-brightyellow.dropdown-toggle {
  color: white;
  background: #bf8303;
  border-color: #825902;
  background-image: none;
}
.btn-brightyellow.dropdown-toggle + ul li.active a {
  color: white;
  background: #fcb621;
}
.btn-brightyellow.disabled,
.btn-brightyellow[disabled],
fieldset[disabled] .btn-brightyellow {
  pointer-events: none;
}
.btn-brightyellow .badge {
  color: #fcb621;
  background-color: #fcb621;
}

.menu-brightyellow ul li.active a,
.menu-brightyellow ul li.active a:hover {
  color: white;
  background: #fcb621 !important;
}

.nav-brightyellow > li.active > a,
.nav-brightyellow > rubix-menu > li.active > a,
.nav-brightyellow > rubix-nav-item > li.active > a {
  color: white;
  background: #fcb621;
  border-color: #fcb621;
}

.tab-brightyellow {
  border-color: #fcb621;
}
.tab-brightyellow > li.active > a {
  border-color: #fcb621;
  border-bottom-color: transparent;
}
.tab-brightyellow.nav-pills > li.active > a {
  background: #fcb621;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brightyellow > li.active > a {
  border: 1px solid #fcb621;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-brightyellow > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brightyellow {
  background: #fcb621 !important;
}
.bg-brightyellow table td,
.bg-brightyellow th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brightyellow:focus {
  background: #fcb621 !important;
}

.bg-hover-brightyellow:hover {
  background: #fcb621 !important;
}

.fg-brightyellow {
  color: #fcb621;
}
.fg-brightyellow .nav-tabs > li.active > a {
  color: #fcb621;
}

.fg-tab-active-brightyellow .nav-tabs > li.active > a {
  color: #fcb621 !important;
}

.fg-focus-brightyellow:focus {
  color: #fcb621;
}

.fg-hover-brightyellow:hover {
  color: #fcb621;
}

.border-brightyellow {
  border-color: #fcb621 !important;
}
.border-brightyellow .rubix-timeline-body > ul {
  border-color: #fcb621;
}
.border-brightyellow.rubix-timeline-view:before {
  border-color: #fcb621;
}

.border-hover-brightyellow:hover {
  border-color: #fcb621 !important;
}

.border-focus-brightyellow:focus {
  border-color: #fcb621 !important;
}

.tl-brightyellow .rubix-timeline-body > ul > li:before {
  border-color: #fcb621;
}

.list-bg-brightyellow > .list-group-item.active {
  background: #fcb621 !important;
  color: white !important;
}

.list-fg-brightyellow > .list-group-item {
  color: #fcb621;
}

.btn-brightyellow75 {
  background: #f3c557;
  color: white;
  border-color: #f3c557;
}
.btn-brightyellow75.btn-outlined {
  color: #f3c557;
  background: none;
}
.btn-brightyellow75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brightyellow75.btn-outlined.btn-onlyOnHover:hover,
.btn-brightyellow75.btn-outlined.btn-onlyOnHover:focus,
.btn-brightyellow75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brightyellow75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brightyellow75.btn-outlined.btn-inverse:hover,
.btn-brightyellow75.btn-outlined.btn-inverse:focus,
.btn-brightyellow75.btn-outlined.btn-inverse.active {
  color: #f3c557;
  background: white;
}
.btn-brightyellow75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brightyellow75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brightyellow75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #f3c557;
  color: white;
  border-color: #f3c557;
}
.btn-brightyellow75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brightyellow75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brightyellow75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #dea110;
  border-color: #a5780c;
}
.btn-brightyellow75:focus,
.btn-brightyellow75.focus,
.btn-brightyellow75:hover,
.btn-brightyellow75.active {
  color: white;
  background: #f6d587;
  border-color: #f6d587;
}
.btn-brightyellow75:active,
.btn-brightyellow75.active,
.btn-brightyellow75[aria-expanded="true"],
.btn-brightyellow75.active:hover,
.btn-brightyellow75.active:focus,
.btn-brightyellow75[aria-expanded="true"]:hover,
.btn-brightyellow75[aria-expanded="true"]:focus,
.open > .btn-brightyellow75.dropdown-toggle {
  color: white;
  background: #dea110;
  border-color: #a5780c;
  background-image: none;
}
.btn-brightyellow75.dropdown-toggle + ul li.active a {
  color: white;
  background: #f3c557;
}
.btn-brightyellow75.disabled,
.btn-brightyellow75[disabled],
fieldset[disabled] .btn-brightyellow75 {
  pointer-events: none;
}
.btn-brightyellow75 .badge {
  color: #f3c557;
  background-color: #f3c557;
}

.menu-brightyellow75 ul li.active a,
.menu-brightyellow75 ul li.active a:hover {
  color: white;
  background: #f3c557 !important;
}

.nav-brightyellow75 > li.active > a,
.nav-brightyellow75 > rubix-menu > li.active > a,
.nav-brightyellow75 > rubix-nav-item > li.active > a {
  color: white;
  background: #f3c557;
  border-color: #f3c557;
}

.tab-brightyellow75 {
  border-color: #f3c557;
}
.tab-brightyellow75 > li.active > a {
  border-color: #f3c557;
  border-bottom-color: transparent;
}
.tab-brightyellow75.nav-pills > li.active > a {
  background: #f3c557;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brightyellow75 > li.active > a {
  border: 1px solid #f3c557;
  border-bottom: none;
}

.rubix-panel-header.nav-inline
  .nav-brightyellow75
  > li.open
  > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brightyellow75 {
  background: #f3c557 !important;
}
.bg-brightyellow75 table td,
.bg-brightyellow75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brightyellow75:focus {
  background: #f3c557 !important;
}

.bg-hover-brightyellow75:hover {
  background: #f3c557 !important;
}

.fg-brightyellow75 {
  color: #f3c557;
}
.fg-brightyellow75 .nav-tabs > li.active > a {
  color: #f3c557;
}

.fg-tab-active-brightyellow75 .nav-tabs > li.active > a {
  color: #f3c557 !important;
}

.fg-focus-brightyellow75:focus {
  color: #f3c557;
}

.fg-hover-brightyellow75:hover {
  color: #f3c557;
}

.border-brightyellow75 {
  border-color: #f3c557 !important;
}
.border-brightyellow75 .rubix-timeline-body > ul {
  border-color: #f3c557;
}
.border-brightyellow75.rubix-timeline-view:before {
  border-color: #f3c557;
}

.border-hover-brightyellow75:hover {
  border-color: #f3c557 !important;
}

.border-focus-brightyellow75:focus {
  border-color: #f3c557 !important;
}

.tl-brightyellow75 .rubix-timeline-body > ul > li:before {
  border-color: #f3c557;
}

.list-bg-brightyellow75 > .list-group-item.active {
  background: #f3c557 !important;
  color: white !important;
}

.list-fg-brightyellow75 > .list-group-item {
  color: #f3c557;
}

.btn-brightyellow65 {
  background: #edbc6c;
  color: white;
  border-color: #edbc6c;
}
.btn-brightyellow65.btn-outlined {
  color: #edbc6c;
  background: none;
}
.btn-brightyellow65.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brightyellow65.btn-outlined.btn-onlyOnHover:hover,
.btn-brightyellow65.btn-outlined.btn-onlyOnHover:focus,
.btn-brightyellow65.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brightyellow65.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brightyellow65.btn-outlined.btn-inverse:hover,
.btn-brightyellow65.btn-outlined.btn-inverse:focus,
.btn-brightyellow65.btn-outlined.btn-inverse.active {
  color: #edbc6c;
  background: white;
}
.btn-brightyellow65.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brightyellow65.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brightyellow65.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #edbc6c;
  color: white;
  border-color: #edbc6c;
}
.btn-brightyellow65.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brightyellow65.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brightyellow65.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #e2961c;
  border-color: #ab7215;
}
.btn-brightyellow65:focus,
.btn-brightyellow65.focus,
.btn-brightyellow65:hover,
.btn-brightyellow65.active {
  color: white;
  background: #f3d199;
  border-color: #f3d199;
}
.btn-brightyellow65:active,
.btn-brightyellow65.active,
.btn-brightyellow65[aria-expanded="true"],
.btn-brightyellow65.active:hover,
.btn-brightyellow65.active:focus,
.btn-brightyellow65[aria-expanded="true"]:hover,
.btn-brightyellow65[aria-expanded="true"]:focus,
.open > .btn-brightyellow65.dropdown-toggle {
  color: white;
  background: #e2961c;
  border-color: #ab7215;
  background-image: none;
}
.btn-brightyellow65.dropdown-toggle + ul li.active a {
  color: white;
  background: #edbc6c;
}
.btn-brightyellow65.disabled,
.btn-brightyellow65[disabled],
fieldset[disabled] .btn-brightyellow65 {
  pointer-events: none;
}
.btn-brightyellow65 .badge {
  color: #edbc6c;
  background-color: #edbc6c;
}

.menu-brightyellow65 ul li.active a,
.menu-brightyellow65 ul li.active a:hover {
  color: white;
  background: #edbc6c !important;
}

.nav-brightyellow65 > li.active > a,
.nav-brightyellow65 > rubix-menu > li.active > a,
.nav-brightyellow65 > rubix-nav-item > li.active > a {
  color: white;
  background: #edbc6c;
  border-color: #edbc6c;
}

.tab-brightyellow65 {
  border-color: #edbc6c;
}
.tab-brightyellow65 > li.active > a {
  border-color: #edbc6c;
  border-bottom-color: transparent;
}
.tab-brightyellow65.nav-pills > li.active > a {
  background: #edbc6c;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brightyellow65 > li.active > a {
  border: 1px solid #edbc6c;
  border-bottom: none;
}

.rubix-panel-header.nav-inline
  .nav-brightyellow65
  > li.open
  > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brightyellow65 {
  background: #edbc6c !important;
}
.bg-brightyellow65 table td,
.bg-brightyellow65 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brightyellow65:focus {
  background: #edbc6c !important;
}

.bg-hover-brightyellow65:hover {
  background: #edbc6c !important;
}

.fg-brightyellow65 {
  color: #edbc6c;
}
.fg-brightyellow65 .nav-tabs > li.active > a {
  color: #edbc6c;
}

.fg-tab-active-brightyellow65 .nav-tabs > li.active > a {
  color: #edbc6c !important;
}

.fg-focus-brightyellow65:focus {
  color: #edbc6c;
}

.fg-hover-brightyellow65:hover {
  color: #edbc6c;
}

.border-brightyellow65 {
  border-color: #edbc6c !important;
}
.border-brightyellow65 .rubix-timeline-body > ul {
  border-color: #edbc6c;
}
.border-brightyellow65.rubix-timeline-view:before {
  border-color: #edbc6c;
}

.border-hover-brightyellow65:hover {
  border-color: #edbc6c !important;
}

.border-focus-brightyellow65:focus {
  border-color: #edbc6c !important;
}

.tl-brightyellow65 .rubix-timeline-body > ul > li:before {
  border-color: #edbc6c;
}

.list-bg-brightyellow65 > .list-group-item.active {
  background: #edbc6c !important;
  color: white !important;
}

.list-fg-brightyellow65 > .list-group-item {
  color: #edbc6c;
}

.btn-yellow {
  background: #fadd7f;
  color: white;
  border-color: #fadd7f;
}
.btn-yellow.btn-outlined {
  color: #fadd7f;
  background: none;
}
.btn-yellow.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-yellow.btn-outlined.btn-onlyOnHover:hover,
.btn-yellow.btn-outlined.btn-onlyOnHover:focus,
.btn-yellow.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-yellow.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-yellow.btn-outlined.btn-inverse:hover,
.btn-yellow.btn-outlined.btn-inverse:focus,
.btn-yellow.btn-outlined.btn-inverse.active {
  color: #fadd7f;
  background: white;
}
.btn-yellow.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-yellow.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-yellow.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #fadd7f;
  color: white;
  border-color: #fadd7f;
}
.btn-yellow.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-yellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-yellow.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #f7c627;
  border-color: #d8a708;
}
.btn-yellow:focus,
.btn-yellow.focus,
.btn-yellow:hover,
.btn-yellow.active {
  color: white;
  background: #fceab0;
  border-color: #fceab0;
}
.btn-yellow:active,
.btn-yellow.active,
.btn-yellow[aria-expanded="true"],
.btn-yellow.active:hover,
.btn-yellow.active:focus,
.btn-yellow[aria-expanded="true"]:hover,
.btn-yellow[aria-expanded="true"]:focus,
.open > .btn-yellow.dropdown-toggle {
  color: white;
  background: #f7c627;
  border-color: #d8a708;
  background-image: none;
}
.btn-yellow.dropdown-toggle + ul li.active a {
  color: white;
  background: #fadd7f;
}
.btn-yellow.disabled,
.btn-yellow[disabled],
fieldset[disabled] .btn-yellow {
  pointer-events: none;
}
.btn-yellow .badge {
  color: #fadd7f;
  background-color: #fadd7f;
}

.menu-yellow ul li.active a,
.menu-yellow ul li.active a:hover {
  color: white;
  background: #fadd7f !important;
}

.nav-yellow > li.active > a,
.nav-yellow > rubix-menu > li.active > a,
.nav-yellow > rubix-nav-item > li.active > a {
  color: white;
  background: #fadd7f;
  border-color: #fadd7f;
}

.tab-yellow {
  border-color: #fadd7f;
}
.tab-yellow > li.active > a {
  border-color: #fadd7f;
  border-bottom-color: transparent;
}
.tab-yellow.nav-pills > li.active > a {
  background: #fadd7f;
  color: white;
}

.rubix-panel-header.nav-inline .nav-yellow > li.active > a {
  border: 1px solid #fadd7f;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-yellow > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-yellow {
  background: #f1c52b !important;
}
.bg-yellow table td,
.bg-yellow th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-yellow:focus {
  background: #fadd7f !important;
}

.bg-hover-yellow:hover {
  background: #fadd7f !important;
}

.fg-yellow {
  color: #fadd7f;
}
.fg-yellow .nav-tabs > li.active > a {
  color: #fadd7f;
}

.fg-tab-active-yellow .nav-tabs > li.active > a {
  color: #fadd7f !important;
}

.fg-focus-yellow:focus {
  color: #fadd7f;
}

.fg-hover-yellow:hover {
  color: #fadd7f;
}

.border-yellow {
  border-color: #fadd7f !important;
}
.border-yellow .rubix-timeline-body > ul {
  border-color: #fadd7f;
}
.border-yellow.rubix-timeline-view:before {
  border-color: #fadd7f;
}

.border-hover-yellow:hover {
  border-color: #fadd7f !important;
}

.border-focus-yellow:focus {
  border-color: #fadd7f !important;
}

.tl-yellow .rubix-timeline-body > ul > li:before {
  border-color: #fadd7f;
}

.list-bg-yellow > .list-group-item.active {
  background: #fadd7f !important;
  color: white !important;
}

.list-fg-yellow > .list-group-item {
  color: #fadd7f;
}

.btn-paleyellow {
  background: #debc85;
  color: white;
  border-color: #debc85;
}
.btn-paleyellow.btn-outlined {
  color: #debc85;
  background: none;
}
.btn-paleyellow.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-paleyellow.btn-outlined.btn-onlyOnHover:hover,
.btn-paleyellow.btn-outlined.btn-onlyOnHover:focus,
.btn-paleyellow.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-paleyellow.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-paleyellow.btn-outlined.btn-inverse:hover,
.btn-paleyellow.btn-outlined.btn-inverse:focus,
.btn-paleyellow.btn-outlined.btn-inverse.active {
  color: #debc85;
  background: white;
}
.btn-paleyellow.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-paleyellow.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-paleyellow.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #debc85;
  color: white;
  border-color: #debc85;
}
.btn-paleyellow.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-paleyellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-paleyellow.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #ca943d;
  border-color: #9f732b;
}
.btn-paleyellow:focus,
.btn-paleyellow.focus,
.btn-paleyellow:hover,
.btn-paleyellow.active {
  color: white;
  background: #e9d2ad;
  border-color: #e9d2ad;
}
.btn-paleyellow:active,
.btn-paleyellow.active,
.btn-paleyellow[aria-expanded="true"],
.btn-paleyellow.active:hover,
.btn-paleyellow.active:focus,
.btn-paleyellow[aria-expanded="true"]:hover,
.btn-paleyellow[aria-expanded="true"]:focus,
.open > .btn-paleyellow.dropdown-toggle {
  color: white;
  background: #ca943d;
  border-color: #9f732b;
  background-image: none;
}
.btn-paleyellow.dropdown-toggle + ul li.active a {
  color: white;
  background: #debc85;
}
.btn-paleyellow.disabled,
.btn-paleyellow[disabled],
fieldset[disabled] .btn-paleyellow {
  pointer-events: none;
}
.btn-paleyellow .badge {
  color: #debc85;
  background-color: #debc85;
}

.menu-paleyellow ul li.active a,
.menu-paleyellow ul li.active a:hover {
  color: white;
  background: #debc85 !important;
}

.nav-paleyellow > li.active > a,
.nav-paleyellow > rubix-menu > li.active > a,
.nav-paleyellow > rubix-nav-item > li.active > a {
  color: white;
  background: #debc85;
  border-color: #debc85;
}

.tab-paleyellow {
  border-color: #debc85;
}
.tab-paleyellow > li.active > a {
  border-color: #debc85;
  border-bottom-color: transparent;
}
.tab-paleyellow.nav-pills > li.active > a {
  background: #debc85;
  color: white;
}

.rubix-panel-header.nav-inline .nav-paleyellow > li.active > a {
  border: 1px solid #debc85;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-paleyellow > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-paleyellow {
  background: #debc85 !important;
}
.bg-paleyellow table td,
.bg-paleyellow th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-paleyellow:focus {
  background: #debc85 !important;
}

.bg-hover-paleyellow:hover {
  background: #debc85 !important;
}

.fg-paleyellow {
  color: #debc85;
}
.fg-paleyellow .nav-tabs > li.active > a {
  color: #debc85;
}

.fg-tab-active-paleyellow .nav-tabs > li.active > a {
  color: #debc85 !important;
}

.fg-focus-paleyellow:focus {
  color: #debc85;
}

.fg-hover-paleyellow:hover {
  color: #debc85;
}

.border-paleyellow {
  border-color: #debc85 !important;
}
.border-paleyellow .rubix-timeline-body > ul {
  border-color: #debc85;
}
.border-paleyellow.rubix-timeline-view:before {
  border-color: #debc85;
}

.border-hover-paleyellow:hover {
  border-color: #debc85 !important;
}

.border-focus-paleyellow:focus {
  border-color: #debc85 !important;
}

.tl-paleyellow .rubix-timeline-body > ul > li:before {
  border-color: #debc85;
}

.list-bg-paleyellow > .list-group-item.active {
  background: #debc85 !important;
  color: white !important;
}

.list-fg-paleyellow > .list-group-item {
  color: #debc85;
}

.btn-lightyellow {
  background: #fbe499;
  color: white;
  border-color: #fbe499;
}
.btn-lightyellow.btn-outlined {
  color: #fbe499;
  background: none;
}
.btn-lightyellow.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightyellow.btn-outlined.btn-onlyOnHover:hover,
.btn-lightyellow.btn-outlined.btn-onlyOnHover:focus,
.btn-lightyellow.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightyellow.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightyellow.btn-outlined.btn-inverse:hover,
.btn-lightyellow.btn-outlined.btn-inverse:focus,
.btn-lightyellow.btn-outlined.btn-inverse.active {
  color: #fbe499;
  background: white;
}
.btn-lightyellow.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightyellow.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightyellow.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #fbe499;
  color: white;
  border-color: #fbe499;
}
.btn-lightyellow.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightyellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightyellow.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #f8cd41;
  border-color: #f2bb09;
}
.btn-lightyellow:focus,
.btn-lightyellow.focus,
.btn-lightyellow:hover,
.btn-lightyellow.active {
  color: white;
  background: #fdf1ca;
  border-color: #fdf1ca;
}
.btn-lightyellow:active,
.btn-lightyellow.active,
.btn-lightyellow[aria-expanded="true"],
.btn-lightyellow.active:hover,
.btn-lightyellow.active:focus,
.btn-lightyellow[aria-expanded="true"]:hover,
.btn-lightyellow[aria-expanded="true"]:focus,
.open > .btn-lightyellow.dropdown-toggle {
  color: white;
  background: #f8cd41;
  border-color: #f2bb09;
  background-image: none;
}
.btn-lightyellow.dropdown-toggle + ul li.active a {
  color: white;
  background: #fbe499;
}
.btn-lightyellow.disabled,
.btn-lightyellow[disabled],
fieldset[disabled] .btn-lightyellow {
  pointer-events: none;
}
.btn-lightyellow .badge {
  color: #fbe499;
  background-color: #fbe499;
}

.menu-lightyellow ul li.active a,
.menu-lightyellow ul li.active a:hover {
  color: white;
  background: #fbe499 !important;
}

.nav-lightyellow > li.active > a,
.nav-lightyellow > rubix-menu > li.active > a,
.nav-lightyellow > rubix-nav-item > li.active > a {
  color: white;
  background: #fbe499;
  border-color: #fbe499;
}

.tab-lightyellow {
  border-color: #fbe499;
}
.tab-lightyellow > li.active > a {
  border-color: #fbe499;
  border-bottom-color: transparent;
}
.tab-lightyellow.nav-pills > li.active > a {
  background: #fbe499;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightyellow > li.active > a {
  border: 1px solid #fbe499;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightyellow > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightyellow {
  background: #fbe499 !important;
}
.bg-lightyellow table td,
.bg-lightyellow th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightyellow:focus {
  background: #fbe499 !important;
}

.bg-hover-lightyellow:hover {
  background: #fbe499 !important;
}

.fg-lightyellow {
  color: #fbe499;
}
.fg-lightyellow .nav-tabs > li.active > a {
  color: #fbe499;
}

.fg-tab-active-lightyellow .nav-tabs > li.active > a {
  color: #fbe499 !important;
}

.fg-focus-lightyellow:focus {
  color: #fbe499;
}

.fg-hover-lightyellow:hover {
  color: #fbe499;
}

.border-lightyellow {
  border-color: #fbe499 !important;
}
.border-lightyellow .rubix-timeline-body > ul {
  border-color: #fbe499;
}
.border-lightyellow.rubix-timeline-view:before {
  border-color: #fbe499;
}

.border-hover-lightyellow:hover {
  border-color: #fbe499 !important;
}

.border-focus-lightyellow:focus {
  border-color: #fbe499 !important;
}

.tl-lightyellow .rubix-timeline-body > ul > li:before {
  border-color: #fbe499;
}

.list-bg-lightyellow > .list-group-item.active {
  background: #fbe499 !important;
  color: white !important;
}

.list-fg-lightyellow > .list-group-item {
  color: #fbe499;
}

.btn-hoveryellow {
  background: #fff1e7;
  color: white;
  border-color: #fff1e7;
}
.btn-hoveryellow.btn-outlined {
  color: #fff1e7;
  background: none;
}
.btn-hoveryellow.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-hoveryellow.btn-outlined.btn-onlyOnHover:hover,
.btn-hoveryellow.btn-outlined.btn-onlyOnHover:focus,
.btn-hoveryellow.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-hoveryellow.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-hoveryellow.btn-outlined.btn-inverse:hover,
.btn-hoveryellow.btn-outlined.btn-inverse:focus,
.btn-hoveryellow.btn-outlined.btn-inverse.active {
  color: #fff1e7;
  background: white;
}
.btn-hoveryellow.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-hoveryellow.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-hoveryellow.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #fff1e7;
  color: white;
  border-color: #fff1e7;
}
.btn-hoveryellow.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-hoveryellow.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-hoveryellow.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #ffbb8b;
  border-color: #ff984e;
}
.btn-hoveryellow:focus,
.btn-hoveryellow.focus,
.btn-hoveryellow:hover,
.btn-hoveryellow.active {
  color: white;
  background: white;
  border-color: white;
}
.btn-hoveryellow:active,
.btn-hoveryellow.active,
.btn-hoveryellow[aria-expanded="true"],
.btn-hoveryellow.active:hover,
.btn-hoveryellow.active:focus,
.btn-hoveryellow[aria-expanded="true"]:hover,
.btn-hoveryellow[aria-expanded="true"]:focus,
.open > .btn-hoveryellow.dropdown-toggle {
  color: white;
  background: #ffbb8b;
  border-color: #ff984e;
  background-image: none;
}
.btn-hoveryellow.dropdown-toggle + ul li.active a {
  color: white;
  background: #fff1e7;
}
.btn-hoveryellow.disabled,
.btn-hoveryellow[disabled],
fieldset[disabled] .btn-hoveryellow {
  pointer-events: none;
}
.btn-hoveryellow .badge {
  color: #fff1e7;
  background-color: #fff1e7;
}

.menu-hoveryellow ul li.active a,
.menu-hoveryellow ul li.active a:hover {
  color: white;
  background: #fff1e7 !important;
}

.nav-hoveryellow > li.active > a,
.nav-hoveryellow > rubix-menu > li.active > a,
.nav-hoveryellow > rubix-nav-item > li.active > a {
  color: white;
  background: #fff1e7;
  border-color: #fff1e7;
}

.tab-hoveryellow {
  border-color: #fff1e7;
}
.tab-hoveryellow > li.active > a {
  border-color: #fff1e7;
  border-bottom-color: transparent;
}
.tab-hoveryellow.nav-pills > li.active > a {
  background: #fff1e7;
  color: white;
}

.rubix-panel-header.nav-inline .nav-hoveryellow > li.active > a {
  border: 1px solid #fff1e7;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-hoveryellow > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-hoveryellow {
  background: #fff1e7 !important;
}
.bg-hoveryellow table td,
.bg-hoveryellow th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-hoveryellow:focus {
  background: #fff1e7 !important;
}

.bg-hover-hoveryellow:hover {
  background: #fff1e7 !important;
}

.fg-hoveryellow {
  color: #fff1e7;
}
.fg-hoveryellow .nav-tabs > li.active > a {
  color: #fff1e7;
}

.fg-tab-active-hoveryellow .nav-tabs > li.active > a {
  color: #fff1e7 !important;
}

.fg-focus-hoveryellow:focus {
  color: #fff1e7;
}

.fg-hover-hoveryellow:hover {
  color: #fff1e7;
}

.border-hoveryellow {
  border-color: #fff1e7 !important;
}
.border-hoveryellow .rubix-timeline-body > ul {
  border-color: #fff1e7;
}
.border-hoveryellow.rubix-timeline-view:before {
  border-color: #fff1e7;
}

.border-hover-hoveryellow:hover {
  border-color: #fff1e7 !important;
}

.border-focus-hoveryellow:focus {
  border-color: #fff1e7 !important;
}

.tl-hoveryellow .rubix-timeline-body > ul > li:before {
  border-color: #fff1e7;
}

.list-bg-hoveryellow > .list-group-item.active {
  background: #fff1e7 !important;
  color: white !important;
}

.list-fg-hoveryellow > .list-group-item {
  color: #fff1e7;
}

.btn-pink {
  background: #e299b7;
  color: white;
  border-color: #e299b7;
}
.btn-pink.btn-outlined {
  color: #e299b7;
  background: none;
}
.btn-pink.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-pink.btn-outlined.btn-onlyOnHover:hover,
.btn-pink.btn-outlined.btn-onlyOnHover:focus,
.btn-pink.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-pink.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-pink.btn-outlined.btn-inverse:hover,
.btn-pink.btn-outlined.btn-inverse:focus,
.btn-pink.btn-outlined.btn-inverse.active {
  color: #e299b7;
  background: white;
}
.btn-pink.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-pink.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-pink.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #e299b7;
  color: white;
  border-color: #e299b7;
}
.btn-pink.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-pink.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-pink.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #ce5285;
  border-color: #b03266;
}
.btn-pink:focus,
.btn-pink.focus,
.btn-pink:hover,
.btn-pink.active {
  color: white;
  background: #edc1d3;
  border-color: #edc1d3;
}
.btn-pink:active,
.btn-pink.active,
.btn-pink[aria-expanded="true"],
.btn-pink.active:hover,
.btn-pink.active:focus,
.btn-pink[aria-expanded="true"]:hover,
.btn-pink[aria-expanded="true"]:focus,
.open > .btn-pink.dropdown-toggle {
  color: white;
  background: #ce5285;
  border-color: #b03266;
  background-image: none;
}
.btn-pink.dropdown-toggle + ul li.active a {
  color: white;
  background: #e299b7;
}
.btn-pink.disabled,
.btn-pink[disabled],
fieldset[disabled] .btn-pink {
  pointer-events: none;
}
.btn-pink .badge {
  color: #e299b7;
  background-color: #e299b7;
}

.menu-pink ul li.active a,
.menu-pink ul li.active a:hover {
  color: white;
  background: #e299b7 !important;
}

.nav-pink > li.active > a,
.nav-pink > rubix-menu > li.active > a,
.nav-pink > rubix-nav-item > li.active > a {
  color: white;
  background: #e299b7;
  border-color: #e299b7;
}

.tab-pink {
  border-color: #e299b7;
}
.tab-pink > li.active > a {
  border-color: #e299b7;
  border-bottom-color: transparent;
}
.tab-pink.nav-pills > li.active > a {
  background: #e299b7;
  color: white;
}

.rubix-panel-header.nav-inline .nav-pink > li.active > a {
  border: 1px solid #e299b7;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-pink > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-pink {
  background: #e299b7 !important;
}
.bg-pink table td,
.bg-pink th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-pink:focus {
  background: #e299b7 !important;
}

.bg-hover-pink:hover {
  background: #e299b7 !important;
}

.fg-pink {
  color: #e299b7;
}
.fg-pink .nav-tabs > li.active > a {
  color: #e299b7;
}

.fg-tab-active-pink .nav-tabs > li.active > a {
  color: #e299b7 !important;
}

.fg-focus-pink:focus {
  color: #e299b7;
}

.fg-hover-pink:hover {
  color: #e299b7;
}

.border-pink {
  border-color: #e299b7 !important;
}
.border-pink .rubix-timeline-body > ul {
  border-color: #e299b7;
}
.border-pink.rubix-timeline-view:before {
  border-color: #e299b7;
}

.border-hover-pink:hover {
  border-color: #e299b7 !important;
}

.border-focus-pink:focus {
  border-color: #e299b7 !important;
}

.tl-pink .rubix-timeline-body > ul > li:before {
  border-color: #e299b7;
}

.list-bg-pink > .list-group-item.active {
  background: #e299b7 !important;
  color: white !important;
}

.list-fg-pink > .list-group-item {
  color: #e299b7;
}

.btn-lightpink {
  background: #ecbcd0;
  color: white;
  border-color: #ecbcd0;
}
.btn-lightpink.btn-outlined {
  color: #ecbcd0;
  background: none;
}
.btn-lightpink.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightpink.btn-outlined.btn-onlyOnHover:hover,
.btn-lightpink.btn-outlined.btn-onlyOnHover:focus,
.btn-lightpink.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightpink.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightpink.btn-outlined.btn-inverse:hover,
.btn-lightpink.btn-outlined.btn-inverse:focus,
.btn-lightpink.btn-outlined.btn-inverse.active {
  color: #ecbcd0;
  background: white;
}
.btn-lightpink.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightpink.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightpink.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #ecbcd0;
  color: white;
  border-color: #ecbcd0;
}
.btn-lightpink.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightpink.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightpink.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #d8749e;
  border-color: #ca457c;
}
.btn-lightpink:focus,
.btn-lightpink.focus,
.btn-lightpink:hover,
.btn-lightpink.active {
  color: white;
  background: #f7e4ec;
  border-color: #f7e4ec;
}
.btn-lightpink:active,
.btn-lightpink.active,
.btn-lightpink[aria-expanded="true"],
.btn-lightpink.active:hover,
.btn-lightpink.active:focus,
.btn-lightpink[aria-expanded="true"]:hover,
.btn-lightpink[aria-expanded="true"]:focus,
.open > .btn-lightpink.dropdown-toggle {
  color: white;
  background: #d8749e;
  border-color: #ca457c;
  background-image: none;
}
.btn-lightpink.dropdown-toggle + ul li.active a {
  color: white;
  background: #ecbcd0;
}
.btn-lightpink.disabled,
.btn-lightpink[disabled],
fieldset[disabled] .btn-lightpink {
  pointer-events: none;
}
.btn-lightpink .badge {
  color: #ecbcd0;
  background-color: #ecbcd0;
}

.menu-lightpink ul li.active a,
.menu-lightpink ul li.active a:hover {
  color: white;
  background: #ecbcd0 !important;
}

.nav-lightpink > li.active > a,
.nav-lightpink > rubix-menu > li.active > a,
.nav-lightpink > rubix-nav-item > li.active > a {
  color: white;
  background: #ecbcd0;
  border-color: #ecbcd0;
}

.tab-lightpink {
  border-color: #ecbcd0;
}
.tab-lightpink > li.active > a {
  border-color: #ecbcd0;
  border-bottom-color: transparent;
}
.tab-lightpink.nav-pills > li.active > a {
  background: #ecbcd0;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightpink > li.active > a {
  border: 1px solid #ecbcd0;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightpink > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightpink {
  background: #ecbcd0 !important;
}
.bg-lightpink table td,
.bg-lightpink th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightpink:focus {
  background: #ecbcd0 !important;
}

.bg-hover-lightpink:hover {
  background: #ecbcd0 !important;
}

.fg-lightpink {
  color: #ecbcd0;
}
.fg-lightpink .nav-tabs > li.active > a {
  color: #ecbcd0;
}

.fg-tab-active-lightpink .nav-tabs > li.active > a {
  color: #ecbcd0 !important;
}

.fg-focus-lightpink:focus {
  color: #ecbcd0;
}

.fg-hover-lightpink:hover {
  color: #ecbcd0;
}

.border-lightpink {
  border-color: #ecbcd0 !important;
}
.border-lightpink .rubix-timeline-body > ul {
  border-color: #ecbcd0;
}
.border-lightpink.rubix-timeline-view:before {
  border-color: #ecbcd0;
}

.border-hover-lightpink:hover {
  border-color: #ecbcd0 !important;
}

.border-focus-lightpink:focus {
  border-color: #ecbcd0 !important;
}

.tl-lightpink .rubix-timeline-body > ul > li:before {
  border-color: #ecbcd0;
}

.list-bg-lightpink > .list-group-item.active {
  background: #ecbcd0 !important;
  color: white !important;
}

.list-fg-lightpink > .list-group-item {
  color: #ecbcd0;
}

.btn-paleblue {
  background: #a5c7ec;
  color: white;
  border-color: #a5c7ec;
}
.btn-paleblue.btn-outlined {
  color: #a5c7ec;
  background: none;
}
.btn-paleblue.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-paleblue.btn-outlined.btn-onlyOnHover:hover,
.btn-paleblue.btn-outlined.btn-onlyOnHover:focus,
.btn-paleblue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-paleblue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-paleblue.btn-outlined.btn-inverse:hover,
.btn-paleblue.btn-outlined.btn-inverse:focus,
.btn-paleblue.btn-outlined.btn-inverse.active {
  color: #a5c7ec;
  background: white;
}
.btn-paleblue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-paleblue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-paleblue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #a5c7ec;
  color: white;
  border-color: #a5c7ec;
}
.btn-paleblue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-paleblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-paleblue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #5998dc;
  border-color: #2b79cd;
}
.btn-paleblue:focus,
.btn-paleblue.focus,
.btn-paleblue:hover,
.btn-paleblue.active {
  color: white;
  background: #cfe1f5;
  border-color: #cfe1f5;
}
.btn-paleblue:active,
.btn-paleblue.active,
.btn-paleblue[aria-expanded="true"],
.btn-paleblue.active:hover,
.btn-paleblue.active:focus,
.btn-paleblue[aria-expanded="true"]:hover,
.btn-paleblue[aria-expanded="true"]:focus,
.open > .btn-paleblue.dropdown-toggle {
  color: white;
  background: #5998dc;
  border-color: #2b79cd;
  background-image: none;
}
.btn-paleblue.dropdown-toggle + ul li.active a {
  color: white;
  background: #a5c7ec;
}
.btn-paleblue.disabled,
.btn-paleblue[disabled],
fieldset[disabled] .btn-paleblue {
  pointer-events: none;
}
.btn-paleblue .badge {
  color: #a5c7ec;
  background-color: #a5c7ec;
}

.menu-paleblue ul li.active a,
.menu-paleblue ul li.active a:hover {
  color: white;
  background: #a5c7ec !important;
}

.nav-paleblue > li.active > a,
.nav-paleblue > rubix-menu > li.active > a,
.nav-paleblue > rubix-nav-item > li.active > a {
  color: white;
  background: #a5c7ec;
  border-color: #a5c7ec;
}

.tab-paleblue {
  border-color: #a5c7ec;
}
.tab-paleblue > li.active > a {
  border-color: #a5c7ec;
  border-bottom-color: transparent;
}
.tab-paleblue.nav-pills > li.active > a {
  background: #a5c7ec;
  color: white;
}

.rubix-panel-header.nav-inline .nav-paleblue > li.active > a {
  border: 1px solid #a5c7ec;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-paleblue > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-paleblue {
  background: #a5c7ec !important;
}
.bg-paleblue table td,
.bg-paleblue th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-paleblue:focus {
  background: #a5c7ec !important;
}

.bg-hover-paleblue:hover {
  background: #a5c7ec !important;
}

.fg-paleblue {
  color: #a5c7ec;
}
.fg-paleblue .nav-tabs > li.active > a {
  color: #a5c7ec;
}

.fg-tab-active-paleblue .nav-tabs > li.active > a {
  color: #a5c7ec !important;
}

.fg-focus-paleblue:focus {
  color: #a5c7ec;
}

.fg-hover-paleblue:hover {
  color: #a5c7ec;
}

.border-paleblue {
  border-color: #a5c7ec !important;
}
.border-paleblue .rubix-timeline-body > ul {
  border-color: #a5c7ec;
}
.border-paleblue.rubix-timeline-view:before {
  border-color: #a5c7ec;
}

.border-hover-paleblue:hover {
  border-color: #a5c7ec !important;
}

.border-focus-paleblue:focus {
  border-color: #a5c7ec !important;
}

.tl-paleblue .rubix-timeline-body > ul > li:before {
  border-color: #a5c7ec;
}

.list-bg-paleblue > .list-group-item.active {
  background: #a5c7ec !important;
  color: white !important;
}

.list-fg-paleblue > .list-group-item {
  color: #a5c7ec;
}

.btn-palegreen {
  background: #a0dfcc;
  color: white;
  border-color: #a0dfcc;
}
.btn-palegreen.btn-outlined {
  color: #a0dfcc;
  background: none;
}
.btn-palegreen.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-palegreen.btn-outlined.btn-onlyOnHover:hover,
.btn-palegreen.btn-outlined.btn-onlyOnHover:focus,
.btn-palegreen.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-palegreen.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-palegreen.btn-outlined.btn-inverse:hover,
.btn-palegreen.btn-outlined.btn-inverse:focus,
.btn-palegreen.btn-outlined.btn-inverse.active {
  color: #a0dfcc;
  background: white;
}
.btn-palegreen.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-palegreen.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-palegreen.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #a0dfcc;
  color: white;
  border-color: #a0dfcc;
}
.btn-palegreen.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-palegreen.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-palegreen.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #5bc8a7;
  border-color: #3aac8a;
}
.btn-palegreen:focus,
.btn-palegreen.focus,
.btn-palegreen:hover,
.btn-palegreen.active {
  color: white;
  background: #c6ece0;
  border-color: #c6ece0;
}
.btn-palegreen:active,
.btn-palegreen.active,
.btn-palegreen[aria-expanded="true"],
.btn-palegreen.active:hover,
.btn-palegreen.active:focus,
.btn-palegreen[aria-expanded="true"]:hover,
.btn-palegreen[aria-expanded="true"]:focus,
.open > .btn-palegreen.dropdown-toggle {
  color: white;
  background: #5bc8a7;
  border-color: #3aac8a;
  background-image: none;
}
.btn-palegreen.dropdown-toggle + ul li.active a {
  color: white;
  background: #a0dfcc;
}
.btn-palegreen.disabled,
.btn-palegreen[disabled],
fieldset[disabled] .btn-palegreen {
  pointer-events: none;
}
.btn-palegreen .badge {
  color: #a0dfcc;
  background-color: #a0dfcc;
}

.menu-palegreen ul li.active a,
.menu-palegreen ul li.active a:hover {
  color: white;
  background: #a0dfcc !important;
}

.nav-palegreen > li.active > a,
.nav-palegreen > rubix-menu > li.active > a,
.nav-palegreen > rubix-nav-item > li.active > a {
  color: white;
  background: #a0dfcc;
  border-color: #a0dfcc;
}

.tab-palegreen {
  border-color: #a0dfcc;
}
.tab-palegreen > li.active > a {
  border-color: #a0dfcc;
  border-bottom-color: transparent;
}
.tab-palegreen.nav-pills > li.active > a {
  background: #a0dfcc;
  color: white;
}

.rubix-panel-header.nav-inline .nav-palegreen > li.active > a {
  border: 1px solid #a0dfcc;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-palegreen > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-palegreen {
  background: #a0dfcc !important;
}
.bg-palegreen table td,
.bg-palegreen th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-palegreen:focus {
  background: #a0dfcc !important;
}

.bg-hover-palegreen:hover {
  background: #a0dfcc !important;
}

.fg-palegreen {
  color: #a0dfcc;
}
.fg-palegreen .nav-tabs > li.active > a {
  color: #a0dfcc;
}

.fg-tab-active-palegreen .nav-tabs > li.active > a {
  color: #a0dfcc !important;
}

.fg-focus-palegreen:focus {
  color: #a0dfcc;
}

.fg-hover-palegreen:hover {
  color: #a0dfcc;
}

.border-palegreen {
  border-color: #a0dfcc !important;
}
.border-palegreen .rubix-timeline-body > ul {
  border-color: #a0dfcc;
}
.border-palegreen.rubix-timeline-view:before {
  border-color: #a0dfcc;
}

.border-hover-palegreen:hover {
  border-color: #a0dfcc !important;
}

.border-focus-palegreen:focus {
  border-color: #a0dfcc !important;
}

.tl-palegreen .rubix-timeline-body > ul > li:before {
  border-color: #a0dfcc;
}

.list-bg-palegreen > .list-group-item.active {
  background: #a0dfcc !important;
  color: white !important;
}

.list-fg-palegreen > .list-group-item {
  color: #a0dfcc;
}

.btn-palepink {
  background: #e394b3;
  color: white;
  border-color: #e394b3;
}
.btn-palepink.btn-outlined {
  color: #e394b3;
  background: none;
}
.btn-palepink.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-palepink.btn-outlined.btn-onlyOnHover:hover,
.btn-palepink.btn-outlined.btn-onlyOnHover:focus,
.btn-palepink.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-palepink.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-palepink.btn-outlined.btn-inverse:hover,
.btn-palepink.btn-outlined.btn-inverse:focus,
.btn-palepink.btn-outlined.btn-inverse.active {
  color: #e394b3;
  background: white;
}
.btn-palepink.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-palepink.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-palepink.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #e394b3;
  color: white;
  border-color: #e394b3;
}
.btn-palepink.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-palepink.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-palepink.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #d04b7f;
  border-color: #b02e61;
}
.btn-palepink:focus,
.btn-palepink.focus,
.btn-palepink:hover,
.btn-palepink.active {
  color: white;
  background: #eebcd0;
  border-color: #eebcd0;
}
.btn-palepink:active,
.btn-palepink.active,
.btn-palepink[aria-expanded="true"],
.btn-palepink.active:hover,
.btn-palepink.active:focus,
.btn-palepink[aria-expanded="true"]:hover,
.btn-palepink[aria-expanded="true"]:focus,
.open > .btn-palepink.dropdown-toggle {
  color: white;
  background: #d04b7f;
  border-color: #b02e61;
  background-image: none;
}
.btn-palepink.dropdown-toggle + ul li.active a {
  color: white;
  background: #e394b3;
}
.btn-palepink.disabled,
.btn-palepink[disabled],
fieldset[disabled] .btn-palepink {
  pointer-events: none;
}
.btn-palepink .badge {
  color: #e394b3;
  background-color: #e394b3;
}

.menu-palepink ul li.active a,
.menu-palepink ul li.active a:hover {
  color: white;
  background: #e394b3 !important;
}

.nav-palepink > li.active > a,
.nav-palepink > rubix-menu > li.active > a,
.nav-palepink > rubix-nav-item > li.active > a {
  color: white;
  background: #e394b3;
  border-color: #e394b3;
}

.tab-palepink {
  border-color: #e394b3;
}
.tab-palepink > li.active > a {
  border-color: #e394b3;
  border-bottom-color: transparent;
}
.tab-palepink.nav-pills > li.active > a {
  background: #e394b3;
  color: white;
}

.rubix-panel-header.nav-inline .nav-palepink > li.active > a {
  border: 1px solid #e394b3;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-palepink > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-palepink {
  background: #e394b3 !important;
}
.bg-palepink table td,
.bg-palepink th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-palepink:focus {
  background: #e394b3 !important;
}

.bg-hover-palepink:hover {
  background: #e394b3 !important;
}

.fg-palepink {
  color: #e394b3;
}
.fg-palepink .nav-tabs > li.active > a {
  color: #e394b3;
}

.fg-tab-active-palepink .nav-tabs > li.active > a {
  color: #e394b3 !important;
}

.fg-focus-palepink:focus {
  color: #e394b3;
}

.fg-hover-palepink:hover {
  color: #e394b3;
}

.border-palepink {
  border-color: #e394b3 !important;
}
.border-palepink .rubix-timeline-body > ul {
  border-color: #e394b3;
}
.border-palepink.rubix-timeline-view:before {
  border-color: #e394b3;
}

.border-hover-palepink:hover {
  border-color: #e394b3 !important;
}

.border-focus-palepink:focus {
  border-color: #e394b3 !important;
}

.tl-palepink .rubix-timeline-body > ul > li:before {
  border-color: #e394b3;
}

.list-bg-palepink > .list-group-item.active {
  background: #e394b3 !important;
  color: white !important;
}

.list-fg-palepink > .list-group-item {
  color: #e394b3;
}

.btn-brownishgray {
  background: #64584c;
  color: white;
  border-color: #64584c;
}
.btn-brownishgray.btn-outlined {
  color: #64584c;
  background: none;
}
.btn-brownishgray.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brownishgray.btn-outlined.btn-onlyOnHover:hover,
.btn-brownishgray.btn-outlined.btn-onlyOnHover:focus,
.btn-brownishgray.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brownishgray.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brownishgray.btn-outlined.btn-inverse:hover,
.btn-brownishgray.btn-outlined.btn-inverse:focus,
.btn-brownishgray.btn-outlined.btn-inverse.active {
  color: #64584c;
  background: white;
}
.btn-brownishgray.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brownishgray.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brownishgray.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #64584c;
  color: white;
  border-color: #64584c;
}
.btn-brownishgray.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brownishgray.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brownishgray.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #302a24;
  border-color: #0d0c0a;
}
.btn-brownishgray:focus,
.btn-brownishgray.focus,
.btn-brownishgray:hover,
.btn-brownishgray.active {
  color: white;
  background: #817262;
  border-color: #817262;
}
.btn-brownishgray:active,
.btn-brownishgray.active,
.btn-brownishgray[aria-expanded="true"],
.btn-brownishgray.active:hover,
.btn-brownishgray.active:focus,
.btn-brownishgray[aria-expanded="true"]:hover,
.btn-brownishgray[aria-expanded="true"]:focus,
.open > .btn-brownishgray.dropdown-toggle {
  color: white;
  background: #302a24;
  border-color: #0d0c0a;
  background-image: none;
}
.btn-brownishgray.dropdown-toggle + ul li.active a {
  color: white;
  background: #64584c;
}
.btn-brownishgray.disabled,
.btn-brownishgray[disabled],
fieldset[disabled] .btn-brownishgray {
  pointer-events: none;
}
.btn-brownishgray .badge {
  color: #64584c;
  background-color: #64584c;
}

.menu-brownishgray ul li.active a,
.menu-brownishgray ul li.active a:hover {
  color: white;
  background: #64584c !important;
}

.nav-brownishgray > li.active > a,
.nav-brownishgray > rubix-menu > li.active > a,
.nav-brownishgray > rubix-nav-item > li.active > a {
  color: white;
  background: #64584c;
  border-color: #64584c;
}

.tab-brownishgray {
  border-color: #64584c;
}
.tab-brownishgray > li.active > a {
  border-color: #64584c;
  border-bottom-color: transparent;
}
.tab-brownishgray.nav-pills > li.active > a {
  background: #64584c;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brownishgray > li.active > a {
  border: 1px solid #64584c;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-brownishgray > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brownishgray {
  background: #64584c !important;
}
.bg-brownishgray table td,
.bg-brownishgray th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brownishgray:focus {
  background: #64584c !important;
}

.bg-hover-brownishgray:hover {
  background: #64584c !important;
}

.fg-brownishgray {
  color: #64584c;
}
.fg-brownishgray .nav-tabs > li.active > a {
  color: #64584c;
}

.fg-tab-active-brownishgray .nav-tabs > li.active > a {
  color: #64584c !important;
}

.fg-focus-brownishgray:focus {
  color: #64584c;
}

.fg-hover-brownishgray:hover {
  color: #64584c;
}

.border-brownishgray {
  border-color: #64584c !important;
}
.border-brownishgray .rubix-timeline-body > ul {
  border-color: #64584c;
}
.border-brownishgray.rubix-timeline-view:before {
  border-color: #64584c;
}

.border-hover-brownishgray:hover {
  border-color: #64584c !important;
}

.border-focus-brownishgray:focus {
  border-color: #64584c !important;
}

.tl-brownishgray .rubix-timeline-body > ul > li:before {
  border-color: #64584c;
}

.list-bg-brownishgray > .list-group-item.active {
  background: #64584c !important;
  color: white !important;
}

.list-fg-brownishgray > .list-group-item {
  color: #64584c;
}

.btn-brownishgray75 {
  background: #776b5f;
  color: white;
  border-color: #776b5f;
}
.btn-brownishgray75.btn-outlined {
  color: #776b5f;
  background: none;
}
.btn-brownishgray75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-brownishgray75.btn-outlined.btn-onlyOnHover:hover,
.btn-brownishgray75.btn-outlined.btn-onlyOnHover:focus,
.btn-brownishgray75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-brownishgray75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-brownishgray75.btn-outlined.btn-inverse:hover,
.btn-brownishgray75.btn-outlined.btn-inverse:focus,
.btn-brownishgray75.btn-outlined.btn-inverse.active {
  color: #776b5f;
  background: white;
}
.btn-brownishgray75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-brownishgray75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-brownishgray75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #776b5f;
  color: white;
  border-color: #776b5f;
}
.btn-brownishgray75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-brownishgray75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-brownishgray75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #443d36;
  border-color: #221f1b;
}
.btn-brownishgray75:focus,
.btn-brownishgray75.focus,
.btn-brownishgray75:hover,
.btn-brownishgray75.active {
  color: white;
  background: #928577;
  border-color: #928577;
}
.btn-brownishgray75:active,
.btn-brownishgray75.active,
.btn-brownishgray75[aria-expanded="true"],
.btn-brownishgray75.active:hover,
.btn-brownishgray75.active:focus,
.btn-brownishgray75[aria-expanded="true"]:hover,
.btn-brownishgray75[aria-expanded="true"]:focus,
.open > .btn-brownishgray75.dropdown-toggle {
  color: white;
  background: #443d36;
  border-color: #221f1b;
  background-image: none;
}
.btn-brownishgray75.dropdown-toggle + ul li.active a {
  color: white;
  background: #776b5f;
}
.btn-brownishgray75.disabled,
.btn-brownishgray75[disabled],
fieldset[disabled] .btn-brownishgray75 {
  pointer-events: none;
}
.btn-brownishgray75 .badge {
  color: #776b5f;
  background-color: #776b5f;
}

.menu-brownishgray75 ul li.active a,
.menu-brownishgray75 ul li.active a:hover {
  color: white;
  background: #776b5f !important;
}

.nav-brownishgray75 > li.active > a,
.nav-brownishgray75 > rubix-menu > li.active > a,
.nav-brownishgray75 > rubix-nav-item > li.active > a {
  color: white;
  background: #776b5f;
  border-color: #776b5f;
}

.tab-brownishgray75 {
  border-color: #776b5f;
}
.tab-brownishgray75 > li.active > a {
  border-color: #776b5f;
  border-bottom-color: transparent;
}
.tab-brownishgray75.nav-pills > li.active > a {
  background: #776b5f;
  color: white;
}

.rubix-panel-header.nav-inline .nav-brownishgray75 > li.active > a {
  border: 1px solid #776b5f;
  border-bottom: none;
}

.rubix-panel-header.nav-inline
  .nav-brownishgray75
  > li.open
  > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-brownishgray75 {
  background: #776b5f !important;
}
.bg-brownishgray75 table td,
.bg-brownishgray75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-brownishgray75:focus {
  background: #776b5f !important;
}

.bg-hover-brownishgray75:hover {
  background: #776b5f !important;
}

.fg-brownishgray75 {
  color: #776b5f;
}
.fg-brownishgray75 .nav-tabs > li.active > a {
  color: #776b5f;
}

.fg-tab-active-brownishgray75 .nav-tabs > li.active > a {
  color: #776b5f !important;
}

.fg-focus-brownishgray75:focus {
  color: #776b5f;
}

.fg-hover-brownishgray75:hover {
  color: #776b5f;
}

.border-brownishgray75 {
  border-color: #776b5f !important;
}
.border-brownishgray75 .rubix-timeline-body > ul {
  border-color: #776b5f;
}
.border-brownishgray75.rubix-timeline-view:before {
  border-color: #776b5f;
}

.border-hover-brownishgray75:hover {
  border-color: #776b5f !important;
}

.border-focus-brownishgray75:focus {
  border-color: #776b5f !important;
}

.tl-brownishgray75 .rubix-timeline-body > ul > li:before {
  border-color: #776b5f;
}

.list-bg-brownishgray75 > .list-group-item.active {
  background: #776b5f !important;
  color: white !important;
}

.list-fg-brownishgray75 > .list-group-item {
  color: #776b5f;
}

.btn-gray {
  background: #eaedf1;
  color: white;
  border-color: #eaedf1;
}
.btn-gray.btn-outlined {
  color: #eaedf1;
  background: none;
}
.btn-gray.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-gray.btn-outlined.btn-onlyOnHover:hover,
.btn-gray.btn-outlined.btn-onlyOnHover:focus,
.btn-gray.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-gray.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-gray.btn-outlined.btn-inverse:hover,
.btn-gray.btn-outlined.btn-inverse:focus,
.btn-gray.btn-outlined.btn-inverse.active {
  color: #eaedf1;
  background: white;
}
.btn-gray.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-gray.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-gray.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #eaedf1;
  color: white;
  border-color: #eaedf1;
}
.btn-gray.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-gray.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-gray.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #b3becc;
  border-color: #8e9eb4;
}
.btn-gray:focus,
.btn-gray.focus,
.btn-gray:hover,
.btn-gray.active {
  color: white;
  background: white;
  border-color: white;
}
.btn-gray:active,
.btn-gray.active,
.btn-gray[aria-expanded="true"],
.btn-gray.active:hover,
.btn-gray.active:focus,
.btn-gray[aria-expanded="true"]:hover,
.btn-gray[aria-expanded="true"]:focus,
.open > .btn-gray.dropdown-toggle {
  color: white;
  background: #b3becc;
  border-color: #8e9eb4;
  background-image: none;
}
.btn-gray.dropdown-toggle + ul li.active a {
  color: white;
  background: #eaedf1;
}
.btn-gray.disabled,
.btn-gray[disabled],
fieldset[disabled] .btn-gray {
  pointer-events: none;
}
.btn-gray .badge {
  color: #eaedf1;
  background-color: #eaedf1;
}

.menu-gray ul li.active a,
.menu-gray ul li.active a:hover {
  color: white;
  background: #eaedf1 !important;
}

.nav-gray > li.active > a,
.nav-gray > rubix-menu > li.active > a,
.nav-gray > rubix-nav-item > li.active > a {
  color: white;
  background: #eaedf1;
  border-color: #eaedf1;
}

.tab-gray {
  border-color: #eaedf1;
}
.tab-gray > li.active > a {
  border-color: #eaedf1;
  border-bottom-color: transparent;
}
.tab-gray.nav-pills > li.active > a {
  background: #eaedf1;
  color: white;
}

.rubix-panel-header.nav-inline .nav-gray > li.active > a {
  border: 1px solid #eaedf1;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-gray > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-gray {
  background: #eaedf1 !important;
}
.bg-gray table td,
.bg-gray th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-gray:focus {
  background: #eaedf1 !important;
}

.bg-hover-gray:hover {
  background: #eaedf1 !important;
}

.fg-gray {
  color: #eaedf1;
}
.fg-gray .nav-tabs > li.active > a {
  color: #eaedf1;
}

.fg-tab-active-gray .nav-tabs > li.active > a {
  color: #eaedf1 !important;
}

.fg-focus-gray:focus {
  color: #eaedf1;
}

.fg-hover-gray:hover {
  color: #eaedf1;
}

.border-gray {
  border-color: #eaedf1 !important;
}
.border-gray .rubix-timeline-body > ul {
  border-color: #eaedf1;
}
.border-gray.rubix-timeline-view:before {
  border-color: #eaedf1;
}

.border-hover-gray:hover {
  border-color: #eaedf1 !important;
}

.border-focus-gray:focus {
  border-color: #eaedf1 !important;
}

.tl-gray .rubix-timeline-body > ul > li:before {
  border-color: #eaedf1;
}

.list-bg-gray > .list-group-item.active {
  background: #eaedf1 !important;
  color: white !important;
}

.list-fg-gray > .list-group-item {
  color: #eaedf1;
}

.btn-darkgray {
  background: #999895;
  color: white;
  border-color: #999895;
}
.btn-darkgray.btn-outlined {
  color: #999895;
  background: none;
}
.btn-darkgray.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgray.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgray.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgray.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgray.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgray.btn-outlined.btn-inverse:hover,
.btn-darkgray.btn-outlined.btn-inverse:focus,
.btn-darkgray.btn-outlined.btn-inverse.active {
  color: #999895;
  background: white;
}
.btn-darkgray.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgray.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgray.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #999895;
  color: white;
  border-color: #999895;
}
.btn-darkgray.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgray.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgray.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #6b6a67;
  border-color: #4c4b49;
}
.btn-darkgray:focus,
.btn-darkgray.focus,
.btn-darkgray:hover,
.btn-darkgray.active {
  color: white;
  background: #b2b1af;
  border-color: #b2b1af;
}
.btn-darkgray:active,
.btn-darkgray.active,
.btn-darkgray[aria-expanded="true"],
.btn-darkgray.active:hover,
.btn-darkgray.active:focus,
.btn-darkgray[aria-expanded="true"]:hover,
.btn-darkgray[aria-expanded="true"]:focus,
.open > .btn-darkgray.dropdown-toggle {
  color: white;
  background: #6b6a67;
  border-color: #4c4b49;
  background-image: none;
}
.btn-darkgray.dropdown-toggle + ul li.active a {
  color: white;
  background: #999895;
}
.btn-darkgray.disabled,
.btn-darkgray[disabled],
fieldset[disabled] .btn-darkgray {
  pointer-events: none;
}
.btn-darkgray .badge {
  color: #999895;
  background-color: #999895;
}

.menu-darkgray ul li.active a,
.menu-darkgray ul li.active a:hover {
  color: white;
  background: #999895 !important;
}

.nav-darkgray > li.active > a,
.nav-darkgray > rubix-menu > li.active > a,
.nav-darkgray > rubix-nav-item > li.active > a {
  color: white;
  background: #999895;
  border-color: #999895;
}

.tab-darkgray {
  border-color: #999895;
}
.tab-darkgray > li.active > a {
  border-color: #999895;
  border-bottom-color: transparent;
}
.tab-darkgray.nav-pills > li.active > a {
  background: #999895;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgray > li.active > a {
  border: 1px solid #999895;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgray > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgray {
  background: #999895 !important;
}
.bg-darkgray table td,
.bg-darkgray th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgray:focus {
  background: #999895 !important;
}

.bg-hover-darkgray:hover {
  background: #999895 !important;
}

.fg-darkgray {
  color: #999895;
}
.fg-darkgray .nav-tabs > li.active > a {
  color: #999895;
}

.fg-tab-active-darkgray .nav-tabs > li.active > a {
  color: #999895 !important;
}

.fg-focus-darkgray:focus {
  color: #999895;
}

.fg-hover-darkgray:hover {
  color: #999895;
}

.border-darkgray {
  border-color: #999895 !important;
}
.border-darkgray .rubix-timeline-body > ul {
  border-color: #999895;
}
.border-darkgray.rubix-timeline-view:before {
  border-color: #999895;
}

.border-hover-darkgray:hover {
  border-color: #999895 !important;
}

.border-focus-darkgray:focus {
  border-color: #999895 !important;
}

.tl-darkgray .rubix-timeline-body > ul > li:before {
  border-color: #999895;
}

.list-bg-darkgray > .list-group-item.active {
  background: #999895 !important;
  color: white !important;
}

.list-fg-darkgray > .list-group-item {
  color: #999895;
}

.btn-darkgray75 {
  background: #b8b6b0;
  color: white;
  border-color: #b8b6b0;
}
.btn-darkgray75.btn-outlined {
  color: #b8b6b0;
  background: none;
}
.btn-darkgray75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgray75.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgray75.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgray75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgray75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgray75.btn-outlined.btn-inverse:hover,
.btn-darkgray75.btn-outlined.btn-inverse:focus,
.btn-darkgray75.btn-outlined.btn-inverse.active {
  color: #b8b6b0;
  background: white;
}
.btn-darkgray75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgray75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgray75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #b8b6b0;
  color: white;
  border-color: #b8b6b0;
}
.btn-darkgray75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgray75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgray75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #8d8980;
  border-color: #6d6a62;
}
.btn-darkgray75:focus,
.btn-darkgray75.focus,
.btn-darkgray75:hover,
.btn-darkgray75.active {
  color: white;
  background: #d0cfcb;
  border-color: #d0cfcb;
}
.btn-darkgray75:active,
.btn-darkgray75.active,
.btn-darkgray75[aria-expanded="true"],
.btn-darkgray75.active:hover,
.btn-darkgray75.active:focus,
.btn-darkgray75[aria-expanded="true"]:hover,
.btn-darkgray75[aria-expanded="true"]:focus,
.open > .btn-darkgray75.dropdown-toggle {
  color: white;
  background: #8d8980;
  border-color: #6d6a62;
  background-image: none;
}
.btn-darkgray75.dropdown-toggle + ul li.active a {
  color: white;
  background: #b8b6b0;
}
.btn-darkgray75.disabled,
.btn-darkgray75[disabled],
fieldset[disabled] .btn-darkgray75 {
  pointer-events: none;
}
.btn-darkgray75 .badge {
  color: #b8b6b0;
  background-color: #b8b6b0;
}

.menu-darkgray75 ul li.active a,
.menu-darkgray75 ul li.active a:hover {
  color: white;
  background: #b8b6b0 !important;
}

.nav-darkgray75 > li.active > a,
.nav-darkgray75 > rubix-menu > li.active > a,
.nav-darkgray75 > rubix-nav-item > li.active > a {
  color: white;
  background: #b8b6b0;
  border-color: #b8b6b0;
}

.tab-darkgray75 {
  border-color: #b8b6b0;
}
.tab-darkgray75 > li.active > a {
  border-color: #b8b6b0;
  border-bottom-color: transparent;
}
.tab-darkgray75.nav-pills > li.active > a {
  background: #b8b6b0;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgray75 > li.active > a {
  border: 1px solid #b8b6b0;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgray75 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgray75 {
  background: #b8b6b0 !important;
}
.bg-darkgray75 table td,
.bg-darkgray75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgray75:focus {
  background: #b8b6b0 !important;
}

.bg-hover-darkgray75:hover {
  background: #b8b6b0 !important;
}

.fg-darkgray75 {
  color: #b8b6b0;
}
.fg-darkgray75 .nav-tabs > li.active > a {
  color: #b8b6b0;
}

.fg-tab-active-darkgray75 .nav-tabs > li.active > a {
  color: #b8b6b0 !important;
}

.fg-focus-darkgray75:focus {
  color: #b8b6b0;
}

.fg-hover-darkgray75:hover {
  color: #b8b6b0;
}

.border-darkgray75 {
  border-color: #b8b6b0 !important;
}
.border-darkgray75 .rubix-timeline-body > ul {
  border-color: #b8b6b0;
}
.border-darkgray75.rubix-timeline-view:before {
  border-color: #b8b6b0;
}

.border-hover-darkgray75:hover {
  border-color: #b8b6b0 !important;
}

.border-focus-darkgray75:focus {
  border-color: #b8b6b0 !important;
}

.tl-darkgray75 .rubix-timeline-body > ul > li:before {
  border-color: #b8b6b0;
}

.list-bg-darkgray75 > .list-group-item.active {
  background: #b8b6b0 !important;
  color: white !important;
}

.list-fg-darkgray75 > .list-group-item {
  color: #b8b6b0;
}

.btn-darkgray50 {
  background: #b8c3c8;
  color: white;
  border-color: #b8c3c8;
}
.btn-darkgray50.btn-outlined {
  color: #b8c3c8;
  background: none;
}
.btn-darkgray50.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgray50.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgray50.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgray50.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgray50.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgray50.btn-outlined.btn-inverse:hover,
.btn-darkgray50.btn-outlined.btn-inverse:focus,
.btn-darkgray50.btn-outlined.btn-inverse.active {
  color: #b8c3c8;
  background: white;
}
.btn-darkgray50.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgray50.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgray50.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #b8c3c8;
  color: white;
  border-color: #b8c3c8;
}
.btn-darkgray50.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgray50.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgray50.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #8497a0;
  border-color: #657982;
}
.btn-darkgray50:focus,
.btn-darkgray50.focus,
.btn-darkgray50:hover,
.btn-darkgray50.active {
  color: white;
  background: #d5dbde;
  border-color: #d5dbde;
}
.btn-darkgray50:active,
.btn-darkgray50.active,
.btn-darkgray50[aria-expanded="true"],
.btn-darkgray50.active:hover,
.btn-darkgray50.active:focus,
.btn-darkgray50[aria-expanded="true"]:hover,
.btn-darkgray50[aria-expanded="true"]:focus,
.open > .btn-darkgray50.dropdown-toggle {
  color: white;
  background: #8497a0;
  border-color: #657982;
  background-image: none;
}
.btn-darkgray50.dropdown-toggle + ul li.active a {
  color: white;
  background: #b8c3c8;
}
.btn-darkgray50.disabled,
.btn-darkgray50[disabled],
fieldset[disabled] .btn-darkgray50 {
  pointer-events: none;
}
.btn-darkgray50 .badge {
  color: #b8c3c8;
  background-color: #b8c3c8;
}

.menu-darkgray50 ul li.active a,
.menu-darkgray50 ul li.active a:hover {
  color: white;
  background: #b8c3c8 !important;
}

.nav-darkgray50 > li.active > a,
.nav-darkgray50 > rubix-menu > li.active > a,
.nav-darkgray50 > rubix-nav-item > li.active > a {
  color: white;
  background: #b8c3c8;
  border-color: #b8c3c8;
}

.tab-darkgray50 {
  border-color: #b8c3c8;
}
.tab-darkgray50 > li.active > a {
  border-color: #b8c3c8;
  border-bottom-color: transparent;
}
.tab-darkgray50.nav-pills > li.active > a {
  background: #b8c3c8;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgray50 > li.active > a {
  border: 1px solid #b8c3c8;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgray50 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgray50 {
  background: #b8c3c8 !important;
}
.bg-darkgray50 table td,
.bg-darkgray50 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgray50:focus {
  background: #b8c3c8 !important;
}

.bg-hover-darkgray50:hover {
  background: #b8c3c8 !important;
}

.fg-darkgray50 {
  color: #b8c3c8;
}
.fg-darkgray50 .nav-tabs > li.active > a {
  color: #b8c3c8;
}

.fg-tab-active-darkgray50 .nav-tabs > li.active > a {
  color: #b8c3c8 !important;
}

.fg-focus-darkgray50:focus {
  color: #b8c3c8;
}

.fg-hover-darkgray50:hover {
  color: #b8c3c8;
}

.border-darkgray50 {
  border-color: #b8c3c8 !important;
}
.border-darkgray50 .rubix-timeline-body > ul {
  border-color: #b8c3c8;
}
.border-darkgray50.rubix-timeline-view:before {
  border-color: #b8c3c8;
}

.border-hover-darkgray50:hover {
  border-color: #b8c3c8 !important;
}

.border-focus-darkgray50:focus {
  border-color: #b8c3c8 !important;
}

.tl-darkgray50 .rubix-timeline-body > ul > li:before {
  border-color: #b8c3c8;
}

.list-bg-darkgray50 > .list-group-item.active {
  background: #b8c3c8 !important;
  color: white !important;
}

.list-fg-darkgray50 > .list-group-item {
  color: #b8c3c8;
}

.btn-darkgray40 {
  background: #cdccc8;
  color: white;
  border-color: #cdccc8;
}
.btn-darkgray40.btn-outlined {
  color: #cdccc8;
  background: none;
}
.btn-darkgray40.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgray40.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgray40.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgray40.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgray40.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgray40.btn-outlined.btn-inverse:hover,
.btn-darkgray40.btn-outlined.btn-inverse:focus,
.btn-darkgray40.btn-outlined.btn-inverse.active {
  color: #cdccc8;
  background: white;
}
.btn-darkgray40.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgray40.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgray40.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #cdccc8;
  color: white;
  border-color: #cdccc8;
}
.btn-darkgray40.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgray40.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgray40.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #a19f98;
  border-color: #848278;
}
.btn-darkgray40:focus,
.btn-darkgray40.focus,
.btn-darkgray40:hover,
.btn-darkgray40.active {
  color: white;
  background: #e5e5e3;
  border-color: #e5e5e3;
}
.btn-darkgray40:active,
.btn-darkgray40.active,
.btn-darkgray40[aria-expanded="true"],
.btn-darkgray40.active:hover,
.btn-darkgray40.active:focus,
.btn-darkgray40[aria-expanded="true"]:hover,
.btn-darkgray40[aria-expanded="true"]:focus,
.open > .btn-darkgray40.dropdown-toggle {
  color: white;
  background: #a19f98;
  border-color: #848278;
  background-image: none;
}
.btn-darkgray40.dropdown-toggle + ul li.active a {
  color: white;
  background: #cdccc8;
}
.btn-darkgray40.disabled,
.btn-darkgray40[disabled],
fieldset[disabled] .btn-darkgray40 {
  pointer-events: none;
}
.btn-darkgray40 .badge {
  color: #cdccc8;
  background-color: #cdccc8;
}

.menu-darkgray40 ul li.active a,
.menu-darkgray40 ul li.active a:hover {
  color: white;
  background: #cdccc8 !important;
}

.nav-darkgray40 > li.active > a,
.nav-darkgray40 > rubix-menu > li.active > a,
.nav-darkgray40 > rubix-nav-item > li.active > a {
  color: white;
  background: #cdccc8;
  border-color: #cdccc8;
}

.tab-darkgray40 {
  border-color: #cdccc8;
}
.tab-darkgray40 > li.active > a {
  border-color: #cdccc8;
  border-bottom-color: transparent;
}
.tab-darkgray40.nav-pills > li.active > a {
  background: #cdccc8;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgray40 > li.active > a {
  border: 1px solid #cdccc8;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgray40 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgray40 {
  background: #cdccc8 !important;
}
.bg-darkgray40 table td,
.bg-darkgray40 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgray40:focus {
  background: #cdccc8 !important;
}

.bg-hover-darkgray40:hover {
  background: #cdccc8 !important;
}

.fg-darkgray40 {
  color: #cdccc8;
}
.fg-darkgray40 .nav-tabs > li.active > a {
  color: #cdccc8;
}

.fg-tab-active-darkgray40 .nav-tabs > li.active > a {
  color: #cdccc8 !important;
}

.fg-focus-darkgray40:focus {
  color: #cdccc8;
}

.fg-hover-darkgray40:hover {
  color: #cdccc8;
}

.border-darkgray40 {
  border-color: #cdccc8 !important;
}
.border-darkgray40 .rubix-timeline-body > ul {
  border-color: #cdccc8;
}
.border-darkgray40.rubix-timeline-view:before {
  border-color: #cdccc8;
}

.border-hover-darkgray40:hover {
  border-color: #cdccc8 !important;
}

.border-focus-darkgray40:focus {
  border-color: #cdccc8 !important;
}

.tl-darkgray40 .rubix-timeline-body > ul > li:before {
  border-color: #cdccc8;
}

.list-bg-darkgray40 > .list-group-item.active {
  background: #cdccc8 !important;
  color: white !important;
}

.list-fg-darkgray40 > .list-group-item {
  color: #cdccc8;
}

.btn-darkgray25 {
  background: #dcdbd8;
  color: white;
  border-color: #dcdbd8;
}
.btn-darkgray25.btn-outlined {
  color: #dcdbd8;
  background: none;
}
.btn-darkgray25.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgray25.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgray25.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgray25.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgray25.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgray25.btn-outlined.btn-inverse:hover,
.btn-darkgray25.btn-outlined.btn-inverse:focus,
.btn-darkgray25.btn-outlined.btn-inverse.active {
  color: #dcdbd8;
  background: white;
}
.btn-darkgray25.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgray25.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgray25.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #dcdbd8;
  color: white;
  border-color: #dcdbd8;
}
.btn-darkgray25.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgray25.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgray25.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #b1aea8;
  border-color: #949187;
}
.btn-darkgray25:focus,
.btn-darkgray25.focus,
.btn-darkgray25:hover,
.btn-darkgray25.active {
  color: white;
  background: #f4f4f3;
  border-color: #f4f4f3;
}
.btn-darkgray25:active,
.btn-darkgray25.active,
.btn-darkgray25[aria-expanded="true"],
.btn-darkgray25.active:hover,
.btn-darkgray25.active:focus,
.btn-darkgray25[aria-expanded="true"]:hover,
.btn-darkgray25[aria-expanded="true"]:focus,
.open > .btn-darkgray25.dropdown-toggle {
  color: white;
  background: #b1aea8;
  border-color: #949187;
  background-image: none;
}
.btn-darkgray25.dropdown-toggle + ul li.active a {
  color: white;
  background: #dcdbd8;
}
.btn-darkgray25.disabled,
.btn-darkgray25[disabled],
fieldset[disabled] .btn-darkgray25 {
  pointer-events: none;
}
.btn-darkgray25 .badge {
  color: #dcdbd8;
  background-color: #dcdbd8;
}

.menu-darkgray25 ul li.active a,
.menu-darkgray25 ul li.active a:hover {
  color: white;
  background: #dcdbd8 !important;
}

.nav-darkgray25 > li.active > a,
.nav-darkgray25 > rubix-menu > li.active > a,
.nav-darkgray25 > rubix-nav-item > li.active > a {
  color: white;
  background: #dcdbd8;
  border-color: #dcdbd8;
}

.tab-darkgray25 {
  border-color: #dcdbd8;
}
.tab-darkgray25 > li.active > a {
  border-color: #dcdbd8;
  border-bottom-color: transparent;
}
.tab-darkgray25.nav-pills > li.active > a {
  background: #dcdbd8;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgray25 > li.active > a {
  border: 1px solid #dcdbd8;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkgray25 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgray25 {
  background: #dcdbd8 !important;
}
.bg-darkgray25 table td,
.bg-darkgray25 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgray25:focus {
  background: #dcdbd8 !important;
}

.bg-hover-darkgray25:hover {
  background: #dcdbd8 !important;
}

.fg-darkgray25 {
  color: #dcdbd8;
}
.fg-darkgray25 .nav-tabs > li.active > a {
  color: #dcdbd8;
}

.fg-tab-active-darkgray25 .nav-tabs > li.active > a {
  color: #dcdbd8 !important;
}

.fg-focus-darkgray25:focus {
  color: #dcdbd8;
}

.fg-hover-darkgray25:hover {
  color: #dcdbd8;
}

.border-darkgray25 {
  border-color: #dcdbd8 !important;
}
.border-darkgray25 .rubix-timeline-body > ul {
  border-color: #dcdbd8;
}
.border-darkgray25.rubix-timeline-view:before {
  border-color: #dcdbd8;
}

.border-hover-darkgray25:hover {
  border-color: #dcdbd8 !important;
}

.border-focus-darkgray25:focus {
  border-color: #dcdbd8 !important;
}

.tl-darkgray25 .rubix-timeline-body > ul > li:before {
  border-color: #dcdbd8;
}

.list-bg-darkgray25 > .list-group-item.active {
  background: #dcdbd8 !important;
  color: white !important;
}

.list-fg-darkgray25 > .list-group-item {
  color: #dcdbd8;
}

.btn-lightgray {
  background: #eeedeb;
  color: white;
  border-color: #eeedeb;
}
.btn-lightgray.btn-outlined {
  color: #eeedeb;
  background: none;
}
.btn-lightgray.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightgray.btn-outlined.btn-onlyOnHover:hover,
.btn-lightgray.btn-outlined.btn-onlyOnHover:focus,
.btn-lightgray.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightgray.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightgray.btn-outlined.btn-inverse:hover,
.btn-lightgray.btn-outlined.btn-inverse:focus,
.btn-lightgray.btn-outlined.btn-inverse.active {
  color: #eeedeb;
  background: white;
}
.btn-lightgray.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightgray.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightgray.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #eeedeb;
  color: white;
  border-color: #eeedeb;
}
.btn-lightgray.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightgray.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightgray.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #c4c0b9;
  border-color: #a8a398;
}
.btn-lightgray:focus,
.btn-lightgray.focus,
.btn-lightgray:hover,
.btn-lightgray.active {
  color: white;
  background: white;
  border-color: white;
}
.btn-lightgray:active,
.btn-lightgray.active,
.btn-lightgray[aria-expanded="true"],
.btn-lightgray.active:hover,
.btn-lightgray.active:focus,
.btn-lightgray[aria-expanded="true"]:hover,
.btn-lightgray[aria-expanded="true"]:focus,
.open > .btn-lightgray.dropdown-toggle {
  color: white;
  background: #c4c0b9;
  border-color: #a8a398;
  background-image: none;
}
.btn-lightgray.dropdown-toggle + ul li.active a {
  color: white;
  background: #eeedeb;
}
.btn-lightgray.disabled,
.btn-lightgray[disabled],
fieldset[disabled] .btn-lightgray {
  pointer-events: none;
}
.btn-lightgray .badge {
  color: #eeedeb;
  background-color: #eeedeb;
}

.menu-lightgray ul li.active a,
.menu-lightgray ul li.active a:hover {
  color: white;
  background: #eeedeb !important;
}

.nav-lightgray > li.active > a,
.nav-lightgray > rubix-menu > li.active > a,
.nav-lightgray > rubix-nav-item > li.active > a {
  color: white;
  background: #eeedeb;
  border-color: #eeedeb;
}

.tab-lightgray {
  border-color: #eeedeb;
}
.tab-lightgray > li.active > a {
  border-color: #eeedeb;
  border-bottom-color: transparent;
}
.tab-lightgray.nav-pills > li.active > a {
  background: #eeedeb;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightgray > li.active > a {
  border: 1px solid #eeedeb;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightgray > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightgray {
  background: #eeedeb !important;
}
.bg-lightgray table td,
.bg-lightgray th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightgray:focus {
  background: #eeedeb !important;
}

.bg-hover-lightgray:hover {
  background: #eeedeb !important;
}

.fg-lightgray {
  color: #eeedeb;
}
.fg-lightgray .nav-tabs > li.active > a {
  color: #eeedeb;
}

.fg-tab-active-lightgray .nav-tabs > li.active > a {
  color: #eeedeb !important;
}

.fg-focus-lightgray:focus {
  color: #eeedeb;
}

.fg-hover-lightgray:hover {
  color: #eeedeb;
}

.border-lightgray {
  border-color: #eeedeb !important;
}
.border-lightgray .rubix-timeline-body > ul {
  border-color: #eeedeb;
}
.border-lightgray.rubix-timeline-view:before {
  border-color: #eeedeb;
}

.border-hover-lightgray:hover {
  border-color: #eeedeb !important;
}

.border-focus-lightgray:focus {
  border-color: #eeedeb !important;
}

.tl-lightgray .rubix-timeline-body > ul > li:before {
  border-color: #eeedeb;
}

.list-bg-lightgray > .list-group-item.active {
  background: #eeedeb !important;
  color: white !important;
}

.list-fg-lightgray > .list-group-item {
  color: #eeedeb;
}

.btn-lightgray50 {
  background: #f1f0ee;
  color: white;
  border-color: #f1f0ee;
}
.btn-lightgray50.btn-outlined {
  color: #f1f0ee;
  background: none;
}
.btn-lightgray50.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-lightgray50.btn-outlined.btn-onlyOnHover:hover,
.btn-lightgray50.btn-outlined.btn-onlyOnHover:focus,
.btn-lightgray50.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-lightgray50.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-lightgray50.btn-outlined.btn-inverse:hover,
.btn-lightgray50.btn-outlined.btn-inverse:focus,
.btn-lightgray50.btn-outlined.btn-inverse.active {
  color: #f1f0ee;
  background: white;
}
.btn-lightgray50.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-lightgray50.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-lightgray50.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #f1f0ee;
  color: white;
  border-color: #f1f0ee;
}
.btn-lightgray50.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-lightgray50.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-lightgray50.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #c8c4bc;
  border-color: #aca69a;
}
.btn-lightgray50:focus,
.btn-lightgray50.focus,
.btn-lightgray50:hover,
.btn-lightgray50.active {
  color: white;
  background: white;
  border-color: white;
}
.btn-lightgray50:active,
.btn-lightgray50.active,
.btn-lightgray50[aria-expanded="true"],
.btn-lightgray50.active:hover,
.btn-lightgray50.active:focus,
.btn-lightgray50[aria-expanded="true"]:hover,
.btn-lightgray50[aria-expanded="true"]:focus,
.open > .btn-lightgray50.dropdown-toggle {
  color: white;
  background: #c8c4bc;
  border-color: #aca69a;
  background-image: none;
}
.btn-lightgray50.dropdown-toggle + ul li.active a {
  color: white;
  background: #f1f0ee;
}
.btn-lightgray50.disabled,
.btn-lightgray50[disabled],
fieldset[disabled] .btn-lightgray50 {
  pointer-events: none;
}
.btn-lightgray50 .badge {
  color: #f1f0ee;
  background-color: #f1f0ee;
}

.menu-lightgray50 ul li.active a,
.menu-lightgray50 ul li.active a:hover {
  color: white;
  background: #f1f0ee !important;
}

.nav-lightgray50 > li.active > a,
.nav-lightgray50 > rubix-menu > li.active > a,
.nav-lightgray50 > rubix-nav-item > li.active > a {
  color: white;
  background: #f1f0ee;
  border-color: #f1f0ee;
}

.tab-lightgray50 {
  border-color: #f1f0ee;
}
.tab-lightgray50 > li.active > a {
  border-color: #f1f0ee;
  border-bottom-color: transparent;
}
.tab-lightgray50.nav-pills > li.active > a {
  background: #f1f0ee;
  color: white;
}

.rubix-panel-header.nav-inline .nav-lightgray50 > li.active > a {
  border: 1px solid #f1f0ee;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-lightgray50 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-lightgray50 {
  background: #f1f0ee !important;
}
.bg-lightgray50 table td,
.bg-lightgray50 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-lightgray50:focus {
  background: #f1f0ee !important;
}

.bg-hover-lightgray50:hover {
  background: #f1f0ee !important;
}

.fg-lightgray50 {
  color: #f1f0ee;
}
.fg-lightgray50 .nav-tabs > li.active > a {
  color: #f1f0ee;
}

.fg-tab-active-lightgray50 .nav-tabs > li.active > a {
  color: #f1f0ee !important;
}

.fg-focus-lightgray50:focus {
  color: #f1f0ee;
}

.fg-hover-lightgray50:hover {
  color: #f1f0ee;
}

.border-lightgray50 {
  border-color: #f1f0ee !important;
}
.border-lightgray50 .rubix-timeline-body > ul {
  border-color: #f1f0ee;
}
.border-lightgray50.rubix-timeline-view:before {
  border-color: #f1f0ee;
}

.border-hover-lightgray50:hover {
  border-color: #f1f0ee !important;
}

.border-focus-lightgray50:focus {
  border-color: #f1f0ee !important;
}

.tl-lightgray50 .rubix-timeline-body > ul > li:before {
  border-color: #f1f0ee;
}

.list-bg-lightgray50 > .list-group-item.active {
  background: #f1f0ee !important;
  color: white !important;
}

.list-fg-lightgray50 > .list-group-item {
  color: #f1f0ee;
}

.btn-black75 {
  background: #3f3f3b;
  color: white;
  border-color: #3f3f3b;
}
.btn-black75.btn-outlined {
  color: #3f3f3b;
  background: none;
}
.btn-black75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-black75.btn-outlined.btn-onlyOnHover:hover,
.btn-black75.btn-outlined.btn-onlyOnHover:focus,
.btn-black75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-black75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-black75.btn-outlined.btn-inverse:hover,
.btn-black75.btn-outlined.btn-inverse:focus,
.btn-black75.btn-outlined.btn-inverse.active {
  color: #3f3f3b;
  background: white;
}
.btn-black75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-black75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-black75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #3f3f3b;
  color: white;
  border-color: #3f3f3b;
}
.btn-black75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-black75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-black75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #10100f;
  border-color: black;
}
.btn-black75:focus,
.btn-black75.focus,
.btn-black75:hover,
.btn-black75.active {
  color: white;
  background: #595954;
  border-color: #595954;
}
.btn-black75:active,
.btn-black75.active,
.btn-black75[aria-expanded="true"],
.btn-black75.active:hover,
.btn-black75.active:focus,
.btn-black75[aria-expanded="true"]:hover,
.btn-black75[aria-expanded="true"]:focus,
.open > .btn-black75.dropdown-toggle {
  color: white;
  background: #10100f;
  border-color: black;
  background-image: none;
}
.btn-black75.dropdown-toggle + ul li.active a {
  color: white;
  background: #3f3f3b;
}
.btn-black75.disabled,
.btn-black75[disabled],
fieldset[disabled] .btn-black75 {
  pointer-events: none;
}
.btn-black75 .badge {
  color: #3f3f3b;
  background-color: #3f3f3b;
}

.menu-black75 ul li.active a,
.menu-black75 ul li.active a:hover {
  color: white;
  background: #3f3f3b !important;
}

.nav-black75 > li.active > a,
.nav-black75 > rubix-menu > li.active > a,
.nav-black75 > rubix-nav-item > li.active > a {
  color: white;
  background: #3f3f3b;
  border-color: #3f3f3b;
}

.tab-black75 {
  border-color: #3f3f3b;
}
.tab-black75 > li.active > a {
  border-color: #3f3f3b;
  border-bottom-color: transparent;
}
.tab-black75.nav-pills > li.active > a {
  background: #3f3f3b;
  color: white;
}

.rubix-panel-header.nav-inline .nav-black75 > li.active > a {
  border: 1px solid #3f3f3b;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-black75 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-black75 {
  background: #3f3f3b !important;
}
.bg-black75 table td,
.bg-black75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-black75:focus {
  background: #3f3f3b !important;
}

.bg-hover-black75:hover {
  background: #3f3f3b !important;
}

.fg-black75 {
  color: #3f3f3b;
}
.fg-black75 .nav-tabs > li.active > a {
  color: #3f3f3b;
}

.fg-tab-active-black75 .nav-tabs > li.active > a {
  color: #3f3f3b !important;
}

.fg-focus-black75:focus {
  color: #3f3f3b;
}

.fg-hover-black75:hover {
  color: #3f3f3b;
}

.border-black75 {
  border-color: #3f3f3b !important;
}
.border-black75 .rubix-timeline-body > ul {
  border-color: #3f3f3b;
}
.border-black75.rubix-timeline-view:before {
  border-color: #3f3f3b;
}

.border-hover-black75:hover {
  border-color: #3f3f3b !important;
}

.border-focus-black75:focus {
  border-color: #3f3f3b !important;
}

.tl-black75 .rubix-timeline-body > ul > li:before {
  border-color: #3f3f3b;
}

.list-bg-black75 > .list-group-item.active {
  background: #3f3f3b !important;
  color: white !important;
}

.list-fg-black75 > .list-group-item {
  color: #3f3f3b;
}

.btn-black50 {
  background: #3b4648;
  color: white;
  border-color: #3b4648;
}
.btn-black50.btn-outlined {
  color: #3b4648;
  background: none;
}
.btn-black50.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-black50.btn-outlined.btn-onlyOnHover:hover,
.btn-black50.btn-outlined.btn-onlyOnHover:focus,
.btn-black50.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-black50.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-black50.btn-outlined.btn-inverse:hover,
.btn-black50.btn-outlined.btn-inverse:focus,
.btn-black50.btn-outlined.btn-inverse.active {
  color: #3b4648;
  background: white;
}
.btn-black50.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-black50.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-black50.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #3b4648;
  color: white;
  border-color: #3b4648;
}
.btn-black50.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-black50.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-black50.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #121516;
  border-color: black;
}
.btn-black50:focus,
.btn-black50.focus,
.btn-black50:hover,
.btn-black50.active {
  color: white;
  background: #526164;
  border-color: #526164;
}
.btn-black50:active,
.btn-black50.active,
.btn-black50[aria-expanded="true"],
.btn-black50.active:hover,
.btn-black50.active:focus,
.btn-black50[aria-expanded="true"]:hover,
.btn-black50[aria-expanded="true"]:focus,
.open > .btn-black50.dropdown-toggle {
  color: white;
  background: #121516;
  border-color: black;
  background-image: none;
}
.btn-black50.dropdown-toggle + ul li.active a {
  color: white;
  background: #3b4648;
}
.btn-black50.disabled,
.btn-black50[disabled],
fieldset[disabled] .btn-black50 {
  pointer-events: none;
}
.btn-black50 .badge {
  color: #3b4648;
  background-color: #3b4648;
}

.menu-black50 ul li.active a,
.menu-black50 ul li.active a:hover {
  color: white;
  background: #3b4648 !important;
}

.nav-black50 > li.active > a,
.nav-black50 > rubix-menu > li.active > a,
.nav-black50 > rubix-nav-item > li.active > a {
  color: white;
  background: #3b4648;
  border-color: #3b4648;
}

.tab-black50 {
  border-color: #3b4648;
}
.tab-black50 > li.active > a {
  border-color: #3b4648;
  border-bottom-color: transparent;
}
.tab-black50.nav-pills > li.active > a {
  background: #3b4648;
  color: white;
}

.rubix-panel-header.nav-inline .nav-black50 > li.active > a {
  border: 1px solid #3b4648;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-black50 > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-black50 {
  background: #3b4648 !important;
}
.bg-black50 table td,
.bg-black50 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-black50:focus {
  background: #3b4648 !important;
}

.bg-hover-black50:hover {
  background: #3b4648 !important;
}

.fg-black50 {
  color: #3b4648;
}
.fg-black50 .nav-tabs > li.active > a {
  color: #3b4648;
}

.fg-tab-active-black50 .nav-tabs > li.active > a {
  color: #3b4648 !important;
}

.fg-focus-black50:focus {
  color: #3b4648;
}

.fg-hover-black50:hover {
  color: #3b4648;
}

.border-black50 {
  border-color: #3b4648 !important;
}
.border-black50 .rubix-timeline-body > ul {
  border-color: #3b4648;
}
.border-black50.rubix-timeline-view:before {
  border-color: #3b4648;
}

.border-hover-black50:hover {
  border-color: #3b4648 !important;
}

.border-focus-black50:focus {
  border-color: #3b4648 !important;
}

.tl-black50 .rubix-timeline-body > ul > li:before {
  border-color: #3b4648;
}

.list-bg-black50 > .list-group-item.active {
  background: #3b4648 !important;
  color: white !important;
}

.list-fg-black50 > .list-group-item {
  color: #3b4648;
}

.btn-davygray {
  background: #555555;
  color: white;
  border-color: #555555;
}
.btn-davygray.btn-outlined {
  color: #555555;
  background: none;
}
.btn-davygray.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-davygray.btn-outlined.btn-onlyOnHover:hover,
.btn-davygray.btn-outlined.btn-onlyOnHover:focus,
.btn-davygray.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-davygray.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-davygray.btn-outlined.btn-inverse:hover,
.btn-davygray.btn-outlined.btn-inverse:focus,
.btn-davygray.btn-outlined.btn-inverse.active {
  color: #555555;
  background: white;
}
.btn-davygray.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-davygray.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-davygray.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #555555;
  color: white;
  border-color: #555555;
}
.btn-davygray.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-davygray.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-davygray.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #272727;
  border-color: #090909;
}
.btn-davygray:focus,
.btn-davygray.focus,
.btn-davygray:hover,
.btn-davygray.active {
  color: white;
  background: #6f6f6f;
  border-color: #6f6f6f;
}
.btn-davygray:active,
.btn-davygray.active,
.btn-davygray[aria-expanded="true"],
.btn-davygray.active:hover,
.btn-davygray.active:focus,
.btn-davygray[aria-expanded="true"]:hover,
.btn-davygray[aria-expanded="true"]:focus,
.open > .btn-davygray.dropdown-toggle {
  color: white;
  background: #272727;
  border-color: #090909;
  background-image: none;
}
.btn-davygray.dropdown-toggle + ul li.active a {
  color: white;
  background: #555555;
}
.btn-davygray.disabled,
.btn-davygray[disabled],
fieldset[disabled] .btn-davygray {
  pointer-events: none;
}
.btn-davygray .badge {
  color: #555555;
  background-color: #555555;
}

.menu-davygray ul li.active a,
.menu-davygray ul li.active a:hover {
  color: white;
  background: #555555 !important;
}

.nav-davygray > li.active > a,
.nav-davygray > rubix-menu > li.active > a,
.nav-davygray > rubix-nav-item > li.active > a {
  color: white;
  background: #555555;
  border-color: #555555;
}

.tab-davygray {
  border-color: #555555;
}
.tab-davygray > li.active > a {
  border-color: #555555;
  border-bottom-color: transparent;
}
.tab-davygray.nav-pills > li.active > a {
  background: #555555;
  color: white;
}

.rubix-panel-header.nav-inline .nav-davygray > li.active > a {
  border: 1px solid #555555;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-davygray > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-davygray {
  background: #555555 !important;
}
.bg-davygray table td,
.bg-davygray th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-davygray:focus {
  background: #555555 !important;
}

.bg-hover-davygray:hover {
  background: #555555 !important;
}

.fg-davygray {
  color: #555555;
}
.fg-davygray .nav-tabs > li.active > a {
  color: #555555;
}

.fg-tab-active-davygray .nav-tabs > li.active > a {
  color: #555555 !important;
}

.fg-focus-davygray:focus {
  color: #555555;
}

.fg-hover-davygray:hover {
  color: #555555;
}

.border-davygray {
  border-color: #555555 !important;
}
.border-davygray .rubix-timeline-body > ul {
  border-color: #555555;
}
.border-davygray.rubix-timeline-view:before {
  border-color: #555555;
}

.border-hover-davygray:hover {
  border-color: #555555 !important;
}

.border-focus-davygray:focus {
  border-color: #555555 !important;
}

.tl-davygray .rubix-timeline-body > ul > li:before {
  border-color: #555555;
}

.list-bg-davygray > .list-group-item.active {
  background: #555555 !important;
  color: white !important;
}

.list-fg-davygray > .list-group-item {
  color: #555555;
}

.btn-darkgrayishblue75 {
  background: #43525a;
  color: white;
  border-color: #43525a;
}
.btn-darkgrayishblue75.btn-outlined {
  color: #43525a;
  background: none;
}
.btn-darkgrayishblue75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgrayishblue75.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgrayishblue75.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgrayishblue75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgrayishblue75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgrayishblue75.btn-outlined.btn-inverse:hover,
.btn-darkgrayishblue75.btn-outlined.btn-inverse:focus,
.btn-darkgrayishblue75.btn-outlined.btn-inverse.active {
  color: #43525a;
  background: white;
}
.btn-darkgrayishblue75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgrayishblue75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgrayishblue75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #43525a;
  color: white;
  border-color: #43525a;
}
.btn-darkgrayishblue75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgrayishblue75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgrayishblue75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #1c2225;
  border-color: #020202;
}
.btn-darkgrayishblue75:focus,
.btn-darkgrayishblue75.focus,
.btn-darkgrayishblue75:hover,
.btn-darkgrayishblue75.active {
  color: white;
  background: #596d77;
  border-color: #596d77;
}
.btn-darkgrayishblue75:active,
.btn-darkgrayishblue75.active,
.btn-darkgrayishblue75[aria-expanded="true"],
.btn-darkgrayishblue75.active:hover,
.btn-darkgrayishblue75.active:focus,
.btn-darkgrayishblue75[aria-expanded="true"]:hover,
.btn-darkgrayishblue75[aria-expanded="true"]:focus,
.open > .btn-darkgrayishblue75.dropdown-toggle {
  color: white;
  background: #1c2225;
  border-color: #020202;
  background-image: none;
}
.btn-darkgrayishblue75.dropdown-toggle + ul li.active a {
  color: white;
  background: #43525a;
}
.btn-darkgrayishblue75.disabled,
.btn-darkgrayishblue75[disabled],
fieldset[disabled] .btn-darkgrayishblue75 {
  pointer-events: none;
}
.btn-darkgrayishblue75 .badge {
  color: #43525a;
  background-color: #43525a;
}

.menu-darkgrayishblue75 ul li.active a,
.menu-darkgrayishblue75 ul li.active a:hover {
  color: white;
  background: #43525a !important;
}

.nav-darkgrayishblue75 > li.active > a,
.nav-darkgrayishblue75 > rubix-menu > li.active > a,
.nav-darkgrayishblue75 > rubix-nav-item > li.active > a {
  color: white;
  background: #43525a;
  border-color: #43525a;
}

.tab-darkgrayishblue75 {
  border-color: #43525a;
}
.tab-darkgrayishblue75 > li.active > a {
  border-color: #43525a;
  border-bottom-color: transparent;
}
.tab-darkgrayishblue75.nav-pills > li.active > a {
  background: #43525a;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgrayishblue75 > li.active > a {
  border: 1px solid #43525a;
  border-bottom: none;
}

.rubix-panel-header.nav-inline
  .nav-darkgrayishblue75
  > li.open
  > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgrayishblue75 {
  background: #43525a !important;
}
.bg-darkgrayishblue75 table td,
.bg-darkgrayishblue75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgrayishblue75:focus {
  background: #43525a !important;
}

.bg-hover-darkgrayishblue75:hover {
  background: #43525a !important;
}

.fg-darkgrayishblue75 {
  color: #43525a;
}
.fg-darkgrayishblue75 .nav-tabs > li.active > a {
  color: #43525a;
}

.fg-tab-active-darkgrayishblue75 .nav-tabs > li.active > a {
  color: #43525a !important;
}

.fg-focus-darkgrayishblue75:focus {
  color: #43525a;
}

.fg-hover-darkgrayishblue75:hover {
  color: #43525a;
}

.border-darkgrayishblue75 {
  border-color: #43525a !important;
}
.border-darkgrayishblue75 .rubix-timeline-body > ul {
  border-color: #43525a;
}
.border-darkgrayishblue75.rubix-timeline-view:before {
  border-color: #43525a;
}

.border-hover-darkgrayishblue75:hover {
  border-color: #43525a !important;
}

.border-focus-darkgrayishblue75:focus {
  border-color: #43525a !important;
}

.tl-darkgrayishblue75 .rubix-timeline-body > ul > li:before {
  border-color: #43525a;
}

.list-bg-darkgrayishblue75 > .list-group-item.active {
  background: #43525a !important;
  color: white !important;
}

.list-fg-darkgrayishblue75 > .list-group-item {
  color: #43525a;
}

.btn-darkgrayishblue {
  background: #4c5d67;
  color: white;
  border-color: #4c5d67;
}
.btn-darkgrayishblue.btn-outlined {
  color: #4c5d67;
  background: none;
}
.btn-darkgrayishblue.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkgrayishblue.btn-outlined.btn-onlyOnHover:hover,
.btn-darkgrayishblue.btn-outlined.btn-onlyOnHover:focus,
.btn-darkgrayishblue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkgrayishblue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkgrayishblue.btn-outlined.btn-inverse:hover,
.btn-darkgrayishblue.btn-outlined.btn-inverse:focus,
.btn-darkgrayishblue.btn-outlined.btn-inverse.active {
  color: #4c5d67;
  background: white;
}
.btn-darkgrayishblue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkgrayishblue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkgrayishblue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #4c5d67;
  color: white;
  border-color: #4c5d67;
}
.btn-darkgrayishblue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkgrayishblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkgrayishblue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #252d32;
  border-color: #0b0e0f;
}
.btn-darkgrayishblue:focus,
.btn-darkgrayishblue.focus,
.btn-darkgrayishblue:hover,
.btn-darkgrayishblue.active {
  color: white;
  background: #627784;
  border-color: #627784;
}
.btn-darkgrayishblue:active,
.btn-darkgrayishblue.active,
.btn-darkgrayishblue[aria-expanded="true"],
.btn-darkgrayishblue.active:hover,
.btn-darkgrayishblue.active:focus,
.btn-darkgrayishblue[aria-expanded="true"]:hover,
.btn-darkgrayishblue[aria-expanded="true"]:focus,
.open > .btn-darkgrayishblue.dropdown-toggle {
  color: white;
  background: #252d32;
  border-color: #0b0e0f;
  background-image: none;
}
.btn-darkgrayishblue.dropdown-toggle + ul li.active a {
  color: white;
  background: #4c5d67;
}
.btn-darkgrayishblue.disabled,
.btn-darkgrayishblue[disabled],
fieldset[disabled] .btn-darkgrayishblue {
  pointer-events: none;
}
.btn-darkgrayishblue .badge {
  color: #4c5d67;
  background-color: #4c5d67;
}

.menu-darkgrayishblue ul li.active a,
.menu-darkgrayishblue ul li.active a:hover {
  color: white;
  background: #4c5d67 !important;
}

.nav-darkgrayishblue > li.active > a,
.nav-darkgrayishblue > rubix-menu > li.active > a,
.nav-darkgrayishblue > rubix-nav-item > li.active > a {
  color: white;
  background: #4c5d67;
  border-color: #4c5d67;
}

.tab-darkgrayishblue {
  border-color: #4c5d67;
}
.tab-darkgrayishblue > li.active > a {
  border-color: #4c5d67;
  border-bottom-color: transparent;
}
.tab-darkgrayishblue.nav-pills > li.active > a {
  background: #4c5d67;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkgrayishblue > li.active > a {
  border: 1px solid #4c5d67;
  border-bottom: none;
}

.rubix-panel-header.nav-inline
  .nav-darkgrayishblue
  > li.open
  > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkgrayishblue {
  background: #4c5d67 !important;
}
.bg-darkgrayishblue table td,
.bg-darkgrayishblue th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkgrayishblue:focus {
  background: #4c5d67 !important;
}

.bg-hover-darkgrayishblue:hover {
  background: #4c5d67 !important;
}

.fg-darkgrayishblue {
  color: #4c5d67;
}
.fg-darkgrayishblue .nav-tabs > li.active > a {
  color: #4c5d67;
}

.fg-tab-active-darkgrayishblue .nav-tabs > li.active > a {
  color: #4c5d67 !important;
}

.fg-focus-darkgrayishblue:focus {
  color: #4c5d67;
}

.fg-hover-darkgrayishblue:hover {
  color: #4c5d67;
}

.border-darkgrayishblue {
  border-color: #4c5d67 !important;
}
.border-darkgrayishblue .rubix-timeline-body > ul {
  border-color: #4c5d67;
}
.border-darkgrayishblue.rubix-timeline-view:before {
  border-color: #4c5d67;
}

.border-hover-darkgrayishblue:hover {
  border-color: #4c5d67 !important;
}

.border-focus-darkgrayishblue:focus {
  border-color: #4c5d67 !important;
}

.tl-darkgrayishblue .rubix-timeline-body > ul > li:before {
  border-color: #4c5d67;
}

.list-bg-darkgrayishblue > .list-group-item.active {
  background: #4c5d67 !important;
  color: white !important;
}

.list-fg-darkgrayishblue > .list-group-item {
  color: #4c5d67;
}

.btn-desaturateddarkblue {
  background: #515e78;
  color: white;
  border-color: #515e78;
}
.btn-desaturateddarkblue.btn-outlined {
  color: #515e78;
  background: none;
}
.btn-desaturateddarkblue.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-desaturateddarkblue.btn-outlined.btn-onlyOnHover:hover,
.btn-desaturateddarkblue.btn-outlined.btn-onlyOnHover:focus,
.btn-desaturateddarkblue.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-desaturateddarkblue.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-desaturateddarkblue.btn-outlined.btn-inverse:hover,
.btn-desaturateddarkblue.btn-outlined.btn-inverse:focus,
.btn-desaturateddarkblue.btn-outlined.btn-inverse.active {
  color: #515e78;
  background: white;
}
.btn-desaturateddarkblue.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-desaturateddarkblue.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-desaturateddarkblue.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #515e78;
  color: white;
  border-color: #515e78;
}
.btn-desaturateddarkblue.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-desaturateddarkblue.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-desaturateddarkblue.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #2c3341;
  border-color: #13161d;
}
.btn-desaturateddarkblue:focus,
.btn-desaturateddarkblue.focus,
.btn-desaturateddarkblue:hover,
.btn-desaturateddarkblue.active {
  color: white;
  background: #667696;
  border-color: #667696;
}
.btn-desaturateddarkblue:active,
.btn-desaturateddarkblue.active,
.btn-desaturateddarkblue[aria-expanded="true"],
.btn-desaturateddarkblue.active:hover,
.btn-desaturateddarkblue.active:focus,
.btn-desaturateddarkblue[aria-expanded="true"]:hover,
.btn-desaturateddarkblue[aria-expanded="true"]:focus,
.open > .btn-desaturateddarkblue.dropdown-toggle {
  color: white;
  background: #2c3341;
  border-color: #13161d;
  background-image: none;
}
.btn-desaturateddarkblue.dropdown-toggle + ul li.active a {
  color: white;
  background: #515e78;
}
.btn-desaturateddarkblue.disabled,
.btn-desaturateddarkblue[disabled],
fieldset[disabled] .btn-desaturateddarkblue {
  pointer-events: none;
}
.btn-desaturateddarkblue .badge {
  color: #515e78;
  background-color: #515e78;
}

.menu-desaturateddarkblue ul li.active a,
.menu-desaturateddarkblue ul li.active a:hover {
  color: white;
  background: #515e78 !important;
}

.nav-desaturateddarkblue > li.active > a,
.nav-desaturateddarkblue > rubix-menu > li.active > a,
.nav-desaturateddarkblue > rubix-nav-item > li.active > a {
  color: white;
  background: #515e78;
  border-color: #515e78;
}

.tab-desaturateddarkblue {
  border-color: #515e78;
}
.tab-desaturateddarkblue > li.active > a {
  border-color: #515e78;
  border-bottom-color: transparent;
}
.tab-desaturateddarkblue.nav-pills > li.active > a {
  background: #515e78;
  color: white;
}

.rubix-panel-header.nav-inline .nav-desaturateddarkblue > li.active > a {
  border: 1px solid #515e78;
  border-bottom: none;
}

.rubix-panel-header.nav-inline
  .nav-desaturateddarkblue
  > li.open
  > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-desaturateddarkblue {
  background: #515e78 !important;
}
.bg-desaturateddarkblue table td,
.bg-desaturateddarkblue th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-desaturateddarkblue:focus {
  background: #515e78 !important;
}

.bg-hover-desaturateddarkblue:hover {
  background: #515e78 !important;
}

.fg-desaturateddarkblue {
  color: #515e78;
}
.fg-desaturateddarkblue .nav-tabs > li.active > a {
  color: #515e78;
}

.fg-tab-active-desaturateddarkblue .nav-tabs > li.active > a {
  color: #515e78 !important;
}

.fg-focus-desaturateddarkblue:focus {
  color: #515e78;
}

.fg-hover-desaturateddarkblue:hover {
  color: #515e78;
}

.border-desaturateddarkblue {
  border-color: #515e78 !important;
}
.border-desaturateddarkblue .rubix-timeline-body > ul {
  border-color: #515e78;
}
.border-desaturateddarkblue.rubix-timeline-view:before {
  border-color: #515e78;
}

.border-hover-desaturateddarkblue:hover {
  border-color: #515e78 !important;
}

.border-focus-desaturateddarkblue:focus {
  border-color: #515e78 !important;
}

.tl-desaturateddarkblue .rubix-timeline-body > ul > li:before {
  border-color: #515e78;
}

.list-bg-desaturateddarkblue > .list-group-item.active {
  background: #515e78 !important;
  color: white !important;
}

.list-fg-desaturateddarkblue > .list-group-item {
  color: #515e78;
}

.btn-desaturateddarkblue75 {
  background: #3b465c;
  color: white;
  border-color: #3b465c;
}
.btn-desaturateddarkblue75.btn-outlined {
  color: #3b465c;
  background: none;
}
.btn-desaturateddarkblue75.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-desaturateddarkblue75.btn-outlined.btn-onlyOnHover:hover,
.btn-desaturateddarkblue75.btn-outlined.btn-onlyOnHover:focus,
.btn-desaturateddarkblue75.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-desaturateddarkblue75.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-desaturateddarkblue75.btn-outlined.btn-inverse:hover,
.btn-desaturateddarkblue75.btn-outlined.btn-inverse:focus,
.btn-desaturateddarkblue75.btn-outlined.btn-inverse.active {
  color: #3b465c;
  background: white;
}
.btn-desaturateddarkblue75.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-desaturateddarkblue75.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-desaturateddarkblue75.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #3b465c;
  color: white;
  border-color: #3b465c;
}
.btn-desaturateddarkblue75.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-desaturateddarkblue75.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-desaturateddarkblue75.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #171b24;
  border-color: black;
}
.btn-desaturateddarkblue75:focus,
.btn-desaturateddarkblue75.focus,
.btn-desaturateddarkblue75:hover,
.btn-desaturateddarkblue75.active {
  color: white;
  background: #4f5e7b;
  border-color: #4f5e7b;
}
.btn-desaturateddarkblue75:active,
.btn-desaturateddarkblue75.active,
.btn-desaturateddarkblue75[aria-expanded="true"],
.btn-desaturateddarkblue75.active:hover,
.btn-desaturateddarkblue75.active:focus,
.btn-desaturateddarkblue75[aria-expanded="true"]:hover,
.btn-desaturateddarkblue75[aria-expanded="true"]:focus,
.open > .btn-desaturateddarkblue75.dropdown-toggle {
  color: white;
  background: #171b24;
  border-color: black;
  background-image: none;
}
.btn-desaturateddarkblue75.dropdown-toggle + ul li.active a {
  color: white;
  background: #3b465c;
}
.btn-desaturateddarkblue75.disabled,
.btn-desaturateddarkblue75[disabled],
fieldset[disabled] .btn-desaturateddarkblue75 {
  pointer-events: none;
}
.btn-desaturateddarkblue75 .badge {
  color: #3b465c;
  background-color: #3b465c;
}

.menu-desaturateddarkblue75 ul li.active a,
.menu-desaturateddarkblue75 ul li.active a:hover {
  color: white;
  background: #3b465c !important;
}

.nav-desaturateddarkblue75 > li.active > a,
.nav-desaturateddarkblue75 > rubix-menu > li.active > a,
.nav-desaturateddarkblue75 > rubix-nav-item > li.active > a {
  color: white;
  background: #3b465c;
  border-color: #3b465c;
}

.tab-desaturateddarkblue75 {
  border-color: #3b465c;
}
.tab-desaturateddarkblue75 > li.active > a {
  border-color: #3b465c;
  border-bottom-color: transparent;
}
.tab-desaturateddarkblue75.nav-pills > li.active > a {
  background: #3b465c;
  color: white;
}

.rubix-panel-header.nav-inline .nav-desaturateddarkblue75 > li.active > a {
  border: 1px solid #3b465c;
  border-bottom: none;
}

.rubix-panel-header.nav-inline
  .nav-desaturateddarkblue75
  > li.open
  > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-desaturateddarkblue75 {
  background: #3b465c !important;
}
.bg-desaturateddarkblue75 table td,
.bg-desaturateddarkblue75 th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-desaturateddarkblue75:focus {
  background: #3b465c !important;
}

.bg-hover-desaturateddarkblue75:hover {
  background: #3b465c !important;
}

.fg-desaturateddarkblue75 {
  color: #3b465c;
}
.fg-desaturateddarkblue75 .nav-tabs > li.active > a {
  color: #3b465c;
}

.fg-tab-active-desaturateddarkblue75 .nav-tabs > li.active > a {
  color: #3b465c !important;
}

.fg-focus-desaturateddarkblue75:focus {
  color: #3b465c;
}

.fg-hover-desaturateddarkblue75:hover {
  color: #3b465c;
}

.border-desaturateddarkblue75 {
  border-color: #3b465c !important;
}
.border-desaturateddarkblue75 .rubix-timeline-body > ul {
  border-color: #3b465c;
}
.border-desaturateddarkblue75.rubix-timeline-view:before {
  border-color: #3b465c;
}

.border-hover-desaturateddarkblue75:hover {
  border-color: #3b465c !important;
}

.border-focus-desaturateddarkblue75:focus {
  border-color: #3b465c !important;
}

.tl-desaturateddarkblue75 .rubix-timeline-body > ul > li:before {
  border-color: #3b465c;
}

.list-bg-desaturateddarkblue75 > .list-group-item.active {
  background: #3b465c !important;
  color: white !important;
}

.list-fg-desaturateddarkblue75 > .list-group-item {
  color: #3b465c;
}

.btn-darkcyan {
  background: #68a0a5;
  color: white;
  border-color: #68a0a5;
}
.btn-darkcyan.btn-outlined {
  color: #68a0a5;
  background: none;
}
.btn-darkcyan.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-darkcyan.btn-outlined.btn-onlyOnHover:hover,
.btn-darkcyan.btn-outlined.btn-onlyOnHover:focus,
.btn-darkcyan.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-darkcyan.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-darkcyan.btn-outlined.btn-inverse:hover,
.btn-darkcyan.btn-outlined.btn-inverse:focus,
.btn-darkcyan.btn-outlined.btn-inverse.active {
  color: #68a0a5;
  background: white;
}
.btn-darkcyan.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-darkcyan.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-darkcyan.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #68a0a5;
  color: white;
  border-color: #68a0a5;
}
.btn-darkcyan.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-darkcyan.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-darkcyan.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #426b6f;
  border-color: #2b4649;
}
.btn-darkcyan:focus,
.btn-darkcyan.focus,
.btn-darkcyan:hover,
.btn-darkcyan.active {
  color: white;
  background: #88b4b8;
  border-color: #88b4b8;
}
.btn-darkcyan:active,
.btn-darkcyan.active,
.btn-darkcyan[aria-expanded="true"],
.btn-darkcyan.active:hover,
.btn-darkcyan.active:focus,
.btn-darkcyan[aria-expanded="true"]:hover,
.btn-darkcyan[aria-expanded="true"]:focus,
.open > .btn-darkcyan.dropdown-toggle {
  color: white;
  background: #426b6f;
  border-color: #2b4649;
  background-image: none;
}
.btn-darkcyan.dropdown-toggle + ul li.active a {
  color: white;
  background: #68a0a5;
}
.btn-darkcyan.disabled,
.btn-darkcyan[disabled],
fieldset[disabled] .btn-darkcyan {
  pointer-events: none;
}
.btn-darkcyan .badge {
  color: #68a0a5;
  background-color: #68a0a5;
}

.menu-darkcyan ul li.active a,
.menu-darkcyan ul li.active a:hover {
  color: white;
  background: #68a0a5 !important;
}

.nav-darkcyan > li.active > a,
.nav-darkcyan > rubix-menu > li.active > a,
.nav-darkcyan > rubix-nav-item > li.active > a {
  color: white;
  background: #68a0a5;
  border-color: #68a0a5;
}

.tab-darkcyan {
  border-color: #68a0a5;
}
.tab-darkcyan > li.active > a {
  border-color: #68a0a5;
  border-bottom-color: transparent;
}
.tab-darkcyan.nav-pills > li.active > a {
  background: #68a0a5;
  color: white;
}

.rubix-panel-header.nav-inline .nav-darkcyan > li.active > a {
  border: 1px solid #68a0a5;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-darkcyan > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-darkcyan {
  background: #68a0a5 !important;
}
.bg-darkcyan table td,
.bg-darkcyan th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-darkcyan:focus {
  background: #68a0a5 !important;
}

.bg-hover-darkcyan:hover {
  background: #68a0a5 !important;
}

.fg-darkcyan {
  color: #68a0a5;
}
.fg-darkcyan .nav-tabs > li.active > a {
  color: #68a0a5;
}

.fg-tab-active-darkcyan .nav-tabs > li.active > a {
  color: #68a0a5 !important;
}

.fg-focus-darkcyan:focus {
  color: #68a0a5;
}

.fg-hover-darkcyan:hover {
  color: #68a0a5;
}

.border-darkcyan {
  border-color: #68a0a5 !important;
}
.border-darkcyan .rubix-timeline-body > ul {
  border-color: #68a0a5;
}
.border-darkcyan.rubix-timeline-view:before {
  border-color: #68a0a5;
}

.border-hover-darkcyan:hover {
  border-color: #68a0a5 !important;
}

.border-focus-darkcyan:focus {
  border-color: #68a0a5 !important;
}

.tl-darkcyan .rubix-timeline-body > ul > li:before {
  border-color: #68a0a5;
}

.list-bg-darkcyan > .list-group-item.active {
  background: #68a0a5 !important;
  color: white !important;
}

.list-fg-darkcyan > .list-group-item {
  color: #68a0a5;
}

.btn-grayishcyan {
  background: #92bdc1;
  color: white;
  border-color: #92bdc1;
}
.btn-grayishcyan.btn-outlined {
  color: #92bdc1;
  background: none;
}
.btn-grayishcyan.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
.btn-grayishcyan.btn-outlined.btn-onlyOnHover:hover,
.btn-grayishcyan.btn-outlined.btn-onlyOnHover:focus,
.btn-grayishcyan.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
.btn-grayishcyan.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
.btn-grayishcyan.btn-outlined.btn-inverse:hover,
.btn-grayishcyan.btn-outlined.btn-inverse:focus,
.btn-grayishcyan.btn-outlined.btn-inverse.active {
  color: #92bdc1;
  background: white;
}
.btn-grayishcyan.btn-outlined.btn-inverse:hover.btn-retainBg,
.btn-grayishcyan.btn-outlined.btn-inverse:focus.btn-retainBg,
.btn-grayishcyan.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #92bdc1;
  color: white;
  border-color: #92bdc1;
}
.btn-grayishcyan.btn-outlined.btn-inverse:hover.btn-retainBg:active,
.btn-grayishcyan.btn-outlined.btn-inverse:focus.btn-retainBg:active,
.btn-grayishcyan.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #5a989e;
  border-color: #437277;
}
.btn-grayishcyan:focus,
.btn-grayishcyan.focus,
.btn-grayishcyan:hover,
.btn-grayishcyan.active {
  color: white;
  background: #b3d1d3;
  border-color: #b3d1d3;
}
.btn-grayishcyan:active,
.btn-grayishcyan.active,
.btn-grayishcyan[aria-expanded="true"],
.btn-grayishcyan.active:hover,
.btn-grayishcyan.active:focus,
.btn-grayishcyan[aria-expanded="true"]:hover,
.btn-grayishcyan[aria-expanded="true"]:focus,
.open > .btn-grayishcyan.dropdown-toggle {
  color: white;
  background: #5a989e;
  border-color: #437277;
  background-image: none;
}
.btn-grayishcyan.dropdown-toggle + ul li.active a {
  color: white;
  background: #92bdc1;
}
.btn-grayishcyan.disabled,
.btn-grayishcyan[disabled],
fieldset[disabled] .btn-grayishcyan {
  pointer-events: none;
}
.btn-grayishcyan .badge {
  color: #92bdc1;
  background-color: #92bdc1;
}

.menu-grayishcyan ul li.active a,
.menu-grayishcyan ul li.active a:hover {
  color: white;
  background: #92bdc1 !important;
}

.nav-grayishcyan > li.active > a,
.nav-grayishcyan > rubix-menu > li.active > a,
.nav-grayishcyan > rubix-nav-item > li.active > a {
  color: white;
  background: #92bdc1;
  border-color: #92bdc1;
}

.tab-grayishcyan {
  border-color: #92bdc1;
}
.tab-grayishcyan > li.active > a {
  border-color: #92bdc1;
  border-bottom-color: transparent;
}
.tab-grayishcyan.nav-pills > li.active > a {
  background: #92bdc1;
  color: white;
}

.rubix-panel-header.nav-inline .nav-grayishcyan > li.active > a {
  border: 1px solid #92bdc1;
  border-bottom: none;
}

.rubix-panel-header.nav-inline .nav-grayishcyan > li.open > .dropdown-toggle {
  color: white;
  background: none;
}

.bg-grayishcyan {
  background: #92bdc1 !important;
}
.bg-grayishcyan table td,
.bg-grayishcyan th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

.bg-focus-grayishcyan:focus {
  background: #92bdc1 !important;
}

.bg-hover-grayishcyan:hover {
  background: #92bdc1 !important;
}

.fg-grayishcyan {
  color: #92bdc1;
}
.fg-grayishcyan .nav-tabs > li.active > a {
  color: #92bdc1;
}

.fg-tab-active-grayishcyan .nav-tabs > li.active > a {
  color: #92bdc1 !important;
}

.fg-focus-grayishcyan:focus {
  color: #92bdc1;
}

.fg-hover-grayishcyan:hover {
  color: #92bdc1;
}

.border-grayishcyan {
  border-color: #92bdc1 !important;
}
.border-grayishcyan .rubix-timeline-body > ul {
  border-color: #92bdc1;
}
.border-grayishcyan.rubix-timeline-view:before {
  border-color: #92bdc1;
}

.border-hover-grayishcyan:hover {
  border-color: #92bdc1 !important;
}

.border-focus-grayishcyan:focus {
  border-color: #92bdc1 !important;
}

.tl-grayishcyan .rubix-timeline-body > ul > li:before {
  border-color: #92bdc1;
}

.list-bg-grayishcyan > .list-group-item.active {
  background: #92bdc1 !important;
  color: white !important;
}

.list-fg-grayishcyan > .list-group-item {
  color: #92bdc1;
}

/* ADD/REMOVE/CHANGE THEMES HERE */
/* GLOBAL SETTINGS */
html {
  letter-spacing: 0.5px;
}
::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}

a {
  color: #2eb398;
}
a:hover,
a:focus {
  color: #248a76;
}

.rubix-panel-container {
  background: #ffffff;
}
.rubix-panel-container.bordered {
  border: 1px solid rgba(206, 219, 236, 0.75);
  -webkit-box-shadow: 0px 2px 0px 0px rgba(206, 219, 236, 0.5);
          box-shadow: 0px 2px 0px 0px rgba(206, 219, 236, 0.5);
}
.rubix-panel-container.noOverflow {
  overflow: visible;
}

.rubix-panel-controls {
  color: #89949b;
}

html.default .form-control {
  border-color: #fff;
}
html.default .form-control:focus {
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  border-color: #079EDA;
}

html.default .dropdown-menu .active > a {
  background-color: #e76049;
}
html.default .dropdown-menu .active > a:hover,
html.default .dropdown-menu .active > a:focus {
  background-color: #e76049;
}

html.default .select2-container-multi .select2-choices {
  border-radius: 0;
  height: 25px;
}

html.default .select2-container .select2-choice,
html.default .select2-container-multi .select2-choices {
  border-width: 2px;
}

html.default .select2-container .select2-choice .select2-arrow {
  color: white;
  border-radius: 0;
}

html.default .select2-drop-active,
html.default .select2-drop.select2-drop-above.select2-drop-active,
html.default .select2-container-active .select2-choice,
html.default .select2-container-active .select2-choices,
html.default .select2-dropdown-open.select2-drop-above .select2-choice,
html.default .select2-dropdown-open.select2-drop-above .select2-choices,
html.default .select2-container-multi.select2-container-active .select2-choices,
html.default .form-control.select2-container.select2-dropdown-open {
  border-width: 2px;
}

html.default .pagination {
  margin: 0 0 25px;
}
html.default .pagination .disabled > a {
  color: #ccc;
}

html.default .pagination > .active > a,
html.default .pagination > .active > a:hover,
html.default .pagination > .active > a:focus,
html.default .pagination > .active > span,
html.default .pagination > .active > span:hover,
html.default .pagination > .active > span:focus {
  color: white;
  /* background: #e76049; */
  /* border-color: #e76049; */
}

html.default .pagination > li > a,
html.default .pagination > li > span {
  color: inherit;
}

html.default .rubix-panel .pagination > li > a {
  border: 1px solid #ddd;
}

html.default .datepicker table tr td.active,
html.default .datepicker table tr td.active:hover,
html.default .datepicker table tr td.active.disabled,
html.default .datepicker table tr td.active.disabled:hover,
html.default .datepicker table tr td span.active,
html.default .datepicker table tr td span.active:hover,
html.default .datepicker table tr td span.active.disabled,
html.default .datepicker table tr td span.active.disabled:hover {
  background: #e76049 !important;
}

html.default .breadcrumb > li > a {
  color: #e76049;
}
html.default .breadcrumb > li > a:hover,
html.default .breadcrumb > li > a:focus {
  color: #c9341b;
}

html.default .btn-theme {
  background: #e76049;
  color: white;
  border-color: #e76049;
}
html.default .btn-theme.btn-outlined {
  color: #e76049;
  background: none;
}
html.default .btn-theme.btn-outlined.btn-onlyOnHover {
  color: #89949b;
}
html.default .btn-theme.btn-outlined.btn-onlyOnHover:hover,
html.default .btn-theme.btn-outlined.btn-onlyOnHover:focus,
html.default .btn-theme.btn-outlined.btn-onlyOnHover.active {
  color: white;
}
html.default .btn-theme.btn-outlined.btn-inverse {
  color: white;
  border-color: white;
}
html.default .btn-theme.btn-outlined.btn-inverse:hover,
html.default .btn-theme.btn-outlined.btn-inverse:focus,
html.default .btn-theme.btn-outlined.btn-inverse.active {
  color: #e76049;
  background: white;
}
html.default .btn-theme.btn-outlined.btn-inverse:hover.btn-retainBg,
html.default .btn-theme.btn-outlined.btn-inverse:focus.btn-retainBg,
html.default .btn-theme.btn-outlined.btn-inverse.active.btn-retainBg {
  background: #e76049;
  color: white;
  border-color: #e76049;
}
html.default .btn-theme.btn-outlined.btn-inverse:hover.btn-retainBg:active,
html.default .btn-theme.btn-outlined.btn-inverse:focus.btn-retainBg:active,
html.default .btn-theme.btn-outlined.btn-inverse.active.btn-retainBg:active {
  background: #bb3019;
  border-color: #852212;
}
html.default .btn-theme:focus,
html.default .btn-theme.focus,
html.default .btn-theme:hover,
html.default .btn-theme.active {
  color: white;
  background: #ed8776;
  border-color: #ed8776;
}
html.default .btn-theme:active,
html.default .btn-theme.active,
html.default .btn-theme[aria-expanded="true"],
html.default .btn-theme.active:hover,
html.default .btn-theme.active:focus,
html.default .btn-theme[aria-expanded="true"]:hover,
html.default .btn-theme[aria-expanded="true"]:focus,
.open > html.default .btn-theme.dropdown-toggle {
  color: white;
  background: #bb3019;
  border-color: #852212;
  background-image: none;
}
html.default .btn-theme.dropdown-toggle + ul li.active a {
  color: white;
  background: #e76049;
}
html.default .btn-theme.disabled,
html.default .btn-theme[disabled],
fieldset[disabled] html.default .btn-theme {
  pointer-events: none;
}
html.default .btn-theme .badge {
  color: #e76049;
  background-color: #e76049;
}

html.default .menu-theme ul li.active a,
html.default .menu-theme ul li.active a:hover {
  color: white;
  background: #e76049 !important;
}

html.default .nav-theme > li.active > a,
html.default .nav-theme > rubix-menu > li.active > a,
html.default .nav-theme > rubix-nav-item > li.active > a {
  color: white;
  background: #e76049;
  border-color: #e76049;
}

html.default .tab-theme {
  border-color: #e76049;
}
html.default .tab-theme > li.active > a {
  border-color: #e76049;
  border-bottom-color: transparent;
}
html.default .tab-theme.nav-pills > li.active > a {
  background: #e76049;
  color: white;
}

html.default .rubix-panel-header.nav-inline .nav-theme > li.active > a {
  border: 1px solid #e76049;
  border-bottom: none;
}

html.default
  .rubix-panel-header.nav-inline
  .nav-theme
  > li.open
  > .dropdown-toggle {
  color: white;
  background: none;
}

html.default .bg-theme {
  background: #e76049 !important;
}
html.default .bg-theme table td,
html.default .bg-theme th {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

html.default .bg-focus-theme:focus {
  background: #e76049 !important;
}

html.default .bg-hover-theme:hover {
  background: #e76049 !important;
}

html.default .fg-theme {
  color: #e76049;
}
html.default .fg-theme .nav-tabs > li.active > a {
  color: #e76049;
}

html.default .fg-tab-active-theme .nav-tabs > li.active > a {
  color: #e76049 !important;
}

html.default .fg-focus-theme:focus {
  color: #e76049;
}

html.default .fg-hover-theme:hover {
  color: #e76049;
}

html.default .border-theme {
  border-color: #e76049 !important;
}
html.default .border-theme .rubix-timeline-body > ul {
  border-color: #e76049;
}
html.default .border-theme.rubix-timeline-view:before {
  border-color: #e76049;
}

html.default .border-hover-theme:hover {
  border-color: #e76049 !important;
}

html.default .border-focus-theme:focus {
  border-color: #e76049 !important;
}

html.default .tl-theme .rubix-timeline-body > ul > li:before {
  border-color: #e76049;
}

html.default .list-bg-theme > .list-group-item.active {
  background: #e76049 !important;
  color: white !important;
}

html.default .list-fg-theme > .list-group-item {
  color: #e76049;
}

html.default {
  background: white;
  overflow-x: hidden;
  color: #89949b;
}
html.default body {
  background: white;
  overflow-x: hidden;
  color: #89949b;
}
html.default body #app-container {
  overflow: hidden;
}
html.default body #container > div:first-child#navbar #rubix-nav-header {
  margin: 0;
}
html.default body #container > div:first-child#body {
  margin-top: 0;
  padding-top: 25px;
}
html.default body #container.container-open > #sidebar {
  left: 0;
}
html.default body #container.container-open #rubix-nav-header,
html.default body #container.container-open > #body,
html.default body #container.container-open > #footer-container {
  margin-left: 120px;
  margin-right: -120px;
}
@media (min-width: 990px) {
  html.default body #container.container-open #rubix-nav-header,
  html.default body #container.container-open > #body,
  html.default body #container.container-open > #footer-container {
    margin-right: 0;
  }
}
html.default body #container.force-close > #sidebar {
  left: -120px;
}
html.default body #container.force-close #rubix-nav-header {
  margin-left: 0;
  margin-right: 0;
}
html.default body #container.force-close > #body,
html.default body #container.force-close > #footer-container {
  margin-left: 0;
  margin-right: 0;
}
html.default body #navbar {
  width: 100%;
}
html.default body #rubix-nav-header {
  border: none;
  margin-left: 0;
  display: block;
  height: 100px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  /* background: #e8ebf2; */
  background: transparent;
}
html.default body #rubix-nav-header .navbar-brand {
  width: 100%;
  text-align: center;
  color: #89949b;
}
html.default body #rubix-nav-header .navbar-brand > img {
  top: -3px;
  margin: auto;
  position: relative;
}
@media (max-width: 320px) {
  html.default body #rubix-nav-header .navbar-brand > img {
    width: 80px;
    left: -10px;
  }
}
html.default body #rubix-nav-header .navbar-content {
  height: 100px;
}
html.default body #rubix-nav-header .navbar-right {
  margin-right: -25px;
}
html.default body #rubix-nav-header .navbar-nav {
  margin: 0;
  display: inline-block;
}
html.default body #rubix-nav-header .navbar-nav:first-child {
  /* margin-left: -25px; */
}
html.default body #rubix-nav-header .navbar-nav > li > a {
  border: none;
  padding: 25px;
  display: block;
  line-height: 1;
}
html.default body #rubix-nav-header .navbar-nav > li > a > .rubix-icon {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}
html.default body #rubix-nav-header .navbar-nav > li.divider {
  height: 100px;
  border: 1px solid rgba(59, 70, 72, 0.45);
}
html.default body #rubix-nav-header .navbar-nav > li.dropdown.open > a {
  color: white;
  background: none;
}
html.default body #rubix-nav-header .navbar-nav > li.active > a,
html.default body #rubix-nav-header .navbar-nav > li > a {
  height: 100px;
  font-size: 26px;
  background: none;
  text-align: center;
  color: #89949b;
}
html.default body #rubix-nav-header .navbar-nav > li.active > a:hover,
html.default body #rubix-nav-header .navbar-nav > li > a:hover {
  /* color: #ffffff;  */
}
html.default body #rubix-nav-header .navbar-nav > li.pressed > a {
  color: white;
}
html.default body #rubix-nav-header .navbar-nav > li.logout > a,
html.default body #rubix-nav-header .navbar-nav > li.sidebar-btn > a {
  width: 110px;
  font-size: 50px;
  padding-left: 0;
  padding-right: 0;
}
html.default body #rubix-nav-header .navbar-nav > li.logout > a {
  color: black;
  /* background: #ff0101;  */
}
html.default body #rubix-nav-header .navbar-nav > li.logout > a:hover {
  color: black;
  /* background: #fa7272;  */
}
html.default body #rubix-nav-header .navbar-nav > li.sidebar-btn > a {
  color: #ffffff;
  background: #2aa38b;
}
html.default body #rubix-nav-header .navbar-nav > li.sidebar-btn > a:hover {
  background: #2eb398;
}
html.default body #rubix-nav-header .navbar-nav > li.collapse-left > a {
  padding-left: 0;
}
html.default body #rubix-nav-header .navbar-nav > li.collapse-right > a {
  padding-right: 0;
}
html.default body #rubix-nav-header .navbar-nav > li.small-font > a {
  font-size: 20px;
}
html.default body #rubix-nav-header .navbar-nav > li .notification-badge {
  font-size: 10px;
  padding: 3px 5px;
  margin-left: -5px;
  line-height: 10px;
  margin-top: -10px;
  position: absolute;
}
@media (min-width: 990px) {
  html.default body #rubix-nav-header {
    /* margin-left: 120px; */
  }
}
html.default body #flag-menu-btn > img {
  top: -2px;
  position: relative;
}
html.default body .lang-menu-text {
  line-height: 32px;
}
html.default body .header-menu > .dropdown-menu {
  border: none;
  margin-top: 0px;
  overflow: visible;
  -webkit-box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
          box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
  border-top: 5px solid #e76049 !important;
}
html.default body .header-menu > .dropdown-menu:after {
  top: -14px;
  right: 25px;
  content: "";
  position: absolute;
  display: inline-block;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #e76049;
}
html.default body #flag-menu-btn + .dropdown-menu {
  width: 325px;
}
html.default body #flag-menu-btn + .dropdown-menu .container-fluid {
  margin-left: -25px;
  margin-right: -25px;
}
html.default body #settings-menu + .dropdown-menu {
  width: 375px;
}
html.default body #notifications-menu + .dropdown-menu,
html.default body #rss-menu + .dropdown-menu {
  width: 325px;
}
html.default body #notifications-menu + .dropdown-menu > li,
html.default body #rss-menu + .dropdown-menu > li {
  border-bottom: 1px solid #f2f2f2;
}
html.default body #notifications-menu + .dropdown-menu > li:last-child,
html.default body #rss-menu + .dropdown-menu > li:last-child {
  border-bottom: none;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid,
html.default body #rss-menu + .dropdown-menu > li > a > .container-fluid {
  padding-top: 10px;
  padding-bottom: 10px;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .avatar-container,
html.default
  body
  #rss-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .avatar-container {
  width: 100px;
  padding-right: 10px;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .avatar-container
  .label,
html.default
  body
  #rss-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .avatar-container
  .label {
  font-size: 8px;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container,
html.default
  body
  #rss-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container {
  width: 225px;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container
  > .time,
html.default
  body
  #rss-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container
  > .time {
  line-height: 1;
  font-size: 10px;
  padding-bottom: 5px;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container
  > .time
  > strong
  > .rubix-icon,
html.default
  body
  #rss-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container
  > .time
  > strong
  > .rubix-icon {
  margin-right: 5px;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container
  > .message-header,
html.default
  body
  #rss-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container
  > .message-header {
  line-height: 1;
  font-size: 12px;
  padding-bottom: 5px;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container
  > .message-details,
html.default
  body
  #rss-menu
  + .dropdown-menu
  > li
  > a
  > .container-fluid
  > .row
  > .notification-container
  > .message-details {
  line-height: 1;
  font-size: 10px;
  padding-bottom: 5px;
}
html.default body #notifications-menu + .dropdown-menu .notification-footer-btn,
html.default body #rss-menu + .dropdown-menu .notification-footer-btn {
  margin: 0;
  height: 100%;
  font-size: 12px;
  border-radius: 0;
  font-weight: bold;
  padding: 6px 12px;
  border: none !important;
  color: #98a0a3 !important;
  background: #f9fafb !important;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  .notification-footer-btn:hover,
html.default
  body
  #notifications-menu
  + .dropdown-menu
  .notification-footer-btn:focus,
html.default body #rss-menu + .dropdown-menu .notification-footer-btn:hover,
html.default body #rss-menu + .dropdown-menu .notification-footer-btn:focus {
  border: none !important;
  background: #eaedf1 !important;
}
html.default
  body
  #notifications-menu
  + .dropdown-menu
  .notification-footer-btn.left-btn,
html.default body #rss-menu + .dropdown-menu .notification-footer-btn.left-btn {
  border-right: 1px solid #dde1e6 !important;
}
html.default body #sidebar {
  top: 0;
  bottom: 0;
  z-index: 1;
  position: fixed;
  overflow: hidden;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  left: -120px;
  width: 120px;
  background: #e8ebf2;
}
@media (min-width: 990px) {
  html.default body #sidebar {
    left: 0;
  }
}
html.default body #sidebar #avatar {
  height: 100px;
  background: #e8ebf2;
}
html.default body #sidebar #avatar img {
  top: 17px;
  position: relative;
}
html.default body #sidebar #avatar-col,
html.default body #sidebar #avatar-desc {
  margin-left: -5px;
}
html.default body #sidebar #demo-progress {
  margin: 0;
  top: 30px;
  height: 4px;
  width: 115px;
  border-radius: 0;
  position: relative;
  background: #de5939;
}
html.default body #sidebar #demo-icon {
  top: 3px;
  float: right;
  font-size: 18px;
  position: relative;
  color: #de5939;
}
html.default body #sidebar .sidebar-controls-container {
  width: 120px;
  height: 35px;
  display: table;
  visibility: visible;
  background: #ff0101;
}
html.default body #sidebar .sidebar-controls-container > .sidebar-controls {
  display: table-row;
}
html.default
  body
  #sidebar
  .sidebar-controls-container
  > .sidebar-controls
  > .sidebar-control-btn {
  border: none;
  outline: none;
  font-size: 16px;
  cursor: pointer;
  background: none;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  border-right: 1px solid #cf4d2e;
}
html.default
  body
  #sidebar
  .sidebar-controls-container
  > .sidebar-controls
  > .sidebar-control-btn
  > a {
  outline: none;
  color: #993f31;
}
html.default
  body
  #sidebar
  .sidebar-controls-container
  > .sidebar-controls
  > .sidebar-control-btn
  > a:hover,
html.default
  body
  #sidebar
  .sidebar-controls-container
  > .sidebar-controls
  > .sidebar-control-btn
  > a:focus {
  border: none;
}
html.default
  body
  #sidebar
  .sidebar-controls-container
  > .sidebar-controls
  > .sidebar-control-btn.active {
  background: #ba4e3b !important;
}
html.default
  body
  #sidebar
  .sidebar-controls-container
  > .sidebar-controls
  > .sidebar-control-btn.active
  > a {
  color: #fa7252;
}
html.default
  body
  #sidebar
  .sidebar-controls-container
  > .sidebar-controls
  > .sidebar-control-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}
html.default body #sidebar .sidebar-item {
  height: 35px;
  background: #1f282d;
}
html.default body #sidebar #sidebar-container {
  bottom: 100px;
  width: 120px;
  overflow: hidden;
  position: absolute;
  top: 120px;
}
html.default body #sidebar #sidebar-container .sidebar {
  top: 0;
  bottom: 0;
  width: 120px;
  overflow: hidden;
  position: absolute;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
html.default body .sidebar-header {
  line-height: 1;
  font-size: 12px;
  padding-top: 25px;
  font-weight: bold;
  padding-bottom: 12px;
  text-transform: uppercase;
  color: rgba(137, 148, 155, 0.4);
}
html.default body .sidebar-nav > .sidebar-header {
  padding-left: 25px;
}
html.default body .sidebar-nav {
  padding: 0;
  list-style: none;
  margin-left: 25px;
  border-left: 2px solid rgba(59, 70, 72, 0.5);
}
html.default body .sidebar-nav > li {
  /* height: 45px; */
  outline: none;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}
html.default body .sidebar-nav > li > a {
  /* height: 45px; */
  border: none;
  outline: none;
  color: black;
  display: block;
  font-size: 14px;
  line-height: 14px;
  text-decoration: none;
  padding: 15px 0px 15px 25px;
}
html.default body .sidebar-nav > li > a > .rubix-icon,
html.default body .sidebar-nav > li > a > rubix-icon > .rubix-icon {
  width: 16px;
  height: 17px;
  vertical-align: top;
  display: inline-block;
}
html.default body .sidebar-nav > li > a > .name {
  line-height: 16px;
  vertical-align: top;
}
html.default body .sidebar-nav-container > div > a.current > .name {
  line-height: 18px;
  vertical-align: top;
  padding-top: 5px;
  /* font-size: 16px; */
  color: black;
  display: grid;
}
html.default body .sidebar-nav > li > a > .name > span > .label,
html.default body .sidebar-nav > li > a > .name > .label {
  float: right;
  margin-top: -3px;
  padding: 5px 10px;
  margin-right: 30px;
}
html.default body .sidebar-nav > li > a > .rubix-icon ~ .name,
html.default body .sidebar-nav > li > a > rubix-icon ~ .name {
  margin-left: 10px;
}
html.default body .sidebar-nav > li > a:hover,
html.default body .sidebar-nav > li > a:focus {
  border: none;
  background: rgba(0, 0, 0, 0.2);
}
html.default body .sidebar-nav > li:hover:before,
html.default body .sidebar-nav > li.open:before {
  display: none;
}
html.default body .sidebar-nav > li.open {
  height: 100%;
}
html.default body .sidebar-nav > li.open > a {
  background: rgba(0, 0, 0, 0.2);
}
html.default body .sidebar-nav > li:before {
  left: 0;
  top: 22px;
  width: 15px;
  content: " ";
  position: absolute;
  display: inline-block;
  border: 1px solid rgba(59, 70, 72, 0.5);
}
html.default body .sidebar-nav > li.completed > a > span > svg {
  color: #079EDA;
  fill: #079EDA;
  fill-rule: evenodd;
}

html.default body .sidebar-nav > li > a > span > svg {
  fill: #000;
  fill-rule: evenodd;
}

html.default body .sidebar-nav > li.completed {
  color: #079EDA;
}
html.default body .sidebar-nav > li.active {
  color: #079EDA;
}
html.default body .sidebar-nav > li.completed > a {
  color: #079EDA;
  /* margin-left: 4px;
  font-weight: 600; */
}
html.default body .sidebar-nav > li.active > a {
  color: #079EDA;
  /* margin-left: 4px;
  font-weight: 600; */
}
html.default body .sidebar-nav > li.active > a > span > svg {
  color: #079EDA;
  fill: #079EDA;
  fill-rule: evenodd;
}

html.default body .sidebar-nav > li.active > a:hover {
  background: rgba(0, 0, 0, 0.6);
}
html.default body .sidebar-nav > li.active:before {
  display: none;
}
html.default body .sidebar-nav > li.active:after {
  top: 50px;
  right: 0;
  content: "";
  position: absolute;
  display: inline-block;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-right: 10px solid #e8ebf2;
}
html.default body .sidebar-nav-container > .sidebar-nav {
  border: none;
  margin-left: -25px;
  margin-right: -25px;
}
html.default body .sidebar-nav-container > .sidebar-nav > li:before {
  display: none;
}
html.default body .sidebar-nav-container > .sidebar-nav > li > a {
  /* font-size: 16px; */
  /* line-height: 16px; */
  text-align: center;
  display: grid;
  padding: 10px;
}
html.default body .sidebar-nav-container > .sidebar-nav > li > a > .name {
  line-height: 18px;
  padding-top: 5px;
  /* margin-left: 15px; */
}
html.default body .sidebar-nav-container > .sidebar-nav > li > a > .rubix-icon,
html.default
  body
  .sidebar-nav-container
  > .sidebar-nav
  > li
  > a
  > rubix-icon
  > .rubix-icon {
  width: 18px;
  height: 19px;
  display: inline-block;
}
html.default body .sidebar-nav-container > .sidebar-nav > li.active > a {
  /* padding-left: 20px; */
}
html.default body #navbar ~ #sidebar {
  top: 100px;
}
html.default body #body {
  left: 0;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  /* z-index: 100; */
  margin-left: 0;
  position: relative;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  background: #e8ebf2;
  /* margin-top: 25px;
  padding-bottom: 25px;
  border-radius: 0px !important; */
  padding: 10px;
  border-radius: 20px !important;
  /* margin: 10px 10px 10px 130px !important; */
  margin-top: 15px !important;
  margin-bottom: 15px !important;
  margin-left: 135px !important;
  margin-right: 15px !important;
}
html.default body #navbar ~ #body {
  margin-top: 99px;
  padding-top: 25px;
}
@media (min-width: 990px) {
  html.default body #sidebar ~ #body {
    /* margin-left: 130px;
    margin-top: 0 !important;
    padding-top: 25px !important; */
  }
}
html.default body #sidebar + #body {
  margin-top: 0;
  padding-top: 15px;
}
html.default body .external-event {
  background: #ff0101;
}
html.default body #footer {
  padding: 10px;
  position: relative;
  color: #ccd6df;
  background: #89949b;
  -ms-flex: none;
  flex: none;
}
html.default body #footer-container {
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
@media (min-width: 990px) {
  html.default body #sidebar ~ #footer-container {
    margin-left: 120px;
  }
}

html .sidebar-nav > li > a > .toggle-button {
  top: 14px;
  right: 15px;
  position: absolute;
}

.toggle-button {
  -webkit-transform-origin: 4px;
      -ms-transform-origin: 4px;
          transform-origin: 4px;
  -webkit-transition: all 0.125s ease;
  transition: all 0.125s ease;
}
.toggle-button.open {
  -webkit-transform: rotate(-90deg);
      -ms-transform: rotate(-90deg);
          transform: rotate(-90deg);
}
.toggle-button.opposite {
  -webkit-transform-origin: 12px;
      -ms-transform-origin: 12px;
          transform-origin: 12px;
}
.toggle-button.opposite.open {
  -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
          transform: rotate(90deg);
}

html.touchevents,
html.touchevents > body,
html.touchevents #app-container,
html.touchevents #app-container > #container {
  position: relative;
}

html.touchevents #body {
  top: 0;
  bottom: 0;
  left: 0 !important;
  right: 0 !important;
  padding: 0 !important;
  position: fixed !important;
  margin-bottom: 0 !important;
  min-height: 100% !important;
  margin-top: -100px !important;
}
html.touchevents #body > div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  padding-top: 25px;
  padding-bottom: 25px;
}
html.touchevents #body > div > div {
  overflow-x: hidden;
}

html.touchevents #sidebar {
  overflow: hidden !important;
}
html.touchevents #sidebar #sidebar-container .sidebar {
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

html.touchevents #footer,
html.touchevents #footer-container {
  display: none !important;
  position: relative !important;
}

html.static {
  background: #273135;
}
html.static body,
html.static #app-container {
  background: #273135;
}
html.static #body {
  margin-top: -35px !important;
}
html.static #sidebar,
html.static #rubix-nav-header {
  position: relative !important;
}
html.static #rubix-nav-header {
  position: static;
  margin-top: -110px;
  margin-bottom: -110px;
  margin-left: -25px !important;
  margin-right: -25px;
}
html.static #sidebar {
  overflow: visible !important;
}
html.static #sidebar #sidebar-container,
html.static #sidebar .sidebar {
  overflow: visible !important;
}
@media (min-width: 990px) {
  html.static #rubix-nav-header {
    margin-left: 225px !important;
  }
}
html.static #container.container-open #rubix-nav-header {
  margin-left: 225px !important;
}
@media (min-width: 990px) {
  html.static #container.container-open #rubix-nav-header {
    margin-right: -25px !important;
  }
}

html.boxed {
  height: 100%;
  overflow: hidden;
  background: #333333 url("/public/imgs/common/congruent_outline.png");
}
html.boxed body {
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: none;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
html.boxed body #navbar {
  padding: 0;
}
html.boxed body #rubix-nav-header {
  margin: 0;
  position: absolute;
}
html.boxed body #sidebar {
  top: 100px;
}
html.boxed body #container.container-open > #sidebar {
  left: 0;
}
html.boxed body #container.container-open #rubix-nav-header {
  margin-left: 0;
  margin-right: 0;
}
html.boxed body #container.container-open > #body,
html.boxed body #container.container-open > #footer-container {
  margin-left: 120px;
  margin-right: -120px;
}
@media (min-width: 990px) {
  html.boxed body #container.container-open > #body,
  html.boxed body #container.container-open > #footer-container {
    margin-right: 0;
    margin-left: 120px;
  }
}
html.boxed body > #app-container {
  height: 100%;
  overflow: hidden;
  position: relative;
}
html.boxed body > #app-container #rubix-nav-header {
  position: relative;
}
html.boxed body > #app-container #sidebar {
  margin: 0;
  position: absolute;
}
html.boxed body > #app-container #body {
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 0;
  overflow: auto;
  margin-left: 0;
  position: absolute;
  padding-bottom: 25px;
  padding-top: 200px;
  margin-top: -175px !important;
  overflow-y: auto;
  overflow-x: hidden;
}
html.boxed body > #app-container #footer-container,
html.boxed body > #app-container #footer {
  display: none;
}
html.boxed body > #app-container #navbar ~ #body {
  margin-top: 0;
  top: 69px;
}
@media (min-width: 990px) {
  html.boxed body {
    width: 990px;
    margin: auto;
    -webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  }
  html.boxed body > #app-container {
    margin: auto;
  }
  html.boxed body > #app-container #sidebar {
    margin-left: 0;
  }
  html.boxed body > #app-container #sidebar ~ #body,
  html.boxed body > #app-container #sidebar ~ #body ~ #footer-container {
    right: 0;
    margin-left: 120px;
  }
}

html.static.boxed {
  height: auto;
  overflow: auto;
  overflow-x: hidden;
}
html.static.boxed body {
  height: auto;
  overflow: visible;
  overflow-x: hidden;
}
html.static.boxed body #app-container {
  overflow: hidden;
}
html.static.boxed body #container.container-open #rubix-nav-header {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
html.static.boxed body #navbar {
  width: 100%;
}
html.static.boxed body #rubix-nav-header {
  margin-right: 0;
  margin-top: -110px;
  margin-left: 0 !important;
}
html.static.boxed body #body {
  overflow: hidden !important;
  padding-top: 95px !important;
  position: relative !important;
  padding-bottom: 95px !important;
}
html.static.boxed body #footer-container,
html.static.boxed body #footer {
  display: block !important;
}
html.static.boxed body #footer-container {
  margin-top: 25px;
}

/* @font-face {
  font-family: "Lato";
  src: url("/fonts/lato/lato-bold-webfont.woff2") format("woff2"),
    url("/fonts/lato/lato-bold-webfont.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Lato";
  src: url("/fonts/lato/lato-bolditalic-webfont.woff2") format("woff2"),
    url("/fonts/lato/lato-bolditalic-webfont.woff") format("woff");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "Lato";
  src: url("/fonts/lato/lato-italic-webfont.woff2") format("woff2"),
    url("/fonts/lato/lato-italic-webfont.woff") format("woff");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "Lato";
  src: url("/fonts/lato/lato-light-webfont.woff2") format("woff2"),
    url("/fonts/lato/lato-light-webfont.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Lato";
  src: url("/fonts/lato/lato-regular-webfont.woff2") format("woff2"),
    url("/fonts/lato/lato-regular-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "fontello";
  src: url("/fonts/fontello/fontello-webfont.woff2") format("woff2"),
    url("/fonts/fontello/fontello-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
} */

[class^="icon-fontello-"]:before,
[class*=" icon-fontello-"]:before {
  font-family: "fontello";
  font-style: normal;
  font-weight: normal;
  speak: none;
  line-height: 1;
  display: inline-block;
  text-decoration: inherit;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-fontello-emo-happy:before {
  content: "\\e804";
}

.icon-fontello-odnoklassniki-rect-1:before {
  content: "\\efff";
}

.icon-fontello-emo-wink2:before {
  content: "\\e806";
}

.icon-fontello-emo-unhappy:before {
  content: "\\e807";
}

.icon-fontello-emo-sleep:before {
  content: "\\e808";
}

.icon-fontello-emo-thumbsup:before {
  content: "\\e809";
}

.icon-fontello-emo-devil:before {
  content: "\\e80a";
}

.icon-fontello-emo-surprised:before {
  content: "\\e80b";
}

.icon-fontello-emo-tongue:before {
  content: "\\e80c";
}

.icon-fontello-emo-coffee:before {
  content: "\\e80d";
}

.icon-fontello-emo-sunglasses:before {
  content: "\\e80e";
}

.icon-fontello-emo-displeased:before {
  content: "\\e80f";
}

.icon-fontello-emo-beer:before {
  content: "\\e810";
}

.icon-fontello-emo-grin:before {
  content: "\\e811";
}

.icon-fontello-emo-angry:before {
  content: "\\e812";
}

.icon-fontello-emo-saint:before {
  content: "\\e813";
}

.icon-fontello-emo-cry:before {
  content: "\\e800";
}

.icon-fontello-emo-shoot:before {
  content: "\\e801";
}

.icon-fontello-emo-squint:before {
  content: "\\e802";
}

.icon-fontello-emo-laugh:before {
  content: "\\e803";
}

.icon-fontello-spin1:before {
  content: "\\e814";
}

.icon-fontello-spin2:before {
  content: "\\e815";
}

.icon-fontello-spin3:before {
  content: "\\e816";
}

.icon-fontello-spin4:before {
  content: "\\e817";
}

.icon-fontello-spin5:before {
  content: "\\e818";
}

.icon-fontello-spin6:before {
  content: "\\e819";
}

.icon-fontello-firefox:before {
  content: "\\e81a";
}

.icon-fontello-chrome:before {
  content: "\\e81b";
}

.icon-fontello-opera:before {
  content: "\\e81c";
}

.icon-fontello-ie:before {
  content: "\\e81d";
}

.icon-fontello-crown:before {
  content: "\\e81e";
}

.icon-fontello-crown-plus:before {
  content: "\\e81f";
}

.icon-fontello-crown-minus:before {
  content: "\\e820";
}

.icon-fontello-marquee:before {
  content: "\\e821";
}

.icon-fontello-glass:before {
  content: "\\e822";
}

.icon-fontello-music-1:before {
  content: "\\e823";
}

.icon-fontello-search-1:before {
  content: "\\e824";
}

.icon-fontello-mail-1:before {
  content: "\\e825";
}

.icon-fontello-mail-alt:before {
  content: "\\e826";
}

.icon-fontello-heart-1:before {
  content: "\\e827";
}

.icon-fontello-heart-empty-1:before {
  content: "\\e828";
}

.icon-fontello-star-1:before {
  content: "\\e829";
}

.icon-fontello-star-empty-1:before {
  content: "\\e82a";
}

.icon-fontello-star-half:before {
  content: "\\e82b";
}

.icon-fontello-star-half-alt:before {
  content: "\\e82c";
}

.icon-fontello-user-1:before {
  content: "\\e82d";
}

.icon-fontello-users-1:before {
  content: "\\e82e";
}

.icon-fontello-male:before {
  content: "\\e82f";
}

.icon-fontello-female:before {
  content: "\\e830";
}

.icon-fontello-video-1:before {
  content: "\\e831";
}

.icon-fontello-videocam:before {
  content: "\\e832";
}

.icon-fontello-picture-1:before {
  content: "\\e833";
}

.icon-fontello-camera-1:before {
  content: "\\e834";
}

.icon-fontello-camera-alt:before {
  content: "\\e835";
}

.icon-fontello-th-large:before {
  content: "\\e836";
}

.icon-fontello-th:before {
  content: "\\e837";
}

.icon-fontello-th-list:before {
  content: "\\e838";
}

.icon-fontello-ok:before {
  content: "\\e839";
}

.icon-fontello-ok-circle:before {
  content: "\\e83a";
}

.icon-fontello-ok-circle2:before {
  content: "\\e83b";
}

.icon-fontello-ok-squared:before {
  content: "\\e83c";
}

.icon-fontello-cancel-1:before {
  content: "\\e83d";
}

.icon-fontello-cancel-circle:before {
  content: "\\e83e";
}

.icon-fontello-cancel-circle2:before {
  content: "\\e83f";
}

.icon-fontello-plus-1:before {
  content: "\\e840";
}

.icon-fontello-plus-circle:before {
  content: "\\e841";
}

.icon-fontello-plus-squared-1:before {
  content: "\\e842";
}

.icon-fontello-plus-squared-alt:before {
  content: "\\e843";
}

.icon-fontello-minus-1:before {
  content: "\\e844";
}

.icon-fontello-minus-circle:before {
  content: "\\e845";
}

.icon-fontello-minus-squared:before {
  content: "\\e846";
}

.icon-fontello-minus-squared-alt:before {
  content: "\\e847";
}

.icon-fontello-help:before {
  content: "\\e848";
}

.icon-fontello-help-circle:before {
  content: "\\e849";
}

.icon-fontello-info-circle:before {
  content: "\\e84a";
}

.icon-fontello-info:before {
  content: "\\e84b";
}

.icon-fontello-home-1:before {
  content: "\\e84c";
}

.icon-fontello-link-1:before {
  content: "\\e84d";
}

.icon-fontello-unlink:before {
  content: "\\e84e";
}

.icon-fontello-link-ext:before {
  content: "\\e84f";
}

.icon-fontello-link-ext-alt:before {
  content: "\\e850";
}

.icon-fontello-attach-1:before {
  content: "\\e851";
}

.icon-fontello-lock-1:before {
  content: "\\e852";
}

.icon-fontello-lock-open-1:before {
  content: "\\e853";
}

.icon-fontello-lock-open-alt:before {
  content: "\\e854";
}

.icon-fontello-pin:before {
  content: "\\e855";
}

.icon-fontello-eye-1:before {
  content: "\\e856";
}

.icon-fontello-eye-off:before {
  content: "\\e857";
}

.icon-fontello-tag-1:before {
  content: "\\e858";
}

.icon-fontello-tags:before {
  content: "\\e859";
}

.icon-fontello-bookmark-1:before {
  content: "\\e85a";
}

.icon-fontello-bookmark-empty:before {
  content: "\\e85b";
}

.icon-fontello-flag-1:before {
  content: "\\e85c";
}

.icon-fontello-flag-empty:before {
  content: "\\e85d";
}

.icon-fontello-flag-checkered:before {
  content: "\\e85e";
}

.icon-fontello-thumbs-up-1:before {
  content: "\\e85f";
}

.icon-fontello-thumbs-down-1:before {
  content: "\\e860";
}

.icon-fontello-thumbs-up-alt:before {
  content: "\\e861";
}

.icon-fontello-thumbs-down-alt:before {
  content: "\\e862";
}

.icon-fontello-download-1:before {
  content: "\\e863";
}

.icon-fontello-upload-1:before {
  content: "\\e864";
}

.icon-fontello-download-cloud:before {
  content: "\\e865";
}

.icon-fontello-upload-cloud-1:before {
  content: "\\e866";
}

.icon-fontello-reply-1:before {
  content: "\\e867";
}

.icon-fontello-reply-all:before {
  content: "\\e868";
}

.icon-fontello-forward-1:before {
  content: "\\e869";
}

.icon-fontello-quote-left:before {
  content: "\\e86a";
}

.icon-fontello-quote-right:before {
  content: "\\e86b";
}

.icon-fontello-code:before {
  content: "\\e86c";
}

.icon-fontello-export-1:before {
  content: "\\e86d";
}

.icon-fontello-export-alt:before {
  content: "\\e86e";
}

.icon-fontello-pencil-1:before {
  content: "\\e86f";
}

.icon-fontello-pencil-squared:before {
  content: "\\e870";
}

.icon-fontello-edit:before {
  content: "\\e871";
}

.icon-fontello-print-1:before {
  content: "\\e872";
}

.icon-fontello-retweet-1:before {
  content: "\\e873";
}

.icon-fontello-keyboard:before {
  content: "\\e874";
}

.icon-fontello-gamepad:before {
  content: "\\e875";
}

.icon-fontello-comment-1:before {
  content: "\\e876";
}

.icon-fontello-chat-1:before {
  content: "\\e877";
}

.icon-fontello-comment-empty:before {
  content: "\\e878";
}

.icon-fontello-chat-empty:before {
  content: "\\e879";
}

.icon-fontello-bell-1:before {
  content: "\\e87a";
}

.icon-fontello-bell-alt:before {
  content: "\\e87b";
}

.icon-fontello-attention-alt:before {
  content: "\\e87c";
  /*@noflip*/
  padding-left: 5px;
  /*@noflip*/
  padding-right: 1px;
  top: 1px;
  position: relative;
}

.icon-fontello-attention-1:before {
  content: "\\e87d";
}

.icon-fontello-attention-circle:before {
  content: "\\e87e";
}

.icon-fontello-location-1:before {
  content: "\\e87f";
}

.icon-fontello-direction:before {
  content: "\\e880";
}

.icon-fontello-compass:before {
  content: "\\e881";
}

.icon-fontello-trash-1:before {
  content: "\\e882";
}

.icon-fontello-doc-1:before {
  content: "\\e883";
}

.icon-fontello-docs-1:before {
  content: "\\e884";
}

.icon-fontello-doc-text:before {
  content: "\\e885";
}

.icon-fontello-doc-inv:before {
  content: "\\e886";
}

.icon-fontello-doc-text-inv:before {
  content: "\\e887";
}

.icon-fontello-folder-1:before {
  content: "\\e888";
}

.icon-fontello-folder-open:before {
  content: "\\e889";
}

.icon-fontello-folder-empty:before {
  content: "\\e88a";
}

.icon-fontello-folder-open-empty:before {
  content: "\\e88b";
}

.icon-fontello-box:before {
  content: "\\e88c";
}

.icon-fontello-rss-1:before {
  content: "\\e88d";
}

.icon-fontello-rss-squared:before {
  content: "\\e88e";
}

.icon-fontello-phone-1:before {
  content: "\\e88f";
}

.icon-fontello-phone-squared:before {
  content: "\\e890";
}

.icon-fontello-menu-1:before {
  content: "\\e891";
}

.icon-fontello-cog-1:before {
  content: "\\e892";
}

.icon-fontello-cog-alt:before {
  content: "\\e893";
}

.icon-fontello-wrench:before {
  content: "\\e894";
}

.icon-fontello-basket-1:before {
  content: "\\e895";
}

.icon-fontello-calendar-1:before {
  content: "\\e896";
}

.icon-fontello-calendar-empty:before {
  content: "\\e897";
}

.icon-fontello-login-1:before {
  content: "\\e898";
}

.icon-fontello-logout-1:before {
  content: "\\e899";
}

.icon-fontello-mic:before {
  content: "\\e89a";
}

.icon-fontello-mute:before {
  content: "\\e89b";
}

.icon-fontello-volume-off:before {
  content: "\\e89c";
}

.icon-fontello-volume-down:before {
  content: "\\e89d";
}

.icon-fontello-volume-up:before {
  content: "\\e89e";
}

.icon-fontello-headphones:before {
  content: "\\e89f";
}

.icon-fontello-clock-1:before {
  content: "\\e8a0";
}

.icon-fontello-lightbulb:before {
  content: "\\e8a1";
}

.icon-fontello-block-1:before {
  content: "\\e8a2";
}

.icon-fontello-resize-full-1:before {
  content: "\\e8a3";
}

.icon-fontello-resize-full-alt:before {
  content: "\\e8a4";
}

.icon-fontello-resize-small-1:before {
  content: "\\e8a5";
}

.icon-fontello-resize-vertical:before {
  content: "\\e8a6";
}

.icon-fontello-resize-horizontal:before {
  content: "\\e8a7";
}

.icon-fontello-move:before {
  content: "\\e8a8";
}

.icon-fontello-zoom-in:before {
  content: "\\e8a9";
}

.icon-fontello-zoom-out:before {
  content: "\\e8aa";
}

.icon-fontello-down-circle2:before {
  content: "\\e8ab";
}

.icon-fontello-up-circle2:before {
  content: "\\e8ac";
}

.icon-fontello-left-circled2:before {
  content: "\\e8ad";
}

.icon-fontello-right-circled2:before {
  content: "\\e8ae";
}

.icon-fontello-down-dir-1:before {
  content: "\\e8af";
}

.icon-fontello-up-dir-1:before {
  content: "\\e8b0";
}

.icon-fontello-left-dir-1:before {
  content: "\\e8b1";
}

.icon-fontello-right-dir-1:before {
  content: "\\e8b2";
}

.icon-fontello-down-open-1:before {
  content: "\\e8b3";
}

.icon-fontello-left-open-1:before {
  content: "\\e8b4";
}

.icon-fontello-right-open-1:before {
  content: "\\e8b5";
}

.icon-fontello-up-open-1:before {
  content: "\\e8b6";
}

.icon-fontello-angle-left:before {
  content: "\\e8b7";
}

.icon-fontello-angle-right:before {
  content: "\\e8b8";
}

.icon-fontello-angle-up:before {
  content: "\\e8b9";
}

.icon-fontello-angle-down:before {
  content: "\\e8ba";
}

.icon-fontello-angle-circled-left:before {
  content: "\\e8bb";
}

.icon-fontello-angle-circled-right:before {
  content: "\\e8bc";
}

.icon-fontello-angle-circled-up:before {
  content: "\\e8bd";
}

.icon-fontello-angle-circled-down:before {
  content: "\\e8be";
}

.icon-fontello-angle-double-left:before {
  content: "\\e8bf";
}

.icon-fontello-angle-double-right:before {
  content: "\\e8c0";
}

.icon-fontello-angle-double-up:before {
  content: "\\e8c1";
}

.icon-fontello-angle-double-down:before {
  content: "\\e8c2";
}

.icon-fontello-down:before {
  content: "\\e8c3";
}

.icon-fontello-right:before {
  content: "\\e8c4";
}

.icon-fontello-left:before {
  content: "\\e8c5";
}

.icon-fontello-up:before {
  content: "\\e8c6";
}

.icon-fontello-down-1:before {
  content: "\\e8c7";
}

.icon-fontello-left-1:before {
  content: "\\e8c8";
}

.icon-fontello-emo-wink:before {
  content: "\\e805";
}

.icon-fontello-up-1:before {
  content: "\\e8ca";
}

.icon-fontello-right-hand:before {
  content: "\\e8cb";
}

.icon-fontello-left-hand:before {
  content: "\\e8cc";
}

.icon-fontello-up-hand:before {
  content: "\\e8cd";
}

.icon-fontello-down-hand:before {
  content: "\\e8ce";
}

.icon-fontello-left-circled-1:before {
  content: "\\e8cf";
}

.icon-fontello-right-circled-1:before {
  content: "\\e8d0";
}

.icon-fontello-up-circled-1:before {
  content: "\\e8d1";
}

.icon-fontello-down-circled-1:before {
  content: "\\e8d2";
}

.icon-fontello-cw-1:before {
  content: "\\e8d3";
}

.icon-fontello-ccw-1:before {
  content: "\\e8d4";
}

.icon-fontello-arrows-cw:before {
  content: "\\e8d5";
}

.icon-fontello-level-up:before {
  content: "\\e8d6";
}

.icon-fontello-level-down:before {
  content: "\\e8d7";
}

.icon-fontello-shuffle-1:before {
  content: "\\e8d8";
}

.icon-fontello-exchange:before {
  content: "\\e8d9";
}

.icon-fontello-collapse:before {
  content: "\\e8da";
}

.icon-fontello-collapse-top:before {
  content: "\\e8db";
}

.icon-fontello-expand:before {
  content: "\\e8dc";
}

.icon-fontello-collapse-left:before {
  content: "\\e8dd";
}

.icon-fontello-play-1:before {
  content: "\\e8de";
}

.icon-fontello-play-circled:before {
  content: "\\e8df";
}

.icon-fontello-play-circle2:before {
  content: "\\e8e0";
}

.icon-fontello-stop-1:before {
  content: "\\e8e1";
}

.icon-fontello-pause-1:before {
  content: "\\e8e2";
}

.icon-fontello-to-end-1:before {
  content: "\\e8e3";
}

.icon-fontello-to-end-alt:before {
  content: "\\e8e4";
}

.icon-fontello-to-start-1:before {
  content: "\\e8e5";
}

.icon-fontello-to-start-alt:before {
  content: "\\e8e6";
}

.icon-fontello-fast-fw:before {
  content: "\\e8e7";
}

.icon-fontello-fast-bw:before {
  content: "\\e8e8";
}

.icon-fontello-eject:before {
  content: "\\e8e9";
}

.icon-fontello-target-1:before {
  content: "\\e8ea";
}

.icon-fontello-signal-1:before {
  content: "\\e8eb";
}

.icon-fontello-award:before {
  content: "\\e8ec";
}

.icon-fontello-desktop:before {
  content: "\\e8ed";
}

.icon-fontello-laptop:before {
  content: "\\e8ee";
}

.icon-fontello-tablet:before {
  content: "\\e8ef";
}

.icon-fontello-mobile-1:before {
  content: "\\e8f0";
}

.icon-fontello-inbox-1:before {
  content: "\\e8f1";
}

.icon-fontello-globe-1:before {
  content: "\\e8f2";
}

.icon-fontello-sun:before {
  content: "\\e8f3";
}

.icon-fontello-cloud-1:before {
  content: "\\e8f4";
}

.icon-fontello-flash-1:before {
  content: "\\e8f5";
}

.icon-fontello-moon:before {
  content: "\\e8f6";
}

.icon-fontello-umbrella:before {
  content: "\\e8f7";
}

.icon-fontello-flight-1:before {
  content: "\\e8f8";
}

.icon-fontello-fighter-jet:before {
  content: "\\e8f9";
}

.icon-fontello-leaf-1:before {
  content: "\\e8fa";
}

.icon-fontello-font:before {
  content: "\\e8fb";
}

.icon-fontello-bold:before {
  content: "\\e8fc";
}

.icon-fontello-italic:before {
  content: "\\e8fd";
}

.icon-fontello-text-height:before {
  content: "\\e8fe";
}

.icon-fontello-text-width:before {
  content: "\\e8ff";
}

.icon-fontello-align-left:before {
  content: "\\e900";
}

.icon-fontello-align-center:before {
  content: "\\e901";
}

.icon-fontello-align-right:before {
  content: "\\e902";
}

.icon-fontello-align-justify:before {
  content: "\\e903";
}

.icon-fontello-list-1:before {
  content: "\\e904";
}

.icon-fontello-indent-left:before {
  content: "\\e905";
}

.icon-fontello-indent-right:before {
  content: "\\e906";
}

.icon-fontello-list-bullet:before {
  content: "\\e907";
}

.icon-fontello-list-numbered:before {
  content: "\\e908";
}

.icon-fontello-strike:before {
  content: "\\e909";
}

.icon-fontello-underline:before {
  content: "\\e90a";
}

.icon-fontello-superscript:before {
  content: "\\e90b";
}

.icon-fontello-subscript:before {
  content: "\\e90c";
}

.icon-fontello-table:before {
  content: "\\e90d";
}

.icon-fontello-columns:before {
  content: "\\e90e";
}

.icon-fontello-crop:before {
  content: "\\e90f";
}

.icon-fontello-scissors:before {
  content: "\\e910";
}

.icon-fontello-paste:before {
  content: "\\e911";
}

.icon-fontello-briefcase-1:before {
  content: "\\e912";
}

.icon-fontello-suitcase-1:before {
  content: "\\e913";
}

.icon-fontello-ellipsis:before {
  content: "\\e914";
}

.icon-fontello-ellipsis-vert:before {
  content: "\\e915";
}

.icon-fontello-off:before {
  content: "\\e916";
}

.icon-fontello-road:before {
  content: "\\e917";
}

.icon-fontello-list-alt:before {
  content: "\\e918";
}

.icon-fontello-qrcode:before {
  content: "\\e919";
}

.icon-fontello-barcode:before {
  content: "\\e91a";
}

.icon-fontello-book-1:before {
  content: "\\e91b";
}

.icon-fontello-ajust:before {
  content: "\\e91c";
}

.icon-fontello-tint:before {
  content: "\\e91d";
}

.icon-fontello-check-1:before {
  content: "\\e91e";
}

.icon-fontello-check-empty:before {
  content: "\\e91f";
}

.icon-fontello-circle:before {
  content: "\\e920";
}

.icon-fontello-circle-empty:before {
  content: "\\e921";
}

.icon-fontello-dot-circled:before {
  content: "\\e922";
}

.icon-fontello-asterisk:before {
  content: "\\e923";
}

.icon-fontello-gift:before {
  content: "\\e924";
}

.icon-fontello-fire:before {
  content: "\\e925";
}

.icon-fontello-magnet-1:before {
  content: "\\e926";
}

.icon-fontello-chart-bar-1:before {
  content: "\\e927";
}

.icon-fontello-ticket:before {
  content: "\\e928";
}

.icon-fontello-credit-card-1:before {
  content: "\\e929";
}

.icon-fontello-floppy-1:before {
  content: "\\e92a";
}

.icon-fontello-megaphone-1:before {
  content: "\\e92b";
}

.icon-fontello-hdd:before {
  content: "\\e92c";
}

.icon-fontello-key-1:before {
  content: "\\e92d";
}

.icon-fontello-fork:before {
  content: "\\e92e";
}

.icon-fontello-rocket:before {
  content: "\\e92f";
}

.icon-fontello-bug:before {
  content: "\\e930";
}

.icon-fontello-certificate:before {
  content: "\\e931";
}

.icon-fontello-tasks:before {
  content: "\\e932";
}

.icon-fontello-filter:before {
  content: "\\e933";
}

.icon-fontello-beaker:before {
  content: "\\e934";
}

.icon-fontello-magic:before {
  content: "\\e935";
}

.icon-fontello-truck:before {
  content: "\\e936";
}

.icon-fontello-money:before {
  content: "\\e937";
}

.icon-fontello-euro:before {
  content: "\\e938";
}

.icon-fontello-pound:before {
  content: "\\e939";
}

.icon-fontello-dollar:before {
  content: "\\e93a";
}

.icon-fontello-rupee:before {
  content: "\\e93b";
}

.icon-fontello-yen:before {
  content: "\\e93c";
}

.icon-fontello-renminbi:before {
  content: "\\e93d";
}

.icon-fontello-try:before {
  content: "\\e93e";
}

.icon-fontello-won:before {
  content: "\\e93f";
}

.icon-fontello-bitcoin:before {
  content: "\\e940";
}

.icon-fontello-sort:before {
  content: "\\e941";
}

.icon-fontello-sort-down:before {
  content: "\\e942";
}

.icon-fontello-sort-up:before {
  content: "\\e943";
}

.icon-fontello-sort-alt-up:before {
  content: "\\e944";
}

.icon-fontello-sort-alt-down:before {
  content: "\\e945";
}

.icon-fontello-sort-name-up:before {
  content: "\\e946";
}

.icon-fontello-sort-name-down:before {
  content: "\\e947";
}

.icon-fontello-sort-number-up:before {
  content: "\\e948";
}

.icon-fontello-sort-number-down:before {
  content: "\\e949";
}

.icon-fontello-hammer:before {
  content: "\\e94a";
}

.icon-fontello-gauge-1:before {
  content: "\\e94b";
}

.icon-fontello-sitemap:before {
  content: "\\e94c";
}

.icon-fontello-spinner:before {
  content: "\\e94d";
}

.icon-fontello-coffee:before {
  content: "\\e94e";
}

.icon-fontello-food:before {
  content: "\\e94f";
}

.icon-fontello-beer:before {
  content: "\\e950";
}

.icon-fontello-user-md:before {
  content: "\\e951";
}

.icon-fontello-stethoscope:before {
  content: "\\e952";
}

.icon-fontello-ambulance:before {
  content: "\\e953";
}

.icon-fontello-medkit:before {
  content: "\\e954";
}

.icon-fontello-h-sigh:before {
  content: "\\e955";
}

.icon-fontello-hospital:before {
  content: "\\e956";
}

.icon-fontello-building:before {
  content: "\\e957";
}

.icon-fontello-smile:before {
  content: "\\e958";
}

.icon-fontello-frown:before {
  content: "\\e959";
}

.icon-fontello-meh:before {
  content: "\\e95a";
}

.icon-fontello-anchor:before {
  content: "\\e95b";
}

.icon-fontello-terminal:before {
  content: "\\e95c";
}

.icon-fontello-eraser:before {
  content: "\\e95d";
}

.icon-fontello-puzzle:before {
  content: "\\e95e";
}

.icon-fontello-shield:before {
  content: "\\e95f";
}

.icon-fontello-extinguisher:before {
  content: "\\e960";
}

.icon-fontello-bullseye:before {
  content: "\\e961";
}

.icon-fontello-wheelchair:before {
  content: "\\e962";
}

.icon-fontello-adn:before {
  content: "\\e963";
}

.icon-fontello-android:before {
  content: "\\e964";
}

.icon-fontello-apple:before {
  content: "\\e965";
}

.icon-fontello-bitbucket:before {
  content: "\\e966";
}

.icon-fontello-bitbucket-squared:before {
  content: "\\e967";
}

.icon-fontello-css3:before {
  content: "\\e968";
}

.icon-fontello-dribbble:before {
  content: "\\e969";
}

.icon-fontello-dropbox:before {
  content: "\\e96a";
}

.icon-fontello-facebook:before {
  content: "\\e96b";
}

.icon-fontello-facebook-squared:before {
  content: "\\e96c";
}

.icon-fontello-flickr:before {
  content: "\\e96d";
}

.icon-fontello-foursquare:before {
  content: "\\e96e";
}

.icon-fontello-github:before {
  content: "\\e96f";
}

.icon-fontello-github-squared:before {
  content: "\\e970";
}

.icon-fontello-github-circled-1:before {
  content: "\\e971";
}

.icon-fontello-gittip:before {
  content: "\\e972";
}

.icon-fontello-gplus-squared:before {
  content: "\\e973";
}

.icon-fontello-gplus:before {
  content: "\\e974";
}

.icon-fontello-html5:before {
  content: "\\e975";
}

.icon-fontello-instagramm:before {
  content: "\\e976";
}

.icon-fontello-linkedin-squared:before {
  content: "\\e977";
}

.icon-fontello-linux:before {
  content: "\\e978";
}

.icon-fontello-linkedin:before {
  content: "\\e979";
}

.icon-fontello-maxcdn:before {
  content: "\\e97a";
}

.icon-fontello-pagelines:before {
  content: "\\e97b";
}

.icon-fontello-pinterest-circled:before {
  content: "\\e97c";
}

.icon-fontello-pinterest-squared:before {
  content: "\\e97d";
}

.icon-fontello-renren:before {
  content: "\\e97e";
}

.icon-fontello-skype:before {
  content: "\\e97f";
}

.icon-fontello-stackexchange:before {
  content: "\\e980";
}

.icon-fontello-stackoverflow:before {
  content: "\\e981";
}

.icon-fontello-trello:before {
  content: "\\e982";
}

.icon-fontello-tumblr:before {
  content: "\\e983";
}

.icon-fontello-tumblr-squared:before {
  content: "\\e984";
}

.icon-fontello-twitter-squared:before {
  content: "\\e985";
}

.icon-fontello-twitter:before {
  content: "\\e986";
}

.icon-fontello-vimeo-squared:before {
  content: "\\e987";
}

.icon-fontello-vkontakte:before {
  content: "\\e988";
}

.icon-fontello-weibo:before {
  content: "\\e989";
}

.icon-fontello-windows:before {
  content: "\\e98a";
}

.icon-fontello-xing:before {
  content: "\\e98b";
}

.icon-fontello-xing-squared:before {
  content: "\\e98c";
}

.icon-fontello-youtube:before {
  content: "\\e98d";
}

.icon-fontello-youtube-squared:before {
  content: "\\e98e";
}

.icon-fontello-youtube-play:before {
  content: "\\e98f";
}

.icon-fontello-blank:before {
  content: "\\e990";
}

.icon-fontello-lemon:before {
  content: "\\e991";
}

.icon-fontello-note:before {
  content: "\\e992";
}

.icon-fontello-note-beamed:before {
  content: "\\e993";
}

.icon-fontello-music:before {
  content: "\\e994";
}

.icon-fontello-search:before {
  content: "\\e995";
}

.icon-fontello-flashlight:before {
  content: "\\e996";
}

.icon-fontello-mail:before {
  content: "\\e997";
}

.icon-fontello-heart:before {
  content: "\\e998";
}

.icon-fontello-heart-empty:before {
  content: "\\e999";
}

.icon-fontello-star:before {
  content: "\\e99a";
}

.icon-fontello-star-empty:before {
  content: "\\e99b";
}

.icon-fontello-user:before {
  content: "\\e99c";
}

.icon-fontello-users:before {
  content: "\\e99d";
}

.icon-fontello-user-add:before {
  content: "\\e99e";
}

.icon-fontello-video:before {
  content: "\\e99f";
}

.icon-fontello-picture:before {
  content: "\\e9a0";
}

.icon-fontello-camera:before {
  content: "\\e9a1";
}

.icon-fontello-layout:before {
  content: "\\e9a2";
}

.icon-fontello-menu:before {
  content: "\\e9a3";
}

.icon-fontello-check:before {
  content: "\\e9a4";
}

.icon-fontello-cancel:before {
  content: "\\e9a5";
}

.icon-fontello-cancel-circled:before {
  content: "\\e9a6";
}

.icon-fontello-cancel-squared:before {
  content: "\\e9a7";
}

.icon-fontello-plus:before {
  content: "\\e9a8";
}

.icon-fontello-plus-circled:before {
  content: "\\e9a9";
}

.icon-fontello-plus-squared:before {
  content: "\\e9aa";
}

.icon-fontello-minus:before {
  content: "\\e9ab";
}

.icon-fontello-minus-circled:before {
  content: "\\e9ac";
}

.icon-fontello-minus-squared-1:before {
  content: "\\e9ad";
}

.icon-fontello-help-1:before {
  content: "\\e9ae";
}

.icon-fontello-help-circled:before {
  content: "\\e9af";
}

.icon-fontello-info-1:before {
  content: "\\e9b0";
}

.icon-fontello-info-circled:before {
  content: "\\e9b1";
}

.icon-fontello-back:before {
  content: "\\e9b2";
}

.icon-fontello-home:before {
  content: "\\e9b3";
}

.icon-fontello-link:before {
  content: "\\e9b4";
}

.icon-fontello-attach:before {
  content: "\\e9b5";
}

.icon-fontello-lock:before {
  content: "\\e9b6";
}

.icon-fontello-lock-open:before {
  content: "\\e9b7";
}

.icon-fontello-eye:before {
  content: "\\e9b8";
}

.icon-fontello-tag:before {
  content: "\\e9b9";
}

.icon-fontello-bookmark:before {
  content: "\\e9ba";
}

.icon-fontello-bookmarks:before {
  content: "\\e9bb";
}

.icon-fontello-flag:before {
  content: "\\e9bc";
}

.icon-fontello-thumbs-up:before {
  content: "\\e9bd";
}

.icon-fontello-thumbs-down:before {
  content: "\\e9be";
}

.icon-fontello-download:before {
  content: "\\e9bf";
}

.icon-fontello-upload:before {
  content: "\\e9c0";
}

.icon-fontello-upload-cloud:before {
  content: "\\e9c1";
}

.icon-fontello-reply:before {
  content: "\\e9c2";
}

.icon-fontello-reply-all-1:before {
  content: "\\e9c3";
}

.icon-fontello-forward:before {
  content: "\\e9c4";
}

.icon-fontello-quote:before {
  content: "\\e9c5";
}

.icon-fontello-code-1:before {
  content: "\\e9c6";
}

.icon-fontello-export:before {
  content: "\\e9c7";
}

.icon-fontello-pencil:before {
  content: "\\e9c8";
}

.icon-fontello-feather:before {
  content: "\\e9c9";
}

.icon-fontello-print:before {
  content: "\\e9ca";
}

.icon-fontello-retweet:before {
  content: "\\e9cb";
}

.icon-fontello-keyboard-1:before {
  content: "\\e9cc";
}

.icon-fontello-comment:before {
  content: "\\e9cd";
}

.icon-fontello-chat:before {
  content: "\\e9ce";
}

.icon-fontello-bell:before {
  content: "\\e9cf";
}

.icon-fontello-attention:before {
  content: "\\e9d0";
}

.icon-fontello-alert:before {
  content: "\\e9d1";
}

.icon-fontello-vcard:before {
  content: "\\e9d2";
}

.icon-fontello-address:before {
  content: "\\e9d3";
}

.icon-fontello-location:before {
  content: "\\e9d4";
}

.icon-fontello-map:before {
  content: "\\e9d5";
}

.icon-fontello-direction-1:before {
  content: "\\e9d6";
}

.icon-fontello-compass-1:before {
  content: "\\e9d7";
}

.icon-fontello-cup:before {
  content: "\\e9d8";
}

.icon-fontello-trash:before {
  content: "\\e9d9";
}

.icon-fontello-doc:before {
  content: "\\e9da";
}

.icon-fontello-docs:before {
  content: "\\e9db";
}

.icon-fontello-doc-landscape:before {
  content: "\\e9dc";
}

.icon-fontello-doc-text-1:before {
  content: "\\e9dd";
}

.icon-fontello-doc-text-inv-1:before {
  content: "\\e9de";
}

.icon-fontello-newspaper:before {
  content: "\\e9df";
}

.icon-fontello-book-open:before {
  content: "\\e9e0";
}

.icon-fontello-book:before {
  content: "\\e9e1";
}

.icon-fontello-folder:before {
  content: "\\e9e2";
}

.icon-fontello-archive:before {
  content: "\\e9e3";
}

.icon-fontello-box-1:before {
  content: "\\e9e4";
}

.icon-fontello-rss:before {
  content: "\\e9e5";
}

.icon-fontello-phone:before {
  content: "\\e9e6";
}

.icon-fontello-cog:before {
  content: "\\e9e7";
}

.icon-fontello-tools:before {
  content: "\\e9e8";
}

.icon-fontello-share:before {
  content: "\\e9e9";
}

.icon-fontello-shareable:before {
  content: "\\e9ea";
}

.icon-fontello-basket:before {
  content: "\\e9eb";
}

.icon-fontello-bag:before {
  content: "\\e9ec";
}

.icon-fontello-calendar:before {
  content: "\\e9ed";
}

.icon-fontello-login:before {
  content: "\\e9ee";
}

.icon-fontello-logout:before {
  content: "\\e9ef";
}

.icon-fontello-mic-1:before {
  content: "\\e9f0";
}

.icon-fontello-mute-1:before {
  content: "\\e9f1";
}

.icon-fontello-sound:before {
  content: "\\e9f2";
}

.icon-fontello-volume:before {
  content: "\\e9f3";
}

.icon-fontello-clock:before {
  content: "\\e9f4";
}

.icon-fontello-hourglass:before {
  content: "\\e9f5";
}

.icon-fontello-lamp:before {
  content: "\\e9f6";
}

.icon-fontello-light-down:before {
  content: "\\e9f7";
}

.icon-fontello-light-up:before {
  content: "\\e9f8";
}

.icon-fontello-adjust:before {
  content: "\\e9f9";
}

.icon-fontello-block:before {
  content: "\\e9fa";
}

.icon-fontello-resize-full:before {
  content: "\\e9fb";
}

.icon-fontello-resize-small:before {
  content: "\\e9fc";
}

.icon-fontello-popup:before {
  content: "\\e9fd";
}

.icon-fontello-publish:before {
  content: "\\e9fe";
}

.icon-fontello-window:before {
  content: "\\e9ff";
}

.icon-fontello-arrow-combo:before {
  content: "\\ea00";
}

.icon-fontello-down-circled:before {
  content: "\\ea01";
}

.icon-fontello-left-circled:before {
  content: "\\ea02";
}

.icon-fontello-right-circled:before {
  content: "\\ea03";
}

.icon-fontello-up-circled:before {
  content: "\\ea04";
}

.icon-fontello-down-open:before {
  content: "\\ea05";
}

.icon-fontello-left-open:before {
  content: "\\ea06";
}

.icon-fontello-right-open:before {
  content: "\\ea07";
}

.icon-fontello-up-open:before {
  content: "\\ea08";
}

.icon-fontello-down-open-mini:before {
  content: "\\ea09";
}

.icon-fontello-left-open-mini:before {
  content: "\\ea0a";
}

.icon-fontello-right-open-mini:before {
  content: "\\ea0b";
}

.icon-fontello-up-open-mini:before {
  content: "\\ea0c";
}

.icon-fontello-down-open-big:before {
  content: "\\ea0d";
}

.icon-fontello-left-open-big:before {
  content: "\\ea0e";
}

.icon-fontello-right-open-big:before {
  content: "\\ea0f";
}

.icon-fontello-up-open-big:before {
  content: "\\ea10";
}

.icon-fontello-down-2:before {
  content: "\\ea11";
}

.icon-fontello-left-2:before {
  content: "\\ea12";
}

.icon-fontello-right-2:before {
  content: "\\ea13";
}

.icon-fontello-up-2:before {
  content: "\\ea14";
}

.icon-fontello-down-dir:before {
  content: "\\ea15";
}

.icon-fontello-left-dir:before {
  content: "\\ea16";
}

.icon-fontello-right-dir:before {
  content: "\\ea17";
}

.icon-fontello-up-dir:before {
  content: "\\ea18";
}

.icon-fontello-down-bold:before {
  content: "\\ea19";
}

.icon-fontello-left-bold:before {
  content: "\\ea1a";
}

.icon-fontello-right-bold:before {
  content: "\\ea1b";
}

.icon-fontello-up-bold:before {
  content: "\\ea1c";
}

.icon-fontello-down-thin:before {
  content: "\\ea1d";
}

.icon-fontello-left-thin:before {
  content: "\\ea1e";
}

.icon-fontello-right-thin:before {
  content: "\\ea1f";
}

.icon-fontello-up-thin:before {
  content: "\\ea20";
}

.icon-fontello-ccw:before {
  content: "\\ea21";
}

.icon-fontello-cw:before {
  content: "\\ea22";
}

.icon-fontello-arrows-ccw:before {
  content: "\\ea23";
}

.icon-fontello-level-down-1:before {
  content: "\\ea24";
}

.icon-fontello-level-up-1:before {
  content: "\\ea25";
}

.icon-fontello-shuffle:before {
  content: "\\ea26";
}

.icon-fontello-loop:before {
  content: "\\ea27";
}

.icon-fontello-switch:before {
  content: "\\ea28";
}

.icon-fontello-play:before {
  content: "\\ea29";
}

.icon-fontello-stop:before {
  content: "\\ea2a";
}

.icon-fontello-pause:before {
  content: "\\ea2b";
}

.icon-fontello-record:before {
  content: "\\ea2c";
}

.icon-fontello-to-end:before {
  content: "\\ea2d";
}

.icon-fontello-to-start:before {
  content: "\\ea2e";
}

.icon-fontello-fast-forward:before {
  content: "\\ea2f";
}

.icon-fontello-fast-backward:before {
  content: "\\ea30";
}

.icon-fontello-progress-0:before {
  content: "\\ea31";
}

.icon-fontello-progress-1:before {
  content: "\\ea32";
}

.icon-fontello-progress-2:before {
  content: "\\ea33";
}

.icon-fontello-progress-3:before {
  content: "\\ea34";
}

.icon-fontello-target:before {
  content: "\\ea35";
}

.icon-fontello-palette:before {
  content: "\\ea36";
}

.icon-fontello-list:before {
  content: "\\ea37";
}

.icon-fontello-list-add:before {
  content: "\\ea38";
}

.icon-fontello-signal:before {
  content: "\\ea39";
}

.icon-fontello-trophy:before {
  content: "\\ea3a";
}

.icon-fontello-battery:before {
  content: "\\ea3b";
}

.icon-fontello-back-in-time:before {
  content: "\\ea3c";
}

.icon-fontello-monitor:before {
  content: "\\ea3d";
}

.icon-fontello-mobile:before {
  content: "\\ea3e";
}

.icon-fontello-network:before {
  content: "\\ea3f";
}

.icon-fontello-cd:before {
  content: "\\ea40";
}

.icon-fontello-inbox:before {
  content: "\\ea41";
}

.icon-fontello-install:before {
  content: "\\ea42";
}

.icon-fontello-globe:before {
  content: "\\ea43";
}

.icon-fontello-cloud:before {
  content: "\\ea44";
}

.icon-fontello-cloud-thunder:before {
  content: "\\ea45";
}

.icon-fontello-flash:before {
  content: "\\ea46";
}

.icon-fontello-moon-1:before {
  content: "\\ea47";
}

.icon-fontello-flight:before {
  content: "\\ea48";
}

.icon-fontello-paper-plane:before {
  content: "\\ea49";
}

.icon-fontello-leaf:before {
  content: "\\ea4a";
}

.icon-fontello-lifebuoy:before {
  content: "\\ea4b";
}

.icon-fontello-mouse:before {
  content: "\\ea4c";
}

.icon-fontello-briefcase:before {
  content: "\\ea4d";
}

.icon-fontello-suitcase:before {
  content: "\\ea4e";
}

.icon-fontello-dot:before {
  content: "\\ea4f";
}

.icon-fontello-dot-2:before {
  content: "\\ea50";
}

.icon-fontello-dot-3:before {
  content: "\\ea51";
}

.icon-fontello-brush:before {
  content: "\\ea52";
}

.icon-fontello-magnet:before {
  content: "\\ea53";
}

.icon-fontello-infinity:before {
  content: "\\ea54";
}

.icon-fontello-erase:before {
  content: "\\ea55";
}

.icon-fontello-chart-pie:before {
  content: "\\ea56";
}

.icon-fontello-chart-line:before {
  content: "\\ea57";
}

.icon-fontello-chart-bar:before {
  content: "\\ea58";
}

.icon-fontello-chart-area:before {
  content: "\\ea59";
}

.icon-fontello-tape:before {
  content: "\\ea5a";
}

.icon-fontello-graduation-cap:before {
  content: "\\ea5b";
}

.icon-fontello-language:before {
  content: "\\ea5c";
}

.icon-fontello-ticket-1:before {
  content: "\\ea5d";
}

.icon-fontello-water:before {
  content: "\\ea5e";
}

.icon-fontello-droplet:before {
  content: "\\ea5f";
}

.icon-fontello-air:before {
  content: "\\ea60";
}

.icon-fontello-credit-card:before {
  content: "\\ea61";
}

.icon-fontello-floppy:before {
  content: "\\ea62";
}

.icon-fontello-clipboard:before {
  content: "\\ea63";
}

.icon-fontello-megaphone:before {
  content: "\\ea64";
}

.icon-fontello-database:before {
  content: "\\ea65";
}

.icon-fontello-drive:before {
  content: "\\ea66";
}

.icon-fontello-bucket:before {
  content: "\\ea67";
}

.icon-fontello-thermometer:before {
  content: "\\ea68";
}

.icon-fontello-key:before {
  content: "\\ea69";
}

.icon-fontello-flow-cascade:before {
  content: "\\ea6a";
}

.icon-fontello-flow-branch:before {
  content: "\\ea6b";
}

.icon-fontello-flow-tree:before {
  content: "\\ea6c";
}

.icon-fontello-flow-line:before {
  content: "\\ea6d";
}

.icon-fontello-flow-parallel:before {
  content: "\\ea6e";
}

.icon-fontello-rocket-1:before {
  content: "\\ea6f";
}

.icon-fontello-gauge:before {
  content: "\\ea70";
}

.icon-fontello-traffic-cone:before {
  content: "\\ea71";
}

.icon-fontello-cc:before {
  content: "\\ea72";
}

.icon-fontello-cc-by:before {
  content: "\\ea73";
}

.icon-fontello-cc-nc:before {
  content: "\\ea74";
}

.icon-fontello-cc-nc-eu:before {
  content: "\\ea75";
}

.icon-fontello-cc-nc-jp:before {
  content: "\\ea76";
}

.icon-fontello-cc-sa:before {
  content: "\\ea77";
}

.icon-fontello-cc-nd:before {
  content: "\\ea78";
}

.icon-fontello-cc-pd:before {
  content: "\\ea79";
}

.icon-fontello-cc-zero:before {
  content: "\\ea7a";
}

.icon-fontello-cc-share:before {
  content: "\\ea7b";
}

.icon-fontello-cc-remix:before {
  content: "\\ea7c";
}

.icon-fontello-github-1:before {
  content: "\\ea7d";
}

.icon-fontello-github-circled:before {
  content: "\\ea7e";
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
